// Reviewed interface translations. Values entered by users are not part of this catalog.
export default {
  "Review selected timesheets": {"es": "Revisar las hojas de horas seleccionadas", "ko": "선택한 근무 기록 검토"},
  "{0} timesheets · {1} total hours": {"es": "{0} hojas de horas · {1} horas en total", "ko": "근무 기록 {0}건 · 총 {1}시간"},
  "Check every employee, service date, time and total below. Approval does not issue payment.": {"es": "Comprueba cada trabajador, fecha de servicio, horario y total que aparece a continuación. La aprobación no realiza ningún pago.", "ko": "아래의 직원, 근무 날짜, 출퇴근 시각, 총 근무 시간을 모두 확인하세요. 승인만으로 지급되지는 않습니다."},
  "Shifts longer than 12 hours need individual review. The existing 50-hour weekly limit applies across clients.": {"es": "Los turnos de más de 12 horas requieren una revisión individual. El límite existente de 50 horas semanales se aplica al trabajo para todos los clientes.", "ko": "12시간을 넘는 근무는 개별 검토가 필요합니다. 기존 주 50시간 한도는 여러 Client의 근무 시간을 합산하여 적용합니다."},
  "Checking the selected timesheets...": {"es": "Comprobando las hojas de horas seleccionadas...", "ko": "선택한 근무 기록을 검사하는 중..."},
  "Some records need correction or individual review. Nothing will be approved until all selected records pass.": {"es": "Algunos registros requieren una corrección o revisión individual. No se aprobará ningún registro hasta que todos los seleccionados superen las comprobaciones.", "ko": "수정하거나 개별 검토해야 하는 기록이 있습니다. 선택한 모든 기록이 검사를 통과해야 일괄 승인할 수 있습니다."},
  "Remove flagged records from this selection": {"es": "Quitar de la selección los registros marcados", "ko": "문제가 표시된 기록을 선택에서 제외"},
  "I have reviewed all selected timesheets and confirm these services and hours are correct.": {"es": "He revisado todas las hojas de horas seleccionadas y confirmo que estos servicios y horarios son correctos.", "ko": "선택한 모든 근무 기록을 검토했으며, 기재된 서비스와 근무 시간이 정확함을 확인합니다."},
  "Approve all selected timesheets": {"es": "Aprobar todas las hojas de horas seleccionadas", "ko": "선택한 근무 기록 모두 승인"},
  "Processing...": {"es": "Procesando...", "ko": "처리 중..."},
  "Refresh and review again": {"es": "Actualizar y revisar de nuevo", "ko": "새로고침 후 다시 검토"},
  "Select pending timesheets in these filters": {"es": "Seleccionar los registros pendientes que coincidan con estos filtros", "ko": "현재 필터의 승인 대기 기록 선택"},
  "{0} selected": {"es": "{0} seleccionados", "ko": "{0}건 선택됨"},
  "Review selected": {"es": "Revisar selección", "ko": "선택한 기록 검토"},
  "Clear selection": {"es": "Borrar selección", "ko": "선택 해제"},
  "Up to 200 timesheets per batch. Only records shown by your filters are selected.": {"es": "Hasta 200 hojas de horas por lote. Solo se seleccionan los registros que coinciden con los filtros.", "ko": "한 번에 최대 200건을 처리합니다. 현재 필터에 해당하는 기록만 선택됩니다."},
  "Select timesheet {0}": {"es": "Seleccionar la hoja de horas {0}", "ko": "근무 기록 {0} 선택"},
  "Could not prepare this review. Refresh and try again.": {"es": "No se pudo preparar esta revisión. Actualiza la página y vuelve a intentarlo.", "ko": "검토 목록을 준비하지 못했습니다. 새로고침 후 다시 시도해 주세요."},
  "{0} timesheets approved": {"es": "{0} hojas de horas aprobadas", "ko": "근무 기록 {0}건이 승인되었습니다"},
  "Could not confirm batch approval. Refresh to check the result, or retry this same review safely.": {"es": "No se pudo confirmar la aprobación del lote. Actualiza para comprobar el resultado o vuelve a enviar esta misma revisión de forma segura.", "ko": "일괄 승인 결과를 확인하지 못했습니다. 새로고침으로 결과를 확인하거나 같은 검토 요청을 다시 시도해 주세요."},
  "The selection could not be approved. Nothing was changed. Refresh and review again.": {"es": "No se pudo aprobar la selección. No se modificó ningún registro. Actualiza y vuelve a revisar.", "ko": "선택한 기록을 승인하지 못했습니다. 변경된 기록은 없습니다. 새로고침 후 다시 검토해 주세요."},
  "This review is invalid or expired. Review the selection again.": {"es": "Esta revisión no es válida o ha caducado. Vuelve a revisar la selección.", "ko": "검토 정보가 유효하지 않거나 만료되었습니다. 선택한 기록을 다시 검토해 주세요."},
  "This review belongs to another client.": {"es": "Esta revisión pertenece a otro cliente.", "ko": "다른 Client의 검토 정보입니다."},
  "Invalid timesheet selection.": {"es": "La selección de hojas de horas no es válida.", "ko": "선택한 근무 기록이 유효하지 않습니다."},
  "One or more selected timesheets are unavailable. Refresh the list.": {"es": "Uno o varios registros seleccionados ya no están disponibles. Actualiza la lista.", "ko": "선택한 근무 기록 중 일부를 사용할 수 없습니다. 목록을 새로고침해 주세요."},
  "A selected worker is no longer available.": {"es": "Uno de los trabajadores seleccionados ya no está disponible.", "ko": "선택한 기록의 직원을 찾을 수 없습니다."},
  "The selection changed. Refresh the list.": {"es": "La selección ha cambiado. Actualiza la lista.", "ko": "선택한 기록이 변경되었습니다. 목록을 새로고침해 주세요."},
  "Only pending, unpaid timesheets can be approved in a batch.": {"es": "Solo se pueden aprobar en lote las hojas de horas pendientes y no pagadas.", "ko": "승인 대기 중인 미지급 근무 기록만 일괄 승인할 수 있습니다."},
  "A correction request is awaiting review.": {"es": "Hay una solicitud de corrección pendiente de revisión.", "ko": "수정 요청이 검토 대기 중입니다."},
  "Complete and correct the dates, times, hours and service code before batch approval.": {"es": "Completa y corrige las fechas, los horarios, las horas y el código de servicio antes de la aprobación en lote.", "ko": "일괄 승인 전에 날짜, 출퇴근 시각, 근무 시간, 서비스 코드를 정확히 입력해야 합니다."},
  "Saved hours do not match the start and end times. Ask for a correction.": {"es": "Las horas guardadas no coinciden con los horarios de inicio y fin. Solicita una corrección.", "ko": "저장된 근무 시간이 출퇴근 시각과 일치하지 않습니다. 수정을 요청해 주세요."},
  "This long shift requires individual review before approval.": {"es": "Este turno prolongado requiere una revisión individual antes de su aprobación.", "ko": "이 장시간 근무 기록은 승인 전에 개별 검토가 필요합니다."},
  "The saved dates or times are invalid. Ask for a correction.": {"es": "Las fechas o los horarios guardados no son válidos. Solicita una corrección.", "ko": "저장된 날짜나 시각이 유효하지 않습니다. 수정을 요청해 주세요."},
  "This timesheet exceeds the 50-hour weekly limit. Review all work recorded for this employee.": {"es": "Esta hoja de horas supera el límite de 50 horas semanales. Revisa todos los registros de este trabajador.", "ko": "이 근무 기록은 주 50시간 한도를 초과합니다. 해당 직원의 전체 근무 기록을 확인해 주세요."},
  "This period overlaps an existing shift. Check Time before submitting again.": {"es": "Este período se solapa con un turno existente. Revisa los registros de horas antes de volver a enviarlo.", "ko": "기존 근무 기록과 시간이 겹칩니다. 근무 기록을 확인해 주세요."},
  "Only completed work can be entered. The end date/time cannot be in the future.": {"es": "Solo se puede registrar trabajo ya realizado. La fecha y hora de finalización no pueden estar en el futuro.", "ko": "완료된 근무만 처리할 수 있습니다. 퇴근 일시는 미래일 수 없습니다."},
  "End date/time must be after the start. Select the following day for an overnight shift.": {"es": "La fecha y hora de finalización deben ser posteriores al inicio. Si el turno cruza la medianoche, selecciona el día siguiente.", "ko": "퇴근 일시는 출근 일시보다 뒤여야 합니다. 자정을 넘기는 근무는 다음 날을 선택하세요."},
  "This local date/time does not exist in the service timezone. Check the daylight saving time change.": {"es": "Esta fecha y hora local no existe en la zona horaria del servicio. Comprueba el cambio de horario de verano.", "ko": "서비스 시간대에 존재하지 않는 시각입니다. 서머타임 변경을 확인해 주세요."},

  "Review completed timesheets below. Approval does not issue payment.": {"es": "Revisa las hojas de horas completadas a continuación. La aprobación no realiza ningún pago.", "ko": "아래에서 완료된 근무 기록을 검토하세요. 승인만으로 지급되지는 않습니다."},
  "Approve timesheet?": {"es": "¿Aprobar esta hoja de horas?", "ko": "이 근무 기록을 승인할까요?"},
  "Decline timesheet?": {"es": "¿Rechazar esta hoja de horas?", "ko": "이 근무 기록을 거절할까요?"},
  "Clock out before review": {"es": "Registra la salida antes de la revisión", "ko": "퇴근 기록 후 검토 가능"},
  "Reviewed": {"es": "Revisada", "ko": "검토 완료"},
  "Loading timesheets...": {"es": "Cargando las hojas de horas...", "ko": "근무 기록을 불러오는 중..."},
  "No timesheets match these filters.": {"es": "No hay hojas de horas que coincidan con estos filtros.", "ko": "선택한 조건에 해당하는 근무 기록이 없습니다."},
  "Could not load timesheets. Please refresh.": {"es": "No se pudieron cargar las hojas de horas. Actualiza la página.", "ko": "근무 기록을 불러오지 못했습니다. 새로고침해 주세요."},
  "Your account changed. Refresh this page.": {"es": "Tu cuenta ha cambiado. Actualiza esta página.", "ko": "로그인 계정이 변경되었습니다. 페이지를 새로고침해 주세요."},
  "Could not review this timesheet. Please retry.": {"es": "No se pudo revisar esta hoja de horas. Vuelve a intentarlo.", "ko": "근무 기록을 처리하지 못했습니다. 다시 시도해 주세요."},
  "Timesheet approved": {"es": "Hoja de horas aprobada", "ko": "근무 기록이 승인되었습니다"},
  "Timesheet declined": {"es": "Hoja de horas rechazada", "ko": "근무 기록이 거절되었습니다"},
  "Review failed": {"es": "No se pudo completar la revisión", "ko": "검토 처리 실패"},
  "This timesheet changed. Refresh before reviewing it again.": {"es": "Esta hoja de horas ha cambiado. Actualiza la página antes de revisarla de nuevo.", "ko": "근무 기록이 변경되었습니다. 새로고침 후 다시 검토해 주세요."},
  "This timesheet has already been reviewed. Refresh the list.": {"es": "Esta hoja de horas ya se ha revisado. Actualiza la lista.", "ko": "이미 검토된 근무 기록입니다. 목록을 새로고침해 주세요."},
  "Paid timesheets cannot be reviewed.": {"es": "No se pueden revisar las hojas de horas ya pagadas.", "ko": "지급 완료된 근무 기록은 검토 상태를 변경할 수 없습니다."},
  "Clock out before reviewing this timesheet.": {"es": "Registra la salida antes de revisar esta hoja de horas.", "ko": "퇴근 기록이 완료된 후 검토할 수 있습니다."},

  "Language": {
    "es": "Idioma",
    "ko": "언어"
  },
  "Portal language": {
    "es": "Idioma del portal",
    "ko": "포털 언어"
  },
  "English is the default. Your selection is saved in this browser and applies immediately.": {
    "es": "El idioma predeterminado es inglés. Su selección se guarda en este navegador y se aplica de inmediato.",
    "ko": "기본 언어는 영어입니다. 선택한 언어는 이 브라우저에 저장되며 즉시 적용됩니다."
  },
  "Names, service codes, uploaded files and information you enter stay in their original language.": {
    "es": "Los nombres, los códigos de servicio, los archivos subidos y la información que introduzca se conservan en su idioma original.",
    "ko": "이름, 서비스 코드, 업로드한 파일 및 직접 입력한 정보는 원래 언어로 유지됩니다."
  },
  "In Spanish or Korean, hover over an underlined term to see its English name. On a phone, tap the underlined term.": {
    "es": "En español o coreano, coloque el cursor sobre un término subrayado para ver su nombre en inglés. En un teléfono, toque el término subrayado.",
    "ko": "한국어나 스페인어에서는 밑줄 친 용어에 마우스를 올리면 영어 원문이 표시됩니다. 휴대폰에서는 밑줄 친 용어를 눌러 보세요."
  },
  "Language updated.": {
    "es": "Idioma actualizado.",
    "ko": "언어가 변경되었습니다."
  },
  "OK": {
    "es": "Aceptar",
    "ko": "확인"
  },
  "Success": {
    "es": "Operación completada",
    "ko": "완료"
  },
  "Error": {
    "es": "Error",
    "ko": "오류"
  },
  "Warning": {
    "es": "Aviso",
    "ko": "주의"
  },
  "Reason": {
    "es": "Motivo",
    "ko": "사유"
  },
  "Existing session": {
    "es": "Sesión existente",
    "ko": "기존 세션"
  },
  "mobile": {
    "es": "móvil",
    "ko": "휴대전화"
  },
  "desktop": {
    "es": "equipo de escritorio",
    "ko": "데스크톱"
  },
  "PC": {
    "es": "PC",
    "ko": "PC"
  },
  "tablet": {
    "es": "tableta",
    "ko": "태블릿"
  },
  "browser": {
    "es": "navegador",
    "ko": "브라우저"
  },
  "session": {
    "es": "sesión",
    "ko": "세션"
  },
  "device": {
    "es": "dispositivo",
    "ko": "기기"
  },
  "completed": {
    "es": "completado",
    "ko": "완료"
  },
  "incomplete": {
    "es": "incompleto",
    "ko": "미완료"
  },
  "required": {
    "es": "obligatorio",
    "ko": "필수"
  },
  "optional": {
    "es": "opcional",
    "ko": "선택 사항"
  },
  "cancelled": {
    "es": "cancelado",
    "ko": "취소됨"
  },
  "withdrawn": {
    "es": "retirado",
    "ko": "철회됨"
  },
  "paid": {
    "es": "pagado",
    "ko": "지급 완료"
  },
  "unpaid": {
    "es": "sin pagar",
    "ko": "미지급"
  },
  "not started": {
    "es": "sin iniciar",
    "ko": "시작 전"
  },
  "update": {
    "es": "modificación",
    "ko": "수정"
  },
  "delete": {
    "es": "eliminación",
    "ko": "삭제"
  },
  "reverted": {
    "es": "revertido",
    "ko": "되돌림"
  },
  "Unknown": {
    "es": "Desconocido",
    "ko": "알 수 없음"
  },
  "United States": {
    "es": "United States",
    "ko": "United States"
  },
  "Personal Assistance": {
    "es": "Asistencia personal",
    "ko": "개인 지원"
  },
  "Respite (Individual and Agency) In-home": {
    "es": "Respiro (individual y de agencia) en el hogar",
    "ko": "가정 내 휴식 지원 (개인 및 기관)"
  },
  "Respite (Individual and Agency) In- home": {
    "es": "Respiro (individual y de agencia) en el hogar",
    "ko": "가정 내 휴식 지원 (개인 및 기관)"
  },
  "Community Living Supports (Individual and Agency)": {
    "es": "Apoyos para la vida comunitaria (individuales y de agencia)",
    "ko": "지역사회 생활 지원 (개인 및 기관)"
  },
  "Participant-Directed Goods and Services": {
    "es": "Bienes y servicios dirigidos por el participante",
    "ko": "참여자 주도 물품 및 서비스"
  },
  "Family/Consumer Training": {
    "es": "Formación para familiares y consumidores",
    "ko": "가족 / 이용자 교육"
  },
  "January": {
    "es": "Enero",
    "ko": "1월"
  },
  "February": {
    "es": "Febrero",
    "ko": "2월"
  },
  "March": {
    "es": "Marzo",
    "ko": "3월"
  },
  "April": {
    "es": "Abril",
    "ko": "4월"
  },
  "May": {
    "es": "Mayo",
    "ko": "5월"
  },
  "June": {
    "es": "Junio",
    "ko": "6월"
  },
  "July": {
    "es": "Julio",
    "ko": "7월"
  },
  "August": {
    "es": "Agosto",
    "ko": "8월"
  },
  "September": {
    "es": "Septiembre",
    "ko": "9월"
  },
  "October": {
    "es": "Octubre",
    "ko": "10월"
  },
  "November": {
    "es": "Noviembre",
    "ko": "11월"
  },
  "December": {
    "es": "Diciembre",
    "ko": "12월"
  },
  "Clock in": {
    "es": "Registrar entrada",
    "ko": "출근 기록"
  },
  "Clock out": {
    "es": "Registrar salida",
    "ko": "퇴근 기록"
  },
  "Oops...": {
    "es": "Ha ocurrido un problema...",
    "ko": "문제가 발생했습니다..."
  },
  "Invalid Password": {
    "es": "Contraseña no válida",
    "ko": "올바르지 않은 비밀번호"
  },
  "Please complete: {0}": {
    "es": "Complete los siguientes campos: {0}",
    "ko": "다음 항목을 입력해 주세요: {0}"
  },
  "The {0} field is required.": {
    "es": "El campo «{0}» es obligatorio.",
    "ko": "{0} 항목을 입력해 주세요."
  },
  "The {0} must be a valid email address.": {
    "es": "El campo «{0}» debe contener un correo electrónico válido.",
    "ko": "{0} 항목에 올바른 이메일 주소를 입력해 주세요."
  },
  "The {0} must be a number.": {
    "es": "El campo «{0}» debe ser un número.",
    "ko": "{0} 항목에는 숫자를 입력해 주세요."
  },
  "The {0} must be at least {1} characters.": {
    "es": "El campo «{0}» debe tener al menos {1} caracteres.",
    "ko": "{0} 항목은 {1}자 이상이어야 합니다."
  },
  "The {0} must not be greater than {1} characters.": {
    "es": "El campo «{0}» no debe superar los {1} caracteres.",
    "ko": "{0} 항목은 {1}자를 초과할 수 없습니다."
  },
  "The {0} must not be greater than {1} kilobytes.": {
    "es": "El archivo de «{0}» no debe superar los {1} KB.",
    "ko": "{0} 파일은 {1}KB를 초과할 수 없습니다."
  },
  "The {0} confirmation does not match.": {
    "es": "La confirmación del campo «{0}» no coincide.",
    "ko": "{0} 확인값이 일치하지 않습니다."
  },
  "Please fill in all required fields": {
    "es": "Complete todos los campos obligatorios.",
    "ko": "모든 필수 항목을 입력해 주세요."
  },
  "Choose English, Spanish or Korean in Settings to change the portal language. Names, service codes and entered information stay unchanged.": {
    "es": "Elija inglés, español o coreano en Configuración para cambiar el idioma del portal. Los nombres, los códigos de servicio y los datos introducidos no cambian.",
    "ko": "설정에서 영어, 스페인어 또는 한국어를 선택하여 포털 언어를 변경할 수 있습니다. 이름, 서비스 코드 및 입력한 정보는 그대로 유지됩니다."
  },
  "Error: {0}": {
    "es": "Error: {0}",
    "ko": "오류: {0}"
  },
  "Error updating payment info: {0}": {
    "es": "Error al actualizar los datos de pago: {0}",
    "ko": "지급 정보 수정 오류: {0}"
  },
  "SS Number": {
    "es": "Número de Seguro Social",
    "ko": "사회보장번호"
  },
  "Street": {
    "es": "Dirección de la calle",
    "ko": "도로명 주소"
  },
  "Zip": {
    "es": "Código postal",
    "ko": "우편번호"
  },
  "Citizenship": {
    "es": "Ciudadanía",
    "ko": "시민권 또는 체류 신분"
  },
  "Citizenship Uscis Or A Number": {
    "es": "USCIS o A-Number",
    "ko": "USCIS 또는 A-Number"
  },
  "Citizenship Id Expiry Date": {
    "es": "Vencimiento de la autorización",
    "ko": "체류 신분 증빙 만료일"
  },
  "service_date": {
    "es": "Fecha del servicio",
    "ko": "서비스 제공일"
  },
  "invoice_file": {
    "es": "Documento de factura",
    "ko": "청구서 서류"
  },
  "description": {
    "es": "Descripción",
    "ko": "설명"
  },
  "Employees": {
    "es": "Empleados",
    "ko": "직원"
  },
  "Vendor": {
    "es": "Proveedor",
    "ko": "공급업체"
  },
  "Vendors": {
    "es": "Proveedores",
    "ko": "공급업체"
  },
  "Coordinator": {
    "es": "Coordinador",
    "ko": "코디네이터"
  },
  "Started": {
    "es": "Iniciado",
    "ko": "시작됨"
  },
  "Terminated": {
    "es": "Finalizado",
    "ko": "종료됨"
  },
  "Processing": {
    "es": "En proceso",
    "ko": "처리 중"
  },
  "Denied": {
    "es": "Denegado",
    "ko": "거절됨"
  },
  "Revert": {
    "es": "Revertir",
    "ko": "되돌리기"
  },
  "Proceed": {
    "es": "Continuar",
    "ko": "계속"
  },
  "Specification": {
    "es": "Especificación",
    "ko": "세부 내용"
  },
  "Signatures": {
    "es": "Firmas",
    "ko": "서명"
  },
  "Saved": {
    "es": "Guardado",
    "ko": "저장됨"
  },
  "Uploaded": {
    "es": "Subido",
    "ko": "업로드 완료"
  },
  "Welcome": {
    "es": "Le damos la bienvenida",
    "ko": "오신 것을"
  },
  "Here": {
    "es": "aquí",
    "ko": "환영합니다"
  },
  "Log-out": {
    "es": "Cerrar sesión",
    "ko": "로그아웃"
  },
  "Month": {
    "es": "Mes",
    "ko": "월"
  },
  "Value": {
    "es": "Valor",
    "ko": "값"
  },
  "Anonymous": {
    "es": "Anónimo",
    "ko": "익명"
  },
  "Authentication token is required.": {
    "es": "Se requiere un token de autenticación.",
    "ko": "인증 토큰이 필요합니다."
  },
  "Invalid authentication token.": {
    "es": "Token de autenticación no válido.",
    "ko": "인증 토큰이 유효하지 않습니다."
  },
  "Invalid or expired authentication token.": {
    "es": "Token de autenticación no válido o caducado.",
    "ko": "인증 토큰이 유효하지 않거나 만료되었습니다."
  },
  "This employee account is not active.": {
    "es": "Esta cuenta de empleado no está activa.",
    "ko": "이 직원 계정은 활성화되지 않았습니다."
  },
  "Authentication tokens do not match.": {
    "es": "Los tokens de autenticación no coinciden.",
    "ko": "인증 토큰이 일치하지 않습니다."
  },
  "English is the default. Your language is saved to your account and follows you on any device. Other accounts keep their own language.": {
    "es": "El idioma predeterminado es inglés. Su idioma se guarda en su cuenta y se aplica en cualquier dispositivo. Las demás cuentas mantienen su propio idioma.",
    "ko": "기본 언어는 영어입니다. 선택한 언어는 계정에 저장되어 어느 기기에서든 적용됩니다. 다른 계정의 언어 설정은 바뀌지 않습니다."
  },
  "Loading account language...": {
    "es": "Cargando el idioma de la cuenta...",
    "ko": "계정 언어를 불러오는 중입니다..."
  },
  "Saving language...": {
    "es": "Guardando el idioma...",
    "ko": "언어를 저장하는 중입니다..."
  },
  "Could not load your account language. Please retry.": {
    "es": "No se pudo cargar el idioma de su cuenta. Vuelva a intentarlo.",
    "ko": "계정 언어를 불러오지 못했습니다. 다시 시도해 주세요."
  },
  "Could not save your account language. Your previous setting is unchanged.": {
    "es": "No se pudo guardar el idioma de su cuenta. Se mantiene la configuración anterior.",
    "ko": "계정 언어를 저장하지 못했습니다. 이전 설정이 유지됩니다."
  },
  "Select {0} only if you’re unmarried and pay more than half the costs of keeping up a home for yourself and a qualifying individual.": {
    "es": "Seleccione {0} solo si no está casado/a y paga más de la mitad de los gastos de mantenimiento de un hogar para usted y una persona que cumpla los requisitos.",
    "ko": "미혼이며 본인과 자격 요건에 해당하는 사람의 가정을 유지하는 데 드는 비용의 절반을 초과하여 부담하는 경우에만 {0}를 선택하세요."
  },
  "This {0} (this \"Agreement\") is entered into by and between {1}, a Financial Management Service company (\"Blessed FMS Inc.\") and any person who consents to this Agreement and the entity that such person represents (together, \"User\"). Each of Blessed FMS Inc. and User are referred to as a \"Party\" and are collectively referred to as the \"Parties.\"": {
    "es": "Este {0} (el «Acuerdo») se celebra entre {1}, una empresa de gestión financiera («Blessed FMS Inc.»), y toda persona que acepte este Acuerdo y la entidad que represente (conjuntamente, el «Usuario»). Blessed FMS Inc. y el Usuario se denominan individualmente «Parte» y conjuntamente «Partes».",
    "ko": "본 {0}(이하 ‘약관’)은 재무관리 서비스 회사인 {1}(이하 ‘Blessed FMS Inc.’)와 본 약관에 동의하는 개인 및 해당 개인이 대리하는 단체(통칭하여 ‘사용자’) 간에 체결됩니다. Blessed FMS Inc.와 사용자는 각각 ‘당사자’, 함께 ‘양 당사자’라고 합니다."
  },
  "Performance": {
    "es": "Rendimiento",
    "ko": "성과"
  },
  "Total orders": {
    "es": "Pedidos totales",
    "ko": "총 주문 수"
  },
  "Overview": {
    "es": "Resumen",
    "ko": "개요"
  },
  "Sales value": {
    "es": "Valor de ventas",
    "ko": "매출액"
  },
  "Page visits": {
    "es": "Visitas a la página",
    "ko": "페이지 방문 수"
  },
  "See all": {
    "es": "Ver todo",
    "ko": "모두 보기"
  },
  "Page name": {
    "es": "Nombre de la página",
    "ko": "페이지 이름"
  },
  "Visitors": {
    "es": "Visitantes",
    "ko": "방문자 수"
  },
  "Unique users": {
    "es": "Usuarios únicos",
    "ko": "고유 사용자 수"
  },
  "Bounce rate": {
    "es": "Porcentaje de rebote",
    "ko": "이탈률"
  },
  "/argon/": {
    "es": "/argon/",
    "ko": "/argon/"
  },
  "/argon/index.html": {
    "es": "/argon/index.html",
    "ko": "/argon/index.html"
  },
  "/argon/charts.html": {
    "es": "/argon/charts.html",
    "ko": "/argon/charts.html"
  },
  "/argon/tables.html": {
    "es": "/argon/tables.html",
    "ko": "/argon/tables.html"
  },
  "/argon/profile.html": {
    "es": "/argon/profile.html",
    "ko": "/argon/profile.html"
  },
  "Social traffic": {
    "es": "Tráfico de redes sociales",
    "ko": "소셜 미디어 유입"
  },
  "Referral": {
    "es": "Origen de referencia",
    "ko": "유입 경로"
  },
  "Facebook": {
    "es": "Facebook",
    "ko": "Facebook"
  },
  "Google": {
    "es": "Google",
    "ko": "Google"
  },
  "Instagram": {
    "es": "Instagram",
    "ko": "Instagram"
  },
  "twitter": {
    "es": "twitter",
    "ko": "twitter"
  },
  "Employee List": {
    "es": "Lista de empleados",
    "ko": "직원 목록"
  },
  "Add employees": {
    "es": "Añadir empleados",
    "ko": "직원 추가"
  },
  "Full Name": {
    "es": "Nombre completo",
    "ko": "성명"
  },
  "Employee ID": {
    "es": "ID de empleado",
    "ko": "직원 ID"
  },
  "Documents": {
    "es": "Documentos",
    "ko": "서류"
  },
  "Action": {
    "es": "Acción",
    "ko": "작업"
  },
  "Another action": {
    "es": "Otra acción",
    "ko": "다른 작업"
  },
  "Something else here": {
    "es": "Otra opción",
    "ko": "기타 옵션"
  },
  "Seprated link": {
    "es": "Enlace separado",
    "ko": "별도 링크"
  },
  "Demo Pages": {
    "es": "Páginas de demostración",
    "ko": "데모 페이지"
  },
  "Admin Layout": {
    "es": "Diseño de administración",
    "ko": "관리자 화면 구성"
  },
  "Dashboard": {
    "es": "Panel de inicio",
    "ko": "대시보드"
  },
  "Settings": {
    "es": "Configuración",
    "ko": "설정"
  },
  "Tables": {
    "es": "Tablas",
    "ko": "표"
  },
  "Maps": {
    "es": "Mapas",
    "ko": "지도"
  },
  "Auth Layout": {
    "es": "Diseño de autenticación",
    "ko": "인증 화면 구성"
  },
  "Login": {
    "es": "Iniciar sesión",
    "ko": "로그인"
  },
  "Register": {
    "es": "Registrarse",
    "ko": "회원 가입"
  },
  "No Layout": {
    "es": "Sin diseño",
    "ko": "기본 구성 없음"
  },
  "Landing": {
    "es": "Página de presentación",
    "ko": "소개 페이지"
  },
  "Profile": {
    "es": "Perfil",
    "ko": "프로필"
  },
  "logout": {
    "es": "cerrar sesión",
    "ko": "로그아웃"
  },
  "Let's keep in touch!": {
    "es": "¡Sigamos en contacto!",
    "ko": "계속 소식을 나눠요!"
  },
  "Find us on any of these platforms, we respond 1-2 business days.": {
    "es": "Encuéntrenos en cualquiera de estas plataformas. Respondemos en 1 o 2 días hábiles.",
    "ko": "아래 플랫폼에서 연락하실 수 있습니다. 영업일 기준 1~2일 이내에 답변드립니다."
  },
  "Useful Links": {
    "es": "Enlaces útiles",
    "ko": "유용한 링크"
  },
  "About Us": {
    "es": "Quiénes somos",
    "ko": "회사 소개"
  },
  "Blog": {
    "es": "Blog",
    "ko": "블로그"
  },
  "Github": {
    "es": "Github",
    "ko": "Github"
  },
  "Free Products": {
    "es": "Productos gratuitos",
    "ko": "무료 제품"
  },
  "Other Resources": {
    "es": "Otros recursos",
    "ko": "기타 자료"
  },
  "MIT License": {
    "es": "Licencia MIT",
    "ko": "MIT 라이선스"
  },
  "Terms & Conditions": {
    "es": "Términos y condiciones",
    "ko": "이용약관"
  },
  "Privacy Policy": {
    "es": "Política de privacidad",
    "ko": "개인정보 처리방침"
  },
  "Contact Us": {
    "es": "Contáctenos",
    "ko": "문의하기"
  },
  "Copyright © {0} Vue Notus by": {
    "es": "Copyright © {0} Vue Notus de",
    "ko": "Copyright © {0} Vue Notus 제작:"
  },
  "Creative Tim": {
    "es": "Creative Tim",
    "ko": "Creative Tim"
  },
  "Copyright © {0}": {
    "es": "Copyright © {0}",
    "ko": "Copyright © {0}"
  },
  "CLIENT PORTAL GUIDE": {
    "es": "GUÍA DEL PORTAL DEL CLIENTE",
    "ko": "클라이언트 포털 이용 안내"
  },
  "Skip": {
    "es": "Omitir",
    "ko": "건너뛰기"
  },
  "Retry": {
    "es": "Reintentar",
    "ko": "다시 시도"
  },
  "Dismiss guide notice": {
    "es": "Cerrar el aviso de la guía",
    "ko": "이용 안내 알림 닫기"
  },
  "Total Budget": {
    "es": "Presupuesto total",
    "ko": "총예산"
  },
  "Available Budget": {
    "es": "Presupuesto disponible",
    "ko": "사용 가능한 예산"
  },
  "Living Arrangements (310~330)": {
    "es": "Apoyo para la vida diaria (310~330)",
    "ko": "일상생활 지원 (310~330)"
  },
  "Employment & Community Participation (331~355)": {
    "es": "Empleo y participación comunitaria (331~355)",
    "ko": "고용 및 지역사회 참여 (331~355)"
  },
  "Health & Safety (356~399)": {
    "es": "Salud y seguridad (356~399)",
    "ko": "건강 및 안전 (356~399)"
  },
  "Description": {
    "es": "Descripción",
    "ko": "설명"
  },
  "description is required": {
    "es": "La descripción es obligatoria.",
    "ko": "설명을 입력해 주세요."
  },
  "Upload Documents": {
    "es": "Subir documentos",
    "ko": "서류 업로드"
  },
  "PLease upload a file": {
    "es": "Suba un archivo.",
    "ko": "파일을 업로드해 주세요."
  },
  "Last Name": {
    "es": "Apellidos",
    "ko": "성"
  },
  "Submit": {
    "es": "Enviar",
    "ko": "제출"
  },
  "Item Description (Description of the item to buy)": {
    "es": "Descripción del artículo que desea comprar",
    "ko": "구매할 물품 설명"
  },
  "Enter item description": {
    "es": "Introduzca la descripción del artículo.",
    "ko": "물품 설명을 입력해 주세요."
  },
  "Item Link (website where the item can be purchased)": {
    "es": "Enlace al sitio web donde se puede comprar el artículo",
    "ko": "물품을 구매할 수 있는 웹사이트 링크"
  },
  "Enter item link": {
    "es": "Introduzca el enlace del artículo.",
    "ko": "물품 링크를 입력해 주세요."
  },
  "Price (Item price from the website link)": {
    "es": "Precio del artículo en el sitio web",
    "ko": "웹사이트에 표시된 물품 가격"
  },
  "Select a service code": {
    "es": "Seleccione un código de servicio.",
    "ko": "서비스 코드를 선택해 주세요."
  },
  "Shipping Address": {
    "es": "Dirección de envío",
    "ko": "배송 주소"
  },
  "Enter alternate shipping address": {
    "es": "Introduzca otra dirección de envío.",
    "ko": "다른 배송 주소를 입력해 주세요."
  },
  "Different from current address": {
    "es": "Diferente de la dirección actual",
    "ko": "현재 주소와 다름"
  },
  "Cancel": {
    "es": "Cancelar",
    "ko": "취소"
  },
  "Employee's First Name": {
    "es": "Nombre del empleado",
    "ko": "직원 이름"
  },
  "First Name": {
    "es": "Nombre",
    "ko": "이름"
  },
  "First Name is required": {
    "es": "El nombre es obligatorio.",
    "ko": "이름을 입력해 주세요."
  },
  "Employee's Last Name": {
    "es": "Apellidos del empleado",
    "ko": "직원 성"
  },
  "Last Name is required": {
    "es": "Los apellidos son obligatorios.",
    "ko": "성을 입력해 주세요."
  },
  "Employee's Email": {
    "es": "Correo electrónico del empleado",
    "ko": "직원 이메일"
  },
  "Email Address": {
    "es": "Dirección de correo electrónico",
    "ko": "이메일 주소"
  },
  "Email is required": {
    "es": "El correo electrónico es obligatorio.",
    "ko": "이메일을 입력해 주세요."
  },
  "Employee's Phone Number": {
    "es": "Número de teléfono del empleado",
    "ko": "직원 전화번호"
  },
  "Phone Number": {
    "es": "Número de teléfono",
    "ko": "전화번호"
  },
  "Phone Number is required": {
    "es": "El número de teléfono es obligatorio.",
    "ko": "전화번호를 입력해 주세요."
  },
  "Add Employee": {
    "es": "Añadir empleado",
    "ko": "직원 추가"
  },
  "Employee Name": {
    "es": "Nombre del empleado",
    "ko": "직원 성명"
  },
  "Enter employee full name": {
    "es": "Introduzca el nombre completo del empleado.",
    "ko": "직원의 성명을 입력해 주세요."
  },
  "Position": {
    "es": "Puesto",
    "ko": "직책"
  },
  "background Check file": {
    "es": "Archivo de verificación de antecedentes",
    "ko": "신원 조회 서류"
  },
  "Hired Date": {
    "es": "Fecha de contratación",
    "ko": "채용일"
  },
  "Close": {
    "es": "Cerrar",
    "ko": "닫기"
  },
  "Enter the email address the vendor used to register with Blessed FMS. The system will securely locate and connect that vendor to your account.": {
    "es": "Introduzca el correo electrónico que el proveedor utilizó para registrarse en Blessed FMS. El sistema localizará al proveedor de forma segura y lo vinculará a su cuenta.",
    "ko": "공급업체가 Blessed FMS에 가입할 때 사용한 이메일 주소를 입력해 주세요. 시스템이 해당 공급업체를 안전하게 확인하여 회원님의 계정에 연결합니다."
  },
  "Vendor Email Address": {
    "es": "Correo electrónico del proveedor",
    "ko": "공급업체 이메일 주소"
  },
  "vendor@example.com": {
    "es": "vendor@example.com",
    "ko": "vendor@example.com"
  },
  "Hire Date": {
    "es": "Fecha de contratación",
    "ko": "채용일"
  },
  "Add Vendor": {
    "es": "Añadir proveedor",
    "ko": "공급업체 추가"
  },
  "OTP CODE": {
    "es": "CÓDIGO DE VERIFICACIÓN",
    "ko": "인증 코드"
  },
  "We have sent to your email the Authentication Code.": {
    "es": "Hemos enviado el código de autenticación a su correo electrónico.",
    "ko": "이메일로 인증 코드를 보내드렸습니다."
  },
  "Please check your email for your OTP code.": {
    "es": "Revise su correo electrónico para consultar el código de verificación.",
    "ko": "이메일에서 인증 코드를 확인해 주세요."
  },
  "PLease enter a valid 6 digit OTP code": {
    "es": "Introduzca un código válido de 6 dígitos.",
    "ko": "올바른 6자리 인증 코드를 입력해 주세요."
  },
  "Invalid Code": {
    "es": "Código no válido",
    "ko": "유효하지 않은 코드"
  },
  "Employee's Details": {
    "es": "Datos del empleado",
    "ko": "직원 정보"
  },
  "Employee's Name:": {
    "es": "Nombre del empleado:",
    "ko": "직원 성명:"
  },
  "From": {
    "es": "Desde",
    "ko": "시작"
  },
  "To": {
    "es": "Hasta",
    "ko": "종료"
  },
  "View Timesheet": {
    "es": "Ver hoja de horas",
    "ko": "근무 시간표 보기"
  },
  "Date": {
    "es": "Fecha",
    "ko": "날짜"
  },
  "Time In": {
    "es": "Entrada",
    "ko": "출근"
  },
  "Time Out": {
    "es": "Salida",
    "ko": "퇴근"
  },
  "Total Hours": {
    "es": "Horas totales",
    "ko": "총 근무 시간"
  },
  "No data": {
    "es": "Sin datos",
    "ko": "데이터 없음"
  },
  "Open menu": {
    "es": "Abrir menú",
    "ko": "메뉴 열기"
  },
  "CLIENT": {
    "es": "CLIENTE",
    "ko": "클라이언트"
  },
  "Client ID: {0}": {
    "es": "ID de cliente: {0}",
    "ko": "클라이언트 ID: {0}"
  },
  "Vue Notus": {
    "es": "Vue Notus",
    "ko": "Vue Notus"
  },
  "Docs": {
    "es": "Documentación",
    "ko": "문서"
  },
  "Share": {
    "es": "Compartir",
    "ko": "공유"
  },
  "Tweet": {
    "es": "Publicar en Twitter",
    "ko": "Twitter에 게시"
  },
  "Star": {
    "es": "Marcar como favorito",
    "ko": "즐겨찾기"
  },
  "Download": {
    "es": "Descargar",
    "ko": "다운로드"
  },
  "Close menu": {
    "es": "Cerrar menú",
    "ko": "메뉴 닫기"
  },
  "{0} Pages": {
    "es": "Páginas de {0}",
    "ko": "{0} 페이지"
  },
  "Account Management": {
    "es": "Gestión de la cuenta",
    "ko": "계정 관리"
  },
  "Guide": {
    "es": "Guía",
    "ko": "이용 안내"
  },
  "Logout": {
    "es": "Cerrar sesión",
    "ko": "로그아웃"
  },
  "Your story starts with us.": {
    "es": "Su historia comienza con nosotros.",
    "ko": "여러분의 이야기가 여기서 시작됩니다."
  },
  "This is a simple example of a Landing Page you can build using Vue Notus. It features multiple CSS components based on the Tailwind CSS design system.": {
    "es": "Este es un ejemplo sencillo de una página de presentación que puede crear con Vue Notus. Incluye varios componentes CSS basados en el sistema de diseño Tailwind CSS.",
    "ko": "Vue Notus로 만들 수 있는 소개 페이지의 간단한 예시입니다. Tailwind CSS 디자인 시스템을 기반으로 한 여러 CSS 구성 요소가 포함되어 있습니다."
  },
  "Awarded Agency": {
    "es": "Agencia premiada",
    "ko": "수상 경력이 있는 에이전시"
  },
  "Divide details about your product or agency work into parts. A paragraph describing a feature will be enough.": {
    "es": "Divida los detalles de su producto o agencia en secciones. Bastará con un párrafo para describir cada característica.",
    "ko": "제품이나 회사의 특징을 항목별로 나누어 소개해 보세요. 각 특징을 한 문단으로 설명하면 됩니다."
  },
  "Free Revisions": {
    "es": "Revisiones gratuitas",
    "ko": "무료 수정"
  },
  "Keep you user engaged by providing meaningful information. Remember that by this time, the user is curious.": {
    "es": "Mantenga el interés del usuario con información útil. En esta etapa, el usuario siente curiosidad.",
    "ko": "유용한 정보를 제공하여 사용자의 관심을 이어가세요. 이 단계에서 사용자는 더 자세히 알고 싶어 합니다."
  },
  "Verified Company": {
    "es": "Empresa verificada",
    "ko": "검증된 회사"
  },
  "Write a few lines about each one. A paragraph describing a feature will be enough. Keep you user engaged!": {
    "es": "Escriba unas líneas sobre cada característica. Un párrafo será suficiente. ¡Mantenga el interés del usuario!",
    "ko": "각 특징을 간단히 소개해 주세요. 한 문단이면 충분합니다. 사용자의 관심을 이어가세요!"
  },
  "Working with us is a pleasure": {
    "es": "Trabajar con nosotros es un placer.",
    "ko": "저희와 함께 즐겁게 일해 보세요."
  },
  "Don't let your uses guess by attaching tooltips and popoves to any element. Just make sure you enable them first via JavaScript.": {
    "es": "Ayude a sus usuarios con información sobre herramientas y ventanas emergentes. Actívelas primero mediante JavaScript.",
    "ko": "도움말과 팝오버를 제공하여 사용자가 쉽게 이해할 수 있도록 도와주세요. 먼저 JavaScript로 활성화해야 합니다."
  },
  "The kit comes with three pre-built pages to help you get started faster. You can change the text and images and you're good to go. Just make sure you enable them first via JavaScript.": {
    "es": "El kit incluye tres páginas prediseñadas para empezar más rápido. Puede cambiar el texto y las imágenes. Recuerde activar las funciones mediante JavaScript.",
    "ko": "이 키트에는 빠르게 시작할 수 있는 세 가지 기본 페이지가 포함되어 있습니다. 텍스트와 이미지를 바꿔 사용하세요. 필요한 기능은 JavaScript로 활성화해 주세요."
  },
  "Check Vue Notus!": {
    "es": "¡Descubra Vue Notus!",
    "ko": "Vue Notus 살펴보기"
  },
  "Top Notch Services": {
    "es": "Servicios de primera calidad",
    "ko": "우수한 서비스"
  },
  "The Arctic Ocean freezes every winter and much of the sea-ice then thaws every summer, and that process will continue whatever happens.": {
    "es": "El océano Ártico se congela cada invierno y gran parte del hielo marino se derrite cada verano. Este proceso seguirá ocurriendo.",
    "ko": "북극해는 겨울마다 얼고 여름마다 해빙의 상당 부분이 녹습니다. 이 과정은 계속됩니다."
  },
  "A growing company": {
    "es": "Una empresa en crecimiento",
    "ko": "성장하는 기업"
  },
  "The extension comes with three pre-built pages to help you get started faster. You can change the text and images and you're good to go.": {
    "es": "La extensión incluye tres páginas prediseñadas para empezar más rápido. Solo tiene que cambiar el texto y las imágenes.",
    "ko": "확장 기능에는 빠르게 시작할 수 있는 세 가지 기본 페이지가 포함되어 있습니다. 텍스트와 이미지를 바꿔 사용하세요."
  },
  "Carefully crafted components": {
    "es": "Componentes cuidadosamente diseñados",
    "ko": "세심하게 설계된 구성 요소"
  },
  "Amazing page examples": {
    "es": "Excelentes ejemplos de páginas",
    "ko": "다양한 페이지 예시"
  },
  "Dynamic components": {
    "es": "Componentes dinámicos",
    "ko": "동적 구성 요소"
  },
  "Here are our heroes": {
    "es": "Nuestro equipo",
    "ko": "팀 소개"
  },
  "According to the National Oceanic and Atmospheric Administration, Ted, Scambos, NSIDClead scentist, puts the potentially record maximum.": {
    "es": "Según la National Oceanic and Atmospheric Administration, Ted Scambos, científico de NSIDC, señala que el máximo podría alcanzar un récord.",
    "ko": "National Oceanic and Atmospheric Administration에 따르면 NSIDC의 과학자 Ted Scambos는 최대치가 기록적인 수준에 이를 수 있다고 설명합니다."
  },
  "Ryan Tompson": {
    "es": "Ryan Tompson",
    "ko": "Ryan Tompson"
  },
  "Web Developer": {
    "es": "Desarrollador web",
    "ko": "웹 개발자"
  },
  "Romina Hadid": {
    "es": "Romina Hadid",
    "ko": "Romina Hadid"
  },
  "Marketing Specialist": {
    "es": "Especialista en marketing",
    "ko": "마케팅 전문가"
  },
  "Alexa Smith": {
    "es": "Alexa Smith",
    "ko": "Alexa Smith"
  },
  "UI/UX Designer": {
    "es": "Diseñador de UI/UX",
    "ko": "UI/UX 디자이너"
  },
  "Jenna Kardi": {
    "es": "Jenna Kardi",
    "ko": "Jenna Kardi"
  },
  "Founder and CEO": {
    "es": "Fundador y director ejecutivo",
    "ko": "설립자 및 최고경영자"
  },
  "Build something": {
    "es": "Cree algo nuevo",
    "ko": "새로운 것을 만들어 보세요"
  },
  "Put the potentially record low maximum sea ice extent tihs year down to low ice. According to the National Oceanic and Atmospheric Administration, Ted, Scambos.": {
    "es": "Según la National Oceanic and Atmospheric Administration y Ted Scambos, la extensión máxima del hielo marino podría alcanzar un mínimo histórico este año.",
    "ko": "National Oceanic and Atmospheric Administration과 Ted Scambos에 따르면 올해 해빙의 최대 면적이 역대 최저치를 기록할 수 있습니다."
  },
  "Excelent Services": {
    "es": "Servicios excelentes",
    "ko": "우수한 서비스"
  },
  "Some quick example text to build on the card title and make up the bulk of the card's content.": {
    "es": "Texto de ejemplo para complementar el título de la tarjeta y formar su contenido principal.",
    "ko": "카드 제목을 보충하고 본문을 구성하는 예시 문구입니다."
  },
  "Grow your market": {
    "es": "Amplíe su mercado",
    "ko": "시장을 넓혀 보세요"
  },
  "Launch time": {
    "es": "Hora de lanzamiento",
    "ko": "출시 시점"
  },
  "Want to work with us?": {
    "es": "¿Quiere trabajar con nosotros?",
    "ko": "저희와 함께 일하고 싶으신가요?"
  },
  "Complete this form and we will get back to you in 24 hours.": {
    "es": "Complete este formulario y nos pondremos en contacto con usted en 24 horas.",
    "ko": "이 양식을 작성해 주시면 24시간 이내에 연락드리겠습니다."
  },
  "Email": {
    "es": "Correo electrónico",
    "ko": "이메일"
  },
  "Message": {
    "es": "Mensaje",
    "ko": "메시지"
  },
  "Type a message...": {
    "es": "Escriba un mensaje...",
    "ko": "메시지를 입력해 주세요..."
  },
  "Send Message": {
    "es": "Enviar mensaje",
    "ko": "메시지 보내기"
  },
  "Connect": {
    "es": "Conectar",
    "ko": "연결"
  },
  "Friends": {
    "es": "Amigos",
    "ko": "친구"
  },
  "Photos": {
    "es": "Fotos",
    "ko": "사진"
  },
  "Comments": {
    "es": "Comentarios",
    "ko": "댓글"
  },
  "Jenna Stones": {
    "es": "Jenna Stones",
    "ko": "Jenna Stones"
  },
  "Los Angeles, California": {
    "es": "Los Angeles, California",
    "ko": "Los Angeles, California"
  },
  "Solution Manager - Creative Tim Officer": {
    "es": "Responsable de soluciones - Creative Tim",
    "ko": "솔루션 매니저 - Creative Tim"
  },
  "University of Computer Science": {
    "es": "University of Computer Science",
    "ko": "University of Computer Science"
  },
  "An artist of considerable range, Jenna the name taken by Melbourne-raised, Brooklyn-based Nick Murphy writes, performs and records all of his own music, giving it a warm, intimate feel with a solid groove structure. An artist of considerable range.": {
    "es": "Jenna es el nombre artístico de Nick Murphy, un artista versátil criado en Melbourne y establecido en Brooklyn. Escribe, interpreta y graba su propia música, con un estilo cálido e íntimo y una sólida estructura rítmica.",
    "ko": "Jenna는 Melbourne에서 성장하고 Brooklyn을 기반으로 활동하는 다재다능한 아티스트 Nick Murphy의 예명입니다. 직접 작사, 연주, 녹음을 하며 탄탄한 리듬과 따뜻하고 친밀한 분위기의 음악을 만듭니다."
  },
  "Show more": {
    "es": "Mostrar más",
    "ko": "더 보기"
  },
  "Sign In": {
    "es": "Iniciar sesión",
    "ko": "로그인"
  },
  "Email and password are incorrect": {
    "es": "El correo electrónico o la contraseña son incorrectos.",
    "ko": "이메일 또는 비밀번호가 올바르지 않습니다."
  },
  "Your session ended. Please sign in again to load your current information.": {
    "es": "Su sesión ha finalizado. Vuelva a iniciar sesión para cargar su información actual.",
    "ko": "세션이 종료되었습니다. 최신 정보를 불러오려면 다시 로그인해 주세요."
  },
  "Your account is not active. Please contact BFMS.": {
    "es": "Su cuenta no está activa. Póngase en contacto con BFMS.",
    "ko": "계정이 활성화되어 있지 않습니다. BFMS에 문의해 주세요."
  },
  "Your password was updated. Please sign in again.": {
    "es": "Su contraseña se ha actualizado. Vuelva a iniciar sesión.",
    "ko": "비밀번호가 변경되었습니다. 다시 로그인해 주세요."
  },
  "Password": {
    "es": "Contraseña",
    "ko": "비밀번호"
  },
  "Show Password": {
    "es": "Mostrar contraseña",
    "ko": "비밀번호 표시"
  },
  "Remember me": {
    "es": "Recordarme",
    "ko": "로그인 정보 기억하기"
  },
  "Enter the code sent to {0} to verify this device. The code expires in 10 minutes.": {
    "es": "Introduzca el código enviado a {0} para verificar este dispositivo. El código caduca en 10 minutos.",
    "ko": "이 기기를 인증하려면 {0}(으)로 발송된 코드를 입력해 주세요. 코드는 10분 후 만료됩니다."
  },
  "Email verification code": {
    "es": "Código de verificación por correo electrónico",
    "ko": "이메일 인증 코드"
  },
  "Verify & sign in": {
    "es": "Verificar e iniciar sesión",
    "ko": "인증 후 로그인"
  },
  "Resend code{0}": {
    "es": "Reenviar código{0}",
    "ko": "코드 다시 보내기{0}"
  },
  "Back to sign in": {
    "es": "Volver al inicio de sesión",
    "ko": "로그인 화면으로 돌아가기"
  },
  "Forgot Password?": {
    "es": "¿Olvidó su contraseña?",
    "ko": "비밀번호를 잊으셨나요?"
  },
  "Account Enrollment": {
    "es": "Registro de cuenta",
    "ko": "계정 등록"
  },
  "ACCOUNT ENROLLMENT": {
    "es": "REGISTRO DE CUENTA",
    "ko": "계정 등록"
  },
  "Middle Name": {
    "es": "Segundo nombre",
    "ko": "중간 이름"
  },
  "Middle Name is required": {
    "es": "El segundo nombre es obligatorio.",
    "ko": "중간 이름을 입력해 주세요."
  },
  "Date of Birth": {
    "es": "Fecha de nacimiento",
    "ko": "생년월일"
  },
  "mm/dd/yyyy": {
    "es": "mm/dd/aaaa",
    "ko": "월/일/연도"
  },
  "Date of Birth is required": {
    "es": "La fecha de nacimiento es obligatoria.",
    "ko": "생년월일을 입력해 주세요."
  },
  "Gender": {
    "es": "Género",
    "ko": "성별"
  },
  "Male": {
    "es": "Masculino",
    "ko": "남성"
  },
  "Female": {
    "es": "Femenino",
    "ko": "여성"
  },
  "Gender is required": {
    "es": "El género es obligatorio.",
    "ko": "성별을 선택해 주세요."
  },
  "Address": {
    "es": "Dirección",
    "ko": "주소"
  },
  "Address is required": {
    "es": "La dirección es obligatoria.",
    "ko": "주소를 입력해 주세요."
  },
  "City": {
    "es": "Ciudad",
    "ko": "도시"
  },
  "City is required": {
    "es": "La ciudad es obligatoria.",
    "ko": "도시를 입력해 주세요."
  },
  "State": {
    "es": "Estado",
    "ko": "주"
  },
  "State is required": {
    "es": "El estado es obligatorio.",
    "ko": "주를 선택해 주세요."
  },
  "Zip Code": {
    "es": "Código postal",
    "ko": "우편번호"
  },
  "Zip Code is required": {
    "es": "El código postal es obligatorio.",
    "ko": "우편번호를 입력해 주세요."
  },
  "Enter a valid email address": {
    "es": "Introduzca un correo electrónico válido.",
    "ko": "올바른 이메일 주소를 입력해 주세요."
  },
  "Contact Number": {
    "es": "Número de contacto",
    "ko": "연락처"
  },
  "Name": {
    "es": "Nombre",
    "ko": "이름"
  },
  "Contact Number is required": {
    "es": "El número de contacto es obligatorio.",
    "ko": "연락처를 입력해 주세요."
  },
  "UCI Number": {
    "es": "Número UCI",
    "ko": "UCI 번호"
  },
  "UCI number is required": {
    "es": "El número UCI es obligatorio.",
    "ko": "UCI 번호를 입력해 주세요."
  },
  "UCI number must be atleast 7 characters alphanumeric": {
    "es": "El número UCI debe tener al menos 7 caracteres alfanuméricos.",
    "ko": "UCI 번호는 영문자와 숫자로 최소 7자여야 합니다."
  },
  "UCI number must not be more than 7 characters alphanumeric": {
    "es": "El número UCI no debe superar los 7 caracteres alfanuméricos.",
    "ko": "UCI 번호는 영문자와 숫자로 7자를 초과할 수 없습니다."
  },
  "SS NUMBER": {
    "es": "NÚMERO DE SEGURO SOCIAL",
    "ko": "사회보장번호"
  },
  "SS number is required": {
    "es": "El número de Seguro Social es obligatorio.",
    "ko": "사회보장번호를 입력해 주세요."
  },
  "SS number must be atleast 9 characters alphanumeric": {
    "es": "El número de Seguro Social debe tener al menos 9 caracteres alfanuméricos.",
    "ko": "사회보장번호는 영문자와 숫자로 최소 9자여야 합니다."
  },
  "SS number must not be more than 9 characters alphanumeric": {
    "es": "El número de Seguro Social no debe superar los 9 caracteres alfanuméricos.",
    "ko": "사회보장번호는 영문자와 숫자로 9자를 초과할 수 없습니다."
  },
  "Regional Center Name": {
    "es": "Nombre del Centro Regional",
    "ko": "Regional Center 이름"
  },
  "Regional Center Name is required": {
    "es": "El nombre del Centro Regional es obligatorio.",
    "ko": "Regional Center 이름을 입력해 주세요."
  },
  "Regional Center Coordinator": {
    "es": "Coordinador del Centro Regional",
    "ko": "Regional Center 코디네이터"
  },
  "Coordinator is required": {
    "es": "El coordinador es obligatorio.",
    "ko": "코디네이터를 입력해 주세요."
  },
  "Regional Center Coordinator Email": {
    "es": "Correo electrónico del coordinador del Centro Regional",
    "ko": "Regional Center 코디네이터 이메일"
  },
  "Regional Center Coordinator Number": {
    "es": "Teléfono del coordinador del Centro Regional",
    "ko": "Regional Center 코디네이터 전화번호"
  },
  "Password is required": {
    "es": "La contraseña es obligatoria.",
    "ko": "비밀번호를 입력해 주세요."
  },
  "Password should contain minimum of 8 characters": {
    "es": "La contraseña debe tener al menos 8 caracteres.",
    "ko": "비밀번호는 8자 이상이어야 합니다."
  },
  "Retype Password": {
    "es": "Vuelva a escribir la contraseña",
    "ko": "비밀번호 재입력"
  },
  "Password did not match.": {
    "es": "Las contraseñas no coinciden.",
    "ko": "비밀번호가 일치하지 않습니다."
  },
  "DMV ID or Passort ID": {
    "es": "Identificación del DMV o pasaporte",
    "ko": "DMV 신분증 또는 여권"
  },
  "Valid ID 1 is required": {
    "es": "La primera identificación es obligatoria.",
    "ko": "첫 번째 신분증을 제출해 주세요."
  },
  "Social Security ID": {
    "es": "Tarjeta de Seguro Social",
    "ko": "사회보장카드"
  },
  "Valid ID 2 is required": {
    "es": "La segunda identificación es obligatoria.",
    "ko": "두 번째 신분증을 제출해 주세요."
  },
  "I agree with the": {
    "es": "Acepto la",
    "ko": "다음 항목에 동의합니다:"
  },
  "Please agree to the Privacy Policy": {
    "es": "Acepte la política de privacidad.",
    "ko": "개인정보 처리방침에 동의해 주세요."
  },
  "Create Account": {
    "es": "Crear cuenta",
    "ko": "계정 만들기"
  },
  "Validating your invitation link...": {
    "es": "Validando el enlace de invitación...",
    "ko": "초대 링크를 확인하는 중입니다..."
  },
  "Back to Sign In": {
    "es": "Volver al inicio de sesión",
    "ko": "로그인 화면으로 돌아가기"
  },
  "Company Name": {
    "es": "Nombre de la empresa",
    "ko": "회사명"
  },
  "Company Name is required": {
    "es": "El nombre de la empresa es obligatorio.",
    "ko": "회사명을 입력해 주세요."
  },
  "Mobile": {
    "es": "Móvil",
    "ko": "휴대전화"
  },
  "Mobile is required": {
    "es": "El número de móvil es obligatorio.",
    "ko": "휴대전화 번호를 입력해 주세요."
  },
  "Phone": {
    "es": "Teléfono",
    "ko": "전화"
  },
  "Phone is required": {
    "es": "El teléfono es obligatorio.",
    "ko": "전화번호를 입력해 주세요."
  },
  "Address 1": {
    "es": "Dirección, línea 1",
    "ko": "주소 1"
  },
  "Address 1 is required": {
    "es": "La primera línea de dirección es obligatoria.",
    "ko": "주소 1을 입력해 주세요."
  },
  "Address 2": {
    "es": "Dirección, línea 2",
    "ko": "주소 2"
  },
  "TIN": {
    "es": "TIN",
    "ko": "TIN"
  },
  "9 digit TIN": {
    "es": "TIN de 9 dígitos",
    "ko": "9자리 TIN"
  },
  "TIN is required": {
    "es": "El TIN es obligatorio.",
    "ko": "TIN을 입력해 주세요."
  },
  "TIN must be exactly 9 digits": {
    "es": "El TIN debe tener exactamente 9 dígitos.",
    "ko": "TIN은 정확히 9자리여야 합니다."
  },
  "Confirm Password": {
    "es": "Confirmar contraseña",
    "ko": "비밀번호 확인"
  },
  "Confirm Password is required": {
    "es": "La confirmación de contraseña es obligatoria.",
    "ko": "비밀번호 확인을 입력해 주세요."
  },
  "Passwords do not match": {
    "es": "Las contraseñas no coinciden.",
    "ko": "비밀번호가 일치하지 않습니다."
  },
  "Create Vendor Account": {
    "es": "Crear cuenta de proveedor",
    "ko": "공급업체 계정 만들기"
  },
  "Select Gender": {
    "es": "Seleccione el género",
    "ko": "성별 선택"
  },
  "Other": {
    "es": "Otro",
    "ko": "기타"
  },
  "SS Number is required": {
    "es": "El número de Seguro Social es obligatorio.",
    "ko": "사회보장번호를 입력해 주세요."
  },
  "UCI Number is required": {
    "es": "El número UCI es obligatorio.",
    "ko": "UCI 번호를 입력해 주세요."
  },
  "Create Employee Account": {
    "es": "Crear cuenta de empleado",
    "ko": "직원 계정 만들기"
  },
  "Enter your email addres": {
    "es": "Introduzca su correo electrónico.",
    "ko": "이메일 주소를 입력해 주세요."
  },
  "Once you click submit, an email will be sent to you containing your new password.": {
    "es": "Al pulsar Enviar, recibirá un correo electrónico con su nueva contraseña.",
    "ko": "제출을 누르면 새 비밀번호가 이메일로 발송됩니다."
  },
  "Account management": {
    "es": "Gestión de la cuenta",
    "ko": "계정 관리"
  },
  "Change Password": {
    "es": "Cambiar contraseña",
    "ko": "비밀번호 변경"
  },
  "Device Management": {
    "es": "Gestión de dispositivos",
    "ko": "기기 관리"
  },
  "Loading account settings…": {
    "es": "Cargando la configuración de la cuenta…",
    "ko": "계정 설정을 불러오는 중입니다…"
  },
  "Administrator sign-in: this session does not add a device to this list.": {
    "es": "Sesión de administrador: esta sesión no añade ningún dispositivo a la lista.",
    "ko": "관리자 로그인: 이 세션은 기기 목록에 추가되지 않습니다."
  },
  "Email two-factor authentication": {
    "es": "Autenticación de dos factores por correo electrónico",
    "ko": "이메일 2단계 인증"
  },
  "Device tracking and device removal work with either setting. Changing this setting requires an email code.": {
    "es": "El registro y la eliminación de dispositivos funcionan con ambas opciones. Para cambiar esta configuración se requiere un código por correo electrónico.",
    "ko": "어느 설정에서든 기기를 기록하고 삭제할 수 있습니다. 이 설정을 변경하려면 이메일 인증 코드가 필요합니다."
  },
  "Your devices": {
    "es": "Sus dispositivos",
    "ko": "내 기기"
  },
  "Names describe the browser and device type; they cannot identify a device’s owner. No IP addresses are stored in this device list. You can rename devices you recognize.": {
    "es": "Los nombres describen el navegador y el tipo de dispositivo; no identifican a su propietario. Esta lista no guarda direcciones IP. Puede cambiar el nombre de los dispositivos que reconoce.",
    "ko": "기기 이름은 브라우저와 기기 유형을 설명하며 소유자를 식별하지는 않습니다. 이 기기 목록에는 IP 주소가 저장되지 않습니다. 알고 있는 기기의 이름을 변경할 수 있습니다."
  },
  "“Existing session” preserves a sign-in from before device tracking. Older browsers may share that session; removing it signs out every browser using it.": {
    "es": "Una «Sesión existente» conserva un inicio de sesión anterior al registro de dispositivos. Varios navegadores antiguos podrían compartirla; al eliminarla, se cerrará la sesión en todos ellos.",
    "ko": "‘기존 세션’은 기기 기록 기능이 도입되기 전의 로그인을 유지합니다. 이전 브라우저 여러 개가 이 세션을 공유할 수 있으며, 삭제하면 해당 세션을 사용하는 모든 브라우저에서 로그아웃됩니다."
  },
  "Verify {0} by email to rename or remove devices.": {
    "es": "Verifique {0} por correo electrónico para cambiar el nombre o eliminar dispositivos.",
    "ko": "기기 이름을 변경하거나 기기를 삭제하려면 이메일로 {0} 인증을 완료해 주세요."
  },
  "Device name": {
    "es": "Nombre del dispositivo",
    "ko": "기기 이름"
  },
  "Browser": {
    "es": "Navegador",
    "ko": "브라우저"
  },
  "Type": {
    "es": "Tipo",
    "ko": "유형"
  },
  "Last active": {
    "es": "Última actividad",
    "ko": "최근 활동"
  },
  "Access": {
    "es": "Acceso",
    "ko": "접근 권한"
  },
  "Actions": {
    "es": "Acciones",
    "ko": "작업"
  },
  "(This session)": {
    "es": "(Esta sesión)",
    "ko": "(현재 세션)"
  },
  "{0} active session(s)": {
    "es": "Sesiones activas: {0}",
    "ko": "활성 세션 수: {0}"
  },
  "Rename": {
    "es": "Cambiar nombre",
    "ko": "이름 변경"
  },
  "Remove": {
    "es": "Eliminar",
    "ko": "삭제"
  },
  "Removing a device signs out its active sessions and removes its trusted status. While 2FA is off, someone who knows the password can sign in again.": {
    "es": "Al eliminar un dispositivo, se cerrarán sus sesiones activas y dejará de ser de confianza. Si la autenticación de dos factores está desactivada, quien conozca la contraseña podrá volver a iniciar sesión.",
    "ko": "기기를 삭제하면 해당 기기의 활성 세션이 종료되고 신뢰 상태가 해제됩니다. 2단계 인증이 꺼져 있으면 비밀번호를 아는 사람이 다시 로그인할 수 있습니다."
  },
  "A code was sent to {0}. It expires in 10 minutes.": {
    "es": "Se ha enviado un código a {0}. Caduca en 10 minutos.",
    "ko": "{0}(으)로 코드를 발송했습니다. 코드는 10분 후 만료됩니다."
  },
  "Confirm {0}": {
    "es": "Confirmar: {0}",
    "ko": "{0} 확인"
  },
  "Spent {0} / Authorized {1}": {
    "es": "Gastado: {0} / Autorizado: {1}",
    "ko": "사용액 {0} / 승인 예산 {1}"
  },
  "Year #:": {
    "es": "Año n.º:",
    "ko": "연차:"
  },
  "Total Budget:": {
    "es": "Presupuesto total:",
    "ko": "총예산:"
  },
  "Total Spent:": {
    "es": "Total gastado:",
    "ko": "총사용액:"
  },
  "Date From:": {
    "es": "Fecha de inicio:",
    "ko": "시작일:"
  },
  "Date To:": {
    "es": "Fecha de finalización:",
    "ko": "종료일:"
  },
  "Domain Breakdown": {
    "es": "Desglose por área",
    "ko": "영역별 내역"
  },
  "No budget data available.": {
    "es": "No hay datos de presupuesto disponibles.",
    "ko": "예산 데이터가 없습니다."
  },
  "Spending Plan Files": {
    "es": "Archivos del plan de gastos",
    "ko": "지출 계획 파일"
  },
  "View uploaded spending plan documents.": {
    "es": "Consulte los documentos del plan de gastos que se han subido.",
    "ko": "업로드된 지출 계획 서류를 확인하세요."
  },
  "No spending plans uploaded yet.": {
    "es": "Todavía no se han subido planes de gastos.",
    "ko": "아직 업로드된 지출 계획이 없습니다."
  },
  "Uploaded: {0}": {
    "es": "Subido: {0}",
    "ko": "업로드: {0}"
  },
  "Preview": {
    "es": "Vista previa",
    "ko": "미리보기"
  },
  "View": {
    "es": "Ver",
    "ko": "보기"
  },
  "SPENDING PLAN DOMAINS": {
    "es": "ÁREAS DEL PLAN DE GASTOS",
    "ko": "지출 계획 영역"
  },
  "TOTAL SPENT": {
    "es": "TOTAL GASTADO",
    "ko": "총사용액"
  },
  "BUDGET": {
    "es": "PRESUPUESTO",
    "ko": "예산"
  },
  "Thank you": {
    "es": "Gracias",
    "ko": "감사합니다"
  },
  "Employee Enrollment Status": {
    "es": "Estado de inscripción de empleados",
    "ko": "직원 등록 현황"
  },
  "Invite employees and monitor onboarding progress. Sensitive employee documents are never shown here.": {
    "es": "Invite a empleados y consulte el avance de su incorporación. Los documentos confidenciales de los empleados nunca se muestran aquí.",
    "ko": "직원을 초대하고 등록 진행 상황을 확인하세요. 직원의 민감한 서류는 이 화면에 표시되지 않습니다."
  },
  "Refresh": {
    "es": "Actualizar",
    "ko": "새로고침"
  },
  "Invite Employee": {
    "es": "Invitar empleado",
    "ko": "직원 초대"
  },
  "Connected Employees": {
    "es": "Empleados vinculados",
    "ko": "연결된 직원"
  },
  "Pending Invitations": {
    "es": "Invitaciones pendientes",
    "ko": "가입 대기 중인 초대"
  },
  "Enrollment Submitted": {
    "es": "Inscripción enviada",
    "ko": "등록 제출 완료"
  },
  "In Progress": {
    "es": "En curso",
    "ko": "진행 중"
  },
  "These employees have not completed the invitation yet.": {
    "es": "Estos empleados aún no han completado la invitación.",
    "ko": "아래 직원은 아직 초대를 통한 가입을 완료하지 않았습니다."
  },
  "Invited {0}": {
    "es": "Invitación enviada: {0}",
    "ko": "초대일: {0}"
  },
  "Invitation Pending": {
    "es": "Invitación pendiente",
    "ko": "초대 수락 대기"
  },
  "Employee Enrollment": {
    "es": "Inscripción de empleados",
    "ko": "직원 등록"
  },
  "Only completion metadata is visible to the client.": {
    "es": "El cliente solo puede ver información sobre el estado de finalización.",
    "ko": "클라이언트는 완료 여부에 관한 정보만 볼 수 있습니다."
  },
  "Loading employee enrollment status...": {
    "es": "Cargando el estado de inscripción de empleados...",
    "ko": "직원 등록 현황을 불러오는 중입니다..."
  },
  "No connected employees yet.": {
    "es": "Todavía no hay empleados vinculados.",
    "ko": "아직 연결된 직원이 없습니다."
  },
  "Invite an employee to begin the onboarding process.": {
    "es": "Invite a un empleado para comenzar el proceso de incorporación.",
    "ko": "직원을 초대하여 등록 절차를 시작하세요."
  },
  "Updated {0}": {
    "es": "Actualizado: {0}",
    "ko": "업데이트: {0}"
  },
  "The employee has not started this employer-specific enrollment yet.": {
    "es": "El empleado todavía no ha iniciado la inscripción específica para este empleador.",
    "ko": "직원이 아직 이 고용주에 대한 등록을 시작하지 않았습니다."
  },
  "Required documents": {
    "es": "Documentos obligatorios",
    "ko": "필수 서류"
  },
  "Recorded signatures": {
    "es": "Firmas registradas",
    "ko": "등록된 서명"
  },
  "Driving documents": {
    "es": "Documentos de conducción",
    "ko": "운전 관련 서류"
  },
  "Employee Invoice Sheets": {
    "es": "Facturas de empleados",
    "ko": "직원 청구서"
  },
  "Review services actually provided to you. Your approval sends the invoice to BFMS admin, who confirms the payroll details and converts it into payroll. Both approvals are required.": {
    "es": "Revise los servicios que realmente ha recibido. Su aprobación envía la factura al administrador de BFMS, quien confirma los datos de nómina y la convierte en un registro de nómina. Se requieren ambas aprobaciones.",
    "ko": "실제로 제공받은 서비스를 검토하세요. 클라이언트가 승인하면 청구서가 BFMS 관리자에게 전달됩니다. 관리자는 급여 정보를 확인한 뒤 청구서를 급여 기록으로 전환합니다. 두 단계의 승인이 모두 필요합니다."
  },
  "Loading invoices...": {
    "es": "Cargando facturas...",
    "ko": "청구서를 불러오는 중입니다..."
  },
  "Submitted / #": {
    "es": "Envío / n.º",
    "ko": "제출일 / 번호"
  },
  "Worker / Year": {
    "es": "Trabajador / año",
    "ko": "직원 / 연차"
  },
  "Service date / Code": {
    "es": "Fecha del servicio / código",
    "ko": "서비스 제공일 / 코드"
  },
  "Work performed": {
    "es": "Trabajo realizado",
    "ko": "수행한 업무"
  },
  "Hours / Rate": {
    "es": "Horas / tarifa",
    "ko": "근무 시간 / 요율"
  },
  "Total": {
    "es": "Total",
    "ko": "합계"
  },
  "Client review": {
    "es": "Revisión del cliente",
    "ko": "클라이언트 검토"
  },
  "Admin review": {
    "es": "Revisión del administrador",
    "ko": "관리자 검토"
  },
  "Year {0}": {
    "es": "Año {0}",
    "ko": "{0}년 차"
  },
  "{0} hours": {
    "es": "{0} horas",
    "ko": "{0}시간"
  },
  "Document": {
    "es": "Documento",
    "ko": "서류"
  },
  "Receipt": {
    "es": "Recibo",
    "ko": "영수증"
  },
  "Approve": {
    "es": "Aprobar",
    "ko": "승인"
  },
  "Decline": {
    "es": "Rechazar",
    "ko": "거절"
  },
  "No employee invoices for your current spending-plan year.": {
    "es": "No hay facturas de empleados para el año actual de su plan de gastos.",
    "ko": "현재 지출 계획 연차에 해당하는 직원 청구서가 없습니다."
  },
  "Personal Information": {
    "es": "Información personal",
    "ko": "개인정보"
  },
  "Terms and Agreement": {
    "es": "Términos y acuerdo",
    "ko": "약관 및 동의"
  },
  "Signature": {
    "es": "Firma",
    "ko": "서명"
  },
  "Resource Documents": {
    "es": "Documentos de referencia",
    "ko": "참고 자료"
  },
  "Send Us a Message": {
    "es": "Envíenos un mensaje",
    "ko": "문의 메시지 보내기"
  },
  "Content": {
    "es": "Contenido",
    "ko": "내용"
  },
  "Subject": {
    "es": "Asunto",
    "ko": "제목"
  },
  "Please specify your concern here.": {
    "es": "Describa aquí su consulta.",
    "ko": "문의 내용을 입력해 주세요."
  },
  "Send": {
    "es": "Enviar",
    "ko": "보내기"
  },
  "Payables List": {
    "es": "Lista de cuentas por pagar",
    "ko": "지급 예정 내역"
  },
  "Upload Invoice": {
    "es": "Subir factura",
    "ko": "청구서 업로드"
  },
  "Date Uploaded": {
    "es": "Fecha de carga",
    "ko": "업로드 날짜"
  },
  "Invoices": {
    "es": "Facturas",
    "ko": "청구서"
  },
  "Reciept": {
    "es": "Recibo",
    "ko": "영수증"
  },
  "No receipt available.": {
    "es": "No hay recibo disponible.",
    "ko": "영수증이 없습니다."
  },
  "Payroll Sheets": {
    "es": "Registros de nómina",
    "ko": "급여 내역"
  },
  "Payroll Start": {
    "es": "Inicio del período de nómina",
    "ko": "급여 기간 시작일"
  },
  "Payroll End": {
    "es": "Fin del período de nómina",
    "ko": "급여 기간 종료일"
  },
  "Payroll File": {
    "es": "Archivo de nómina",
    "ko": "급여 파일"
  },
  "Time Created": {
    "es": "Fecha de creación",
    "ko": "생성일시"
  },
  "No payroll sheets found for this period.": {
    "es": "No se encontraron registros de nómina para este período.",
    "ko": "해당 기간의 급여 내역이 없습니다."
  },
  "Purchase Request": {
    "es": "Solicitud de compra",
    "ko": "구매 요청"
  },
  "Quick report view for purchase requests.": {
    "es": "Vista rápida de las solicitudes de compra.",
    "ko": "구매 요청을 간단히 확인하는 화면입니다."
  },
  "Create Purchase Request": {
    "es": "Crear solicitud de compra",
    "ko": "구매 요청 작성"
  },
  "Purchase Date": {
    "es": "Fecha de compra",
    "ko": "구매일"
  },
  "Item Description": {
    "es": "Descripción del artículo",
    "ko": "물품 설명"
  },
  "Price": {
    "es": "Precio",
    "ko": "가격"
  },
  "Status": {
    "es": "Estado",
    "ko": "상태"
  },
  "Advanced View": {
    "es": "Vista detallada",
    "ko": "상세 보기"
  },
  "No purchase requests yet.": {
    "es": "Todavía no hay solicitudes de compra.",
    "ko": "아직 구매 요청이 없습니다."
  },
  "Report Title": {
    "es": "Título del informe",
    "ko": "보고서 제목"
  },
  "Report Description": {
    "es": "Descripción del informe",
    "ko": "보고서 설명"
  },
  "Report Date": {
    "es": "Fecha del informe",
    "ko": "보고서 날짜"
  },
  "View and download helpful documents shared in your enrollment resources.": {
    "es": "Consulte y descargue los documentos de ayuda disponibles en los recursos de su inscripción.",
    "ko": "등록 참고 자료에 있는 문서를 확인하고 다운로드하세요."
  },
  "Loading resources...": {
    "es": "Cargando recursos...",
    "ko": "자료를 불러오는 중입니다..."
  },
  "No resource documents available yet.": {
    "es": "Todavía no hay documentos de referencia disponibles.",
    "ko": "아직 제공된 참고 자료가 없습니다."
  },
  "Resource Name": {
    "es": "Nombre del recurso",
    "ko": "자료명"
  },
  "Resource Description": {
    "es": "Descripción del recurso",
    "ko": "자료 설명"
  },
  "Select Signature Method:": {
    "es": "Seleccione el método de firma:",
    "ko": "서명 방식 선택:"
  },
  "Text": {
    "es": "Texto",
    "ko": "텍스트"
  },
  "Draw": {
    "es": "Dibujar",
    "ko": "직접 그리기"
  },
  "Type your name:": {
    "es": "Escriba su nombre:",
    "ko": "이름 입력:"
  },
  "e.g. John Smith": {
    "es": "p. ej., John Smith",
    "ko": "예: John Smith"
  },
  "Preview:": {
    "es": "Vista previa:",
    "ko": "미리보기:"
  },
  "Alex Brush": {
    "es": "Alex Brush",
    "ko": "Alex Brush"
  },
  "Mr Dafoe": {
    "es": "Mr Dafoe",
    "ko": "Mr Dafoe"
  },
  "MrDeHaviland": {
    "es": "MrDeHaviland",
    "ko": "MrDeHaviland"
  },
  "PWSimpleScript": {
    "es": "PWSimpleScript",
    "ko": "PWSimpleScript"
  },
  "Draw your signature:": {
    "es": "Dibuje su firma:",
    "ko": "서명을 그려 주세요:"
  },
  "Clear": {
    "es": "Borrar",
    "ko": "지우기"
  },
  "My Expenditure": {
    "es": "Mis gastos",
    "ko": "내 지출"
  },
  "Review authorized budget, monthly expenses, total expenses, and remaining balance by service code.": {
    "es": "Consulte el presupuesto autorizado, los gastos del mes, los gastos totales y el saldo restante por código de servicio.",
    "ko": "서비스 코드별 승인 예산, 이번 달 지출, 총지출 및 잔액을 확인하세요."
  },
  "Budget Period: {0} - {1}": {
    "es": "Período presupuestario: {0} - {1}",
    "ko": "예산 기간: {0} - {1}"
  },
  "Authorized Budget": {
    "es": "Presupuesto autorizado",
    "ko": "승인 예산"
  },
  "Expenses This Month": {
    "es": "Gastos de este mes",
    "ko": "이번 달 지출"
  },
  "Total Expenses": {
    "es": "Gastos totales",
    "ko": "총지출"
  },
  "Amount Remaining": {
    "es": "Importe restante",
    "ko": "남은 금액"
  },
  "Search by service code, description, provider, or domain...": {
    "es": "Buscar por código de servicio, descripción, proveedor o área...",
    "ko": "서비스 코드, 설명, 제공자 또는 영역으로 검색..."
  },
  "Loading expenditure records...": {
    "es": "Cargando registros de gastos...",
    "ko": "지출 기록을 불러오는 중입니다..."
  },
  "Service Code": {
    "es": "Código de servicio",
    "ko": "서비스 코드"
  },
  "Domain": {
    "es": "Área",
    "ko": "영역"
  },
  "Provider / Vendor / Employee": {
    "es": "Prestador / proveedor / empleado",
    "ko": "서비스 제공자 / 공급업체 / 직원"
  },
  "Amount Authorized": {
    "es": "Importe autorizado",
    "ko": "승인 금액"
  },
  "Usage": {
    "es": "Uso",
    "ko": "사용 현황"
  },
  "Show Detail": {
    "es": "Ver detalles",
    "ko": "상세 내역 보기"
  },
  "No expense provider yet": {
    "es": "Todavía no hay un proveedor con gastos registrados.",
    "ko": "아직 지출이 기록된 제공자가 없습니다."
  },
  "No expenditure records found.": {
    "es": "No se encontraron registros de gastos.",
    "ko": "지출 기록이 없습니다."
  },
  "Total for {0}:": {
    "es": "Total de {0}:",
    "ko": "{0} 합계:"
  },
  "Service Code {0}": {
    "es": "Código de servicio {0}",
    "ko": "서비스 코드 {0}"
  },
  "Authorized": {
    "es": "Autorizado",
    "ko": "승인 금액"
  },
  "This Month": {
    "es": "Este mes",
    "ko": "이번 달"
  },
  "Remaining": {
    "es": "Restante",
    "ko": "잔액"
  },
  "Provider": {
    "es": "Proveedor",
    "ko": "제공자"
  },
  "Amount": {
    "es": "Importe",
    "ko": "금액"
  },
  "No detailed expenses yet for this service code.": {
    "es": "Todavía no hay gastos detallados para este código de servicio.",
    "ko": "아직 이 서비스 코드의 상세 지출이 없습니다."
  },
  "Timesheets": {
    "es": "Hojas de horas",
    "ko": "근무 시간표"
  },
  "Export to PDF": {
    "es": "Exportar a PDF",
    "ko": "PDF로 내보내기"
  },
  "Export to Excel": {
    "es": "Exportar a Excel",
    "ko": "Excel로 내보내기"
  },
  "Employee Changes": {
    "es": "Cambios de empleados",
    "ko": "직원 변경 내역"
  },
  "All Employees": {
    "es": "Todos los empleados",
    "ko": "모든 직원"
  },
  "All Months": {
    "es": "Todos los meses",
    "ko": "모든 월"
  },
  "All Years": {
    "es": "Todos los años",
    "ko": "모든 연도"
  },
  "Clear Dates": {
    "es": "Borrar fechas",
    "ko": "날짜 초기화"
  },
  "Employee": {
    "es": "Empleado",
    "ko": "직원"
  },
  "Pending": {
    "es": "Pendiente",
    "ko": "대기 중"
  },
  "Approved": {
    "es": "Aprobado",
    "ko": "승인됨"
  },
  "Declined": {
    "es": "Rechazado",
    "ko": "거절됨"
  },
  "Employee Timesheet Changes": {
    "es": "Cambios en las hojas de horas de empleados",
    "ko": "직원 근무 시간표 변경 내역"
  },
  "Direct employee edits and deletes recorded by the new audit system.": {
    "es": "Ediciones y eliminaciones realizadas directamente por empleados, registradas por el nuevo sistema de auditoría.",
    "ko": "새 감사 시스템에 기록된 직원의 직접 수정 및 삭제 내역입니다."
  },
  "Active": {
    "es": "Activo",
    "ko": "활성"
  },
  "All": {
    "es": "Todos",
    "ko": "전체"
  },
  "Loading changes...": {
    "es": "Cargando cambios...",
    "ko": "변경 내역을 불러오는 중입니다..."
  },
  "No employee change logs found.": {
    "es": "No se encontraron registros de cambios de empleados.",
    "ko": "직원 변경 기록이 없습니다."
  },
  "Change #{0} • Timesheet #{1}": {
    "es": "Cambio n.º {0} • Hoja de horas n.º {1}",
    "ko": "변경 #{0} • 근무 시간표 #{1}"
  },
  "Employee reason:": {
    "es": "Motivo del empleado:",
    "ko": "직원 사유:"
  },
  "Changed at:": {
    "es": "Fecha del cambio:",
    "ko": "변경일시:"
  },
  "Admin reason:": {
    "es": "Motivo del administrador:",
    "ko": "관리자 사유:"
  },
  "Reverted at:": {
    "es": "Fecha de reversión:",
    "ko": "되돌린 일시:"
  },
  "Original": {
    "es": "Original",
    "ko": "변경 전"
  },
  "Date:": {
    "es": "Fecha:",
    "ko": "날짜:"
  },
  "Time In:": {
    "es": "Entrada:",
    "ko": "출근:"
  },
  "Time Out:": {
    "es": "Salida:",
    "ko": "퇴근:"
  },
  "Total Hours:": {
    "es": "Horas totales:",
    "ko": "총 근무 시간:"
  },
  "Service Code:": {
    "es": "Código de servicio:",
    "ko": "서비스 코드:"
  },
  "Specification:": {
    "es": "Especificación:",
    "ko": "세부 내용:"
  },
  "New": {
    "es": "Nuevo",
    "ko": "변경 후"
  },
  "This timesheet was deleted.": {
    "es": "Esta hoja de horas se eliminó.",
    "ko": "이 근무 시간표는 삭제되었습니다."
  },
  "Revert Change": {
    "es": "Revertir cambio",
    "ko": "변경 되돌리기"
  },
  "INVOICE LISTS": {
    "es": "LISTA DE FACTURAS",
    "ko": "청구서 목록"
  },
  "From:": {
    "es": "Desde:",
    "ko": "시작:"
  },
  "To:": {
    "es": "Hasta:",
    "ko": "종료:"
  },
  "Sort:": {
    "es": "Orden:",
    "ko": "정렬:"
  },
  "Latest First": {
    "es": "Más recientes primero",
    "ko": "최신순"
  },
  "Oldest First": {
    "es": "Más antiguos primero",
    "ko": "오래된순"
  },
  "Invoice Date": {
    "es": "Fecha de la factura",
    "ko": "청구서 날짜"
  },
  "Invoice": {
    "es": "Factura",
    "ko": "청구서"
  },
  "View Invoice": {
    "es": "Ver factura",
    "ko": "청구서 보기"
  },
  "MY INVOICES": {
    "es": "MIS FACTURAS",
    "ko": "내 청구서"
  },
  "Client": {
    "es": "Cliente",
    "ko": "클라이언트"
  },
  "Invoice File": {
    "es": "Archivo de la factura",
    "ko": "청구서 파일"
  },
  "No invoices submitted yet.": {
    "es": "Todavía no se han enviado facturas.",
    "ko": "아직 제출한 청구서가 없습니다."
  },
  "Download Invoice": {
    "es": "Descargar factura",
    "ko": "청구서 다운로드"
  },
  "No file": {
    "es": "Sin archivo",
    "ko": "파일 없음"
  },
  "Client / Program Name": {
    "es": "Nombre del cliente / programa",
    "ko": "클라이언트 / 프로그램 이름"
  },
  "Who is this invoice for?": {
    "es": "¿A quién corresponde esta factura?",
    "ko": "어느 클라이언트에 대한 청구서인가요?"
  },
  "Invoice date is required": {
    "es": "La fecha de la factura es obligatoria.",
    "ko": "청구서 날짜를 입력해 주세요."
  },
  "Amount is required": {
    "es": "El importe es obligatorio.",
    "ko": "금액을 입력해 주세요."
  },
  "Describe the invoice...": {
    "es": "Describa la factura...",
    "ko": "청구서 내용을 설명해 주세요..."
  },
  "Description is required": {
    "es": "La descripción es obligatoria.",
    "ko": "설명을 입력해 주세요."
  },
  "Please attach the invoice file": {
    "es": "Adjunte el archivo de la factura.",
    "ko": "청구서 파일을 첨부해 주세요."
  },
  "Vendors List": {
    "es": "Lista de proveedores",
    "ko": "공급업체 목록"
  },
  "Invite Vendor": {
    "es": "Invitar proveedor",
    "ko": "공급업체 초대"
  },
  "Trade Name": {
    "es": "Nombre comercial",
    "ko": "상호"
  },
  "Vendor ID": {
    "es": "ID de proveedor",
    "ko": "공급업체 ID"
  },
  "Terminate": {
    "es": "Finalizar relación",
    "ko": "관계 종료"
  },
  "No enrolled vendors yet.": {
    "es": "Todavía no hay proveedores inscritos.",
    "ko": "아직 등록된 공급업체가 없습니다."
  },
  "New Password": {
    "es": "Nueva contraseña",
    "ko": "새 비밀번호"
  },
  "Password did not matched.": {
    "es": "Las contraseñas no coinciden.",
    "ko": "비밀번호가 일치하지 않습니다."
  },
  "Password invalid. Minimum of 8 Characters": {
    "es": "Contraseña no válida. Debe tener al menos 8 caracteres.",
    "ko": "비밀번호가 올바르지 않습니다. 8자 이상 입력해 주세요."
  },
  "Client ID:": {
    "es": "ID de cliente:",
    "ko": "클라이언트 ID:"
  },
  "Client Information": {
    "es": "Información del cliente",
    "ko": "클라이언트 정보"
  },
  "Client First Name": {
    "es": "Nombre del cliente",
    "ko": "클라이언트 이름"
  },
  "Client Last Name": {
    "es": "Apellidos del cliente",
    "ko": "클라이언트 성"
  },
  "Select...": {
    "es": "Seleccione...",
    "ko": "선택해 주세요..."
  },
  "Civil Status": {
    "es": "Estado civil",
    "ko": "혼인 상태"
  },
  "Single": {
    "es": "Soltero/a",
    "ko": "미혼"
  },
  "Married": {
    "es": "Casado/a",
    "ko": "기혼"
  },
  "Divorced": {
    "es": "Divorciado/a",
    "ko": "이혼"
  },
  "Widowed": {
    "es": "Viudo/a",
    "ko": "사별"
  },
  "CA Driver's License Number": {
    "es": "Número de licencia de conducir de CA",
    "ko": "캘리포니아 운전면허 번호"
  },
  "(if any)": {
    "es": "(si corresponde)",
    "ko": "(해당하는 경우)"
  },
  "Address Information": {
    "es": "Información de dirección",
    "ko": "주소 정보"
  },
  "Street Address": {
    "es": "Dirección de la calle",
    "ko": "도로명 주소"
  },
  "Country": {
    "es": "País",
    "ko": "국가"
  },
  "Regional Center Information": {
    "es": "Información del Centro Regional",
    "ko": "Regional Center 정보"
  },
  "Service Coordinator Name": {
    "es": "Nombre del coordinador de servicios",
    "ko": "서비스 코디네이터 성명"
  },
  "Service Coordinator Email": {
    "es": "Correo electrónico del coordinador de servicios",
    "ko": "서비스 코디네이터 이메일"
  },
  "Service Coordinator Phone Number": {
    "es": "Teléfono del coordinador de servicios",
    "ko": "서비스 코디네이터 전화번호"
  },
  "Is the client under 18 years old or represented by a legal guardian?": {
    "es": "¿El cliente es menor de 18 años o está representado por un tutor legal?",
    "ko": "클라이언트가 만 18세 미만이거나 법적 보호자의 대리 지원을 받고 있나요?"
  },
  "This question is about the client receiving services, not the employee. Choose Yes if the client is under 18, or if an authorized legal representative acts for the client. Choose No if the client is 18 or older and acts on their own behalf without a legal representative. Being an adult client's parent, caregiver, or helper does not by itself establish legal authority. No is the default; check that it matches the client's situation.": {
    "es": "Esta pregunta se refiere al cliente que recibe los servicios, no al empleado. Elija Sí si el cliente es menor de 18 años o si un representante legal autorizado actúa en su nombre. Elija No si tiene 18 años o más y actúa por cuenta propia, sin representante legal. Ser padre, cuidador o ayudante de un cliente adulto no otorga por sí solo autoridad legal. La opción predeterminada es No; compruebe que corresponda a la situación del cliente.",
    "ko": "이 질문은 직원이 아니라 서비스를 받는 클라이언트에 관한 것입니다. 클라이언트가 만 18세 미만이거나 권한이 있는 법정대리인이 클라이언트를 대신하는 경우 ‘예’를 선택하세요. 만 18세 이상이며 법정대리인 없이 본인이 직접 의사결정을 하는 경우 ‘아니요’를 선택하세요. 성인 클라이언트의 부모, 돌봄 제공자 또는 조력자라는 사실만으로 법적 대리 권한이 생기는 것은 아닙니다. 기본값은 ‘아니요’이므로 클라이언트의 상황에 맞는지 확인해 주세요."
  },
  "Yes": {
    "es": "Sí",
    "ko": "예"
  },
  "No": {
    "es": "No",
    "ko": "아니요"
  },
  "Employer / Legal Representative Information": {
    "es": "Información del empleador / representante legal",
    "ko": "고용주 / 법정대리인 정보"
  },
  "Enter the person authorized to represent the client, not the employee's information. Use the representative's actual relationship and legal name. Confirm their employer title and the household employer's EIN details with BFMS before submitting.": {
    "es": "Introduzca los datos de la persona autorizada para representar al cliente, no los del empleado. Indique su relación real con el cliente y su nombre legal. Antes de enviar, confirme con BFMS su cargo como empleador y los datos del EIN del empleador doméstico.",
    "ko": "직원의 정보가 아니라 클라이언트를 대리할 권한이 있는 사람의 정보를 입력해 주세요. 실제 관계와 법적 성명을 기재하세요. 제출 전에 고용주 직함과 가정 고용주의 EIN 정보를 BFMS에 확인해 주세요."
  },
  "Relationship to Client": {
    "es": "Relación con el cliente",
    "ko": "클라이언트와의 관계"
  },
  "Parent": {
    "es": "Padre o madre",
    "ko": "부모"
  },
  "Conservator": {
    "es": "Curador legal",
    "ko": "법원이 선임한 후견인"
  },
  "Power of Attorney": {
    "es": "Apoderado legal",
    "ko": "위임장을 통한 대리인"
  },
  "Legal Representative First Name": {
    "es": "Nombre del representante legal",
    "ko": "법정대리인 이름"
  },
  "Legal Representative Last Name": {
    "es": "Apellidos del representante legal",
    "ko": "법정대리인 성"
  },
  "Title": {
    "es": "Cargo",
    "ko": "직함"
  },
  "eg. Household Employer": {
    "es": "p. ej., empleador doméstico",
    "ko": "예: 가정 고용주"
  },
  "The representative's role in this enrollment; Household Employer is an example, not the employee's job title.": {
    "es": "El cargo del representante en esta inscripción. Empleador doméstico es un ejemplo; no es el puesto del empleado.",
    "ko": "이번 등록에서 대리인이 맡는 역할입니다. ‘가정 고용주’는 예시이며 직원의 직책을 의미하지 않습니다."
  },
  "EIN Number": {
    "es": "Número EIN",
    "ko": "EIN 번호"
  },
  "Use the employer's 9-digit EIN confirmed by BFMS from the IRS record. Do not enter the employee's Social Security number.": {
    "es": "Utilice el EIN de 9 dígitos del empleador que BFMS haya confirmado con el registro del IRS. No introduzca el número de Seguro Social del empleado.",
    "ko": "IRS 기록을 바탕으로 BFMS가 확인한 고용주의 9자리 EIN을 입력해 주세요. 직원의 사회보장번호를 입력하지 마세요."
  },
  "EIN Payer Full Name": {
    "es": "Nombre legal completo del pagador asociado al EIN",
    "ko": "EIN에 등록된 지급자 법적 성명"
  },
  "Enter the legal employer/payer name associated with that EIN, as shown on the IRS confirmation. It may differ from the representative's name.": {
    "es": "Introduzca el nombre legal del empleador o pagador asociado a ese EIN, tal como aparece en la confirmación del IRS. Puede ser diferente del nombre del representante.",
    "ko": "IRS 확인서에 표시된 해당 EIN의 법적 고용주 또는 지급자 이름을 입력해 주세요. 대리인의 이름과 다를 수 있습니다."
  },
  "Proof of Legal Representation": {
    "es": "Prueba de representación legal",
    "ko": "법적 대리 권한 증빙"
  },
  "Upload the document BFMS accepts as evidence of this person's authority to act for the client, such as applicable power-of-attorney or court conservatorship paperwork. A disability diagnosis alone does not identify an authorized representative. If you are unsure which document applies, confirm with BFMS before uploading.": {
    "es": "Suba el documento que BFMS acepte como prueba de la autoridad de esta persona para actuar en nombre del cliente, como un poder notarial aplicable o una resolución judicial de tutela. Un diagnóstico de discapacidad por sí solo no identifica a un representante autorizado. Si no sabe qué documento corresponde, consulte con BFMS antes de subirlo.",
    "ko": "위임장이나 법원의 후견인 지정 서류 등, 해당 인물이 클라이언트를 대신할 권한이 있음을 입증하는 BFMS 인정 서류를 업로드해 주세요. 장애 진단만으로는 대리 권한이 있는 사람이 확인되지 않습니다. 어떤 서류가 필요한지 확실하지 않다면 업로드 전에 BFMS에 문의하세요."
  },
  "Upload / Select File": {
    "es": "Subir / seleccionar archivo",
    "ko": "파일 업로드 / 선택"
  },
  "Choose File": {
    "es": "Elegir archivo",
    "ko": "파일 선택"
  },
  "Existing file saved for ID 2:": {
    "es": "Archivo existente guardado para la identificación 2:",
    "ko": "두 번째 신분증으로 저장된 파일:"
  },
  "View current document": {
    "es": "Ver documento actual",
    "ko": "현재 서류 보기"
  },
  "General Contact Info": {
    "es": "Información general de contacto",
    "ko": "일반 연락처 정보"
  },
  "Phone Number (Optional)": {
    "es": "Teléfono (opcional)",
    "ko": "전화번호 (선택 사항)"
  },
  "Save Update Information": {
    "es": "Guardar información actualizada",
    "ko": "변경 정보 저장"
  },
  "Resources and reports are grouped here for easier access.": {
    "es": "Los recursos y los informes están agrupados aquí para facilitar el acceso.",
    "ko": "자료와 보고서를 쉽게 찾을 수 있도록 한곳에 모았습니다."
  },
  "Resources": {
    "es": "Recursos",
    "ko": "자료"
  },
  "Reports": {
    "es": "Informes",
    "ko": "보고서"
  },
  "Terms of Service Agreement": {
    "es": "Acuerdo de condiciones del servicio",
    "ko": "서비스 이용약관"
  },
  "This": {
    "es": "Este",
    "ko": "본"
  },
  "TERMS OF SERVICE AGREEMENT": {
    "es": "ACUERDO DE CONDICIONES DEL SERVICIO",
    "ko": "서비스 이용약관"
  },
  "(this \"Agreement\") is entered into by and between": {
    "es": "(el «Acuerdo») se celebra entre",
    "ko": "(이하 ‘약관’)은 다음 당사자 간에 체결됩니다:"
  },
  "Blessed FMS Inc.": {
    "es": "Blessed FMS Inc.",
    "ko": "Blessed FMS Inc."
  },
  ", a Financial Management Service company (\"Blessed FMS Inc.\") and any person who consents to this Agreement and the entity that such person represents (together, \"User\"). Each of Blessed FMS Inc. and User are referred to as a \"Party\" and are collectively referred to as the \"Parties.\"": {
    "es": ", una empresa de gestión financiera («Blessed FMS Inc.»), y toda persona que acepte este Acuerdo y la entidad que represente (conjuntamente, el «Usuario»). Blessed FMS Inc. y el Usuario se denominan individualmente «Parte» y conjuntamente «Partes».",
    "ko": ": 재무관리 서비스 회사인 Blessed FMS Inc.(이하 ‘Blessed FMS Inc.’)와 본 약관에 동의하는 개인 및 해당 개인이 대리하는 단체(통칭하여 ‘사용자’). Blessed FMS Inc.와 사용자는 각각 ‘당사자’, 함께 ‘양 당사자’라고 합니다."
  },
  "BY LOGGING INTO, ACCESSING, VIEWING, DOWNLOADING, OR OTHERWISE USING ANY PART OF BLESSED FMS INC.'S NETWORK, SYSTEMS OR RESOURCES (the \"SERVICE\"), USER EXPRESSLY AGREES TO AND CONSENTS TO BE BOUND BY ALL OF THE TERMS OF THIS AGREEMENT.": {
    "es": "AL INICIAR SESIÓN, ACCEDER, CONSULTAR, DESCARGAR O UTILIZAR CUALQUIER PARTE DE LA RED, LOS SISTEMAS O LOS RECURSOS DE BLESSED FMS INC. (EL «SERVICIO»), EL USUARIO ACEPTA EXPRESAMENTE TODOS LOS TÉRMINOS DE ESTE ACUERDO Y CONSIENTE EN QUEDAR VINCULADO POR ELLOS.",
    "ko": "사용자는 Blessed FMS Inc.의 네트워크, 시스템 또는 자원(이하 ‘서비스’)의 일부라도 로그인, 접근, 열람, 다운로드하거나 기타 방식으로 이용하는 경우, 본 약관의 모든 조항에 구속되는 데 명시적으로 동의합니다."
  },
  "1. Service Terms and Limitations": {
    "es": "1. Condiciones y limitaciones del servicio",
    "ko": "1. 서비스 이용 조건 및 제한"
  },
  "A. Description": {
    "es": "A. Descripción",
    "ko": "A. 설명"
  },
  "Blessed FMS Inc.'s network, systems, and resources (the \"Service\") is proprietary to Blessed FMS Inc. and is protected by intellectual property laws and treaties. User's access to the Service is licensed and not sold.": {
    "es": "La red, los sistemas y los recursos de Blessed FMS Inc. (el «Servicio») son propiedad de Blessed FMS Inc. y están protegidos por las leyes y los tratados de propiedad intelectual. El acceso del Usuario se concede mediante licencia, no mediante venta.",
    "ko": "Blessed FMS Inc.의 네트워크, 시스템 및 자원(이하 ‘서비스’)은 Blessed FMS Inc.의 독점적 자산이며 지식재산권 관련 법률과 조약의 보호를 받습니다. 사용자의 서비스 접근 권한은 판매가 아니라 이용 허가로 제공됩니다."
  },
  "B. Limitations": {
    "es": "B. Limitaciones",
    "ko": "B. 제한"
  },
  "User shall not:": {
    "es": "El Usuario no deberá:",
    "ko": "사용자는 다음 행위를 해서는 안 됩니다:"
  },
  "Sell, market, rent, sub-license, or license any aspect of the service": {
    "es": "Vender, comercializar, alquilar, sublicenciar o conceder licencias sobre cualquier parte del Servicio",
    "ko": "서비스의 일부를 판매, 마케팅, 임대하거나 재실시권 또는 이용권을 부여하는 행위"
  },
  "Decipher, decompile, disassemble, reverse engineer the Service": {
    "es": "Descifrar, descompilar, desensamblar o realizar ingeniería inversa del Servicio",
    "ko": "서비스를 해독, 디컴파일, 역어셈블 또는 역설계하는 행위"
  },
  "Allow unauthorized access to the Service": {
    "es": "Permitir el acceso no autorizado al Servicio",
    "ko": "서비스에 대한 무단 접근을 허용하는 행위"
  },
  "Write or develop any derivative works based upon the Service": {
    "es": "Escribir o desarrollar obras derivadas del Servicio",
    "ko": "서비스를 기반으로 2차적 저작물을 작성하거나 개발하는 행위"
  },
  "Modify, adapt, or translate the Service without prior written consent": {
    "es": "Modificar, adaptar o traducir el Servicio sin consentimiento previo por escrito",
    "ko": "사전 서면 동의 없이 서비스를 수정, 각색 또는 번역하는 행위"
  },
  "Use the Service to provide processing services to third parties": {
    "es": "Utilizar el Servicio para prestar servicios de procesamiento a terceros",
    "ko": "서비스를 이용하여 제삼자에게 처리 서비스를 제공하는 행위"
  },
  "Remove identification, patent, copyright, or trademark notices": {
    "es": "Eliminar avisos de identificación, patentes, derechos de autor o marcas comerciales",
    "ko": "식별 표시, 특허, 저작권 또는 상표 고지를 제거하는 행위"
  },
  "Circumvent any security feature of the Service": {
    "es": "Eludir cualquier función de seguridad del Servicio",
    "ko": "서비스의 보안 기능을 우회하는 행위"
  },
  "Use the Service in any manner that violates applicable law": {
    "es": "Utilizar el Servicio de forma que infrinja la legislación aplicable",
    "ko": "관련 법률을 위반하는 방식으로 서비스를 이용하는 행위"
  },
  "2. Privacy and Security": {
    "es": "2. Privacidad y seguridad",
    "ko": "2. 개인정보 보호 및 보안"
  },
  "A. Security": {
    "es": "A. Seguridad",
    "ko": "A. 보안"
  },
  "User shall be solely responsible for the security, confidentiality, and integrity of all messages, content, and other information. User agrees to bear all responsibility for the confidentiality of User's password and all use incurred from use of the Service.": {
    "es": "El Usuario será el único responsable de la seguridad, confidencialidad e integridad de todos los mensajes, contenidos y demás información. Acepta toda responsabilidad por la confidencialidad de su contraseña y por el uso del Servicio realizado con ella.",
    "ko": "사용자는 모든 메시지, 콘텐츠 및 기타 정보의 보안, 기밀성 및 무결성에 대해 단독으로 책임을 집니다. 사용자는 비밀번호의 기밀 유지와 해당 비밀번호를 통한 모든 서비스 이용에 대한 책임을 부담하는 데 동의합니다."
  },
  "B. Privacy": {
    "es": "B. Privacidad",
    "ko": "B. 개인정보 보호"
  },
  "Blessed FMS Inc. will attempt to respect User's privacy but may disclose information when necessary to:": {
    "es": "Blessed FMS Inc. procurará respetar la privacidad del Usuario, pero podrá divulgar información cuando sea necesario para:",
    "ko": "Blessed FMS Inc.는 사용자의 개인정보를 존중하기 위해 노력하지만, 다음 목적상 필요한 경우 정보를 공개할 수 있습니다:"
  },
  "Comply with legal process or governmental requirements": {
    "es": "Cumplir procesos legales o requisitos gubernamentales",
    "ko": "법적 절차 또는 정부의 요구를 준수하기 위한 경우"
  },
  "Protect and defend the rights or property of Blessed FMS Inc.": {
    "es": "Proteger y defender los derechos o la propiedad de Blessed FMS Inc.",
    "ko": "Blessed FMS Inc.의 권리 또는 재산을 보호하고 방어하기 위한 경우"
  },
  "Enforce this Agreement": {
    "es": "Hacer cumplir este Acuerdo",
    "ko": "본 약관을 집행하기 위한 경우"
  },
  "Protect the interests of other users": {
    "es": "Proteger los intereses de otros usuarios",
    "ko": "다른 사용자의 이익을 보호하기 위한 경우"
  },
  "Operate or conduct maintenance of services": {
    "es": "Operar o mantener los servicios",
    "ko": "서비스를 운영하거나 유지보수하기 위한 경우"
  },
  "C. Confidentiality": {
    "es": "C. Confidencialidad",
    "ko": "C. 기밀 유지"
  },
  "Important:": {
    "es": "Importante:",
    "ko": "중요:"
  },
  "Information accessed is protected by federal and state privacy laws, including HIPAA and FERPA. Violation may carry criminal and civil penalties.": {
    "es": "La información consultada está protegida por leyes federales y estatales de privacidad, incluidas HIPAA y FERPA. Las infracciones pueden conllevar sanciones penales y civiles.",
    "ko": "열람하는 정보는 HIPAA와 FERPA를 포함한 연방 및 주 개인정보 보호법의 보호를 받습니다. 위반 시 형사 처벌 및 민사상 책임이 발생할 수 있습니다."
  },
  "3. User Representations": {
    "es": "3. Declaraciones del Usuario",
    "ko": "3. 사용자의 진술"
  },
  "User represents and warrants that:": {
    "es": "El Usuario declara y garantiza que:",
    "ko": "사용자는 다음 사항을 진술하고 보증합니다:"
  },
  "User is over the age of eighteen (18)": {
    "es": "Es mayor de dieciocho (18) años",
    "ko": "만 18세를 초과하는 연령임"
  },
  "User has power and authority to enter into this Agreement": {
    "es": "Tiene la capacidad y la autoridad para celebrar este Acuerdo",
    "ko": "본 약관을 체결할 능력과 권한이 있음"
  },
  "All information provided is truthful, accurate, and complete": {
    "es": "Toda la información facilitada es veraz, exacta y completa",
    "ko": "제공한 모든 정보가 사실이며 정확하고 완전함"
  },
  "User shall comply with all terms and conditions": {
    "es": "Cumplirá todos los términos y condiciones",
    "ko": "모든 이용 조건을 준수할 것임"
  },
  "User has provided accurate registration information": {
    "es": "Ha proporcionado información de registro exacta",
    "ko": "정확한 가입 정보를 제공하였음"
  },
  "4. Acceptable Use": {
    "es": "4. Uso aceptable",
    "ko": "4. 허용되는 이용"
  },
  "User agrees not to use the Service to:": {
    "es": "El Usuario acepta no utilizar el Servicio para:",
    "ko": "사용자는 서비스를 다음 목적으로 이용하지 않는 데 동의합니다:"
  },
  "Violate any law or regulation": {
    "es": "Infringir leyes o reglamentos",
    "ko": "법률 또는 규정을 위반하는 행위"
  },
  "Disseminate unsolicited messages or commercial email": {
    "es": "Difundir mensajes no solicitados o correos comerciales",
    "ko": "수신자가 요청하지 않은 메시지 또는 상업용 이메일을 배포하는 행위"
  },
  "Transmit abusive, obscene, or threatening material": {
    "es": "Transmitir material abusivo, obsceno o amenazante",
    "ko": "모욕적, 음란하거나 위협적인 자료를 전송하는 행위"
  },
  "Infringe intellectual property rights": {
    "es": "Infringir derechos de propiedad intelectual",
    "ko": "지식재산권을 침해하는 행위"
  },
  "Create false identities": {
    "es": "Crear identidades falsas",
    "ko": "허위 신원을 만드는 행위"
  },
  "Interfere with or gain unauthorized access to other accounts": {
    "es": "Interferir en otras cuentas o acceder a ellas sin autorización",
    "ko": "다른 계정을 방해하거나 무단으로 접근하는 행위"
  },
  "Transmit viruses or malicious code": {
    "es": "Transmitir virus o código malicioso",
    "ko": "바이러스 또는 악성 코드를 전송하는 행위"
  },
  "Damage or impair Blessed FMS Inc.'s servers": {
    "es": "Dañar o perjudicar los servidores de Blessed FMS Inc.",
    "ko": "Blessed FMS Inc.의 서버를 손상하거나 기능을 저해하는 행위"
  },
  "5. Additional Terms": {
    "es": "5. Condiciones adicionales",
    "ko": "5. 추가 조건"
  },
  "Termination:": {
    "es": "Terminación:",
    "ko": "종료:"
  },
  "This Agreement continues until terminated. Blessed FMS Inc. reserves the right to suspend or terminate access at any time.": {
    "es": "Este Acuerdo permanecerá vigente hasta su terminación. Blessed FMS Inc. se reserva el derecho de suspender o cancelar el acceso en cualquier momento.",
    "ko": "본 약관은 종료될 때까지 유효합니다. Blessed FMS Inc.는 언제든지 접근 권한을 일시 중지하거나 종료할 권리를 보유합니다."
  },
  "Disclaimer:": {
    "es": "Exención de garantías:",
    "ko": "보증의 부인:"
  },
  "The Service is provided \"AS IS\" without warranty. Use is at User's sole risk.": {
    "es": "El Servicio se ofrece «TAL CUAL», sin garantías. El Usuario asume todos los riesgos derivados de su uso.",
    "ko": "서비스는 어떠한 보증도 없이 ‘있는 그대로’ 제공됩니다. 서비스 이용에 따른 위험은 전적으로 사용자가 부담합니다."
  },
  "Liability Limitation:": {
    "es": "Limitación de responsabilidad:",
    "ko": "책임의 제한:"
  },
  "Blessed FMS Inc.'s total liability shall not exceed $5,000.": {
    "es": "La responsabilidad total de Blessed FMS Inc. no superará los 5.000 dólares.",
    "ko": "Blessed FMS Inc.의 총책임 한도는 $5,000를 초과하지 않습니다."
  },
  "Governing Law:": {
    "es": "Legislación aplicable:",
    "ko": "준거법:"
  },
  "This Agreement is governed by the laws of the Commonwealth of Massachusetts.": {
    "es": "Este Acuerdo se rige por las leyes de la Commonwealth of Massachusetts.",
    "ko": "본 약관은 Commonwealth of Massachusetts의 법률에 따릅니다."
  },
  "I acknowledge that I have read, understood, and agree to be bound by these Terms of Service": {
    "es": "Confirmo que he leído y entendido estas condiciones del servicio y acepto quedar vinculado por ellas.",
    "ko": "본인은 이 서비스 이용약관을 읽고 이해하였으며, 그에 구속되는 데 동의합니다."
  },
  "Accept Terms": {
    "es": "Aceptar condiciones",
    "ko": "약관 동의"
  },
  "Upload File": {
    "es": "Subir archivo",
    "ko": "파일 업로드"
  },
  "Employees List": {
    "es": "Lista de empleados",
    "ko": "직원 목록"
  },
  "Separation Date": {
    "es": "Fecha de finalización de la relación laboral",
    "ko": "고용 종료일"
  },
  "credit-card": {
    "es": "credit-card",
    "ko": "credit-card"
  },
  "office": {
    "es": "office",
    "ko": "office"
  },
  "shop": {
    "es": "shop",
    "ko": "shop"
  },
  "breadcrumb": {
    "es": "breadcrumb",
    "ko": "breadcrumb"
  },
  "Pages": {
    "es": "Páginas",
    "ko": "페이지"
  },
  "Client: {0} {1}": {
    "es": "Cliente: {0} {1}",
    "ko": "클라이언트: {0} {1}"
  },
  "Current Running Time: {0} hours": {
    "es": "Tiempo transcurrido: {0} horas",
    "ko": "현재 경과 시간: {0}시간"
  },
  "PDF Preview": {
    "es": "Vista previa del PDF",
    "ko": "PDF 미리보기"
  },
  "This file cannot be previewed in the browser.": {
    "es": "Este archivo no se puede previsualizar en el navegador.",
    "ko": "브라우저에서 이 파일을 미리 볼 수 없습니다."
  },
  "Prev": {
    "es": "Anterior",
    "ko": "이전"
  },
  "Pause": {
    "es": "Pausar",
    "ko": "일시 정지"
  },
  "Next": {
    "es": "Siguiente",
    "ko": "다음"
  },
  "FMS Portal Configurator": {
    "es": "Configurador del portal FMS",
    "ko": "FMS 포털 화면 설정"
  },
  "See our dashboard options.": {
    "es": "Consulte las opciones del panel.",
    "ko": "대시보드 옵션을 확인하세요."
  },
  "Sidebar Colors": {
    "es": "Colores de la barra lateral",
    "ko": "사이드바 색상"
  },
  "Sidenav Type": {
    "es": "Tipo de menú lateral",
    "ko": "사이드바 유형"
  },
  "Choose between 2 different sidenav types.": {
    "es": "Elija entre dos tipos de menú lateral.",
    "ko": "두 가지 사이드바 유형 중에서 선택하세요."
  },
  "Transparent": {
    "es": "Transparente",
    "ko": "투명"
  },
  "White": {
    "es": "Blanco",
    "ko": "흰색"
  },
  "You can change the sidenav type just on desktop view.": {
    "es": "El tipo de menú lateral solo puede cambiarse en la vista de escritorio.",
    "ko": "사이드바 유형은 데스크톱 화면에서만 변경할 수 있습니다."
  },
  "Navbar Fixed": {
    "es": "Barra de navegación fija",
    "ko": "상단 메뉴 고정"
  },
  "© {0}, made with": {
    "es": "© {0}, creado con",
    "ko": "© {0}, 제작:"
  },
  "by": {
    "es": "por",
    "ko": "제작자:"
  },
  "for a better web.": {
    "es": "para una web mejor.",
    "ko": "더 나은 웹을 위하여."
  },
  "License": {
    "es": "Licencia",
    "ko": "라이선스"
  },
  "User Avatar": {
    "es": "Imagen del usuario",
    "ko": "사용자 프로필 이미지"
  },
  "Sign Out": {
    "es": "Cerrar sesión",
    "ko": "로그아웃"
  },
  "Switch Client": {
    "es": "Cambiar cliente",
    "ko": "클라이언트 전환"
  },
  "FMS Provider": {
    "es": "Proveedor FMS",
    "ko": "FMS 제공자"
  },
  "Toggle navigation": {
    "es": "Mostrar u ocultar navegación",
    "ko": "메뉴 열기 / 닫기"
  },
  "Enrollment": {
    "es": "Inscripción",
    "ko": "등록"
  },
  "Time Sheet": {
    "es": "Hoja de horas",
    "ko": "근무 시간표"
  },
  "Invoice Sheets": {
    "es": "Facturas",
    "ko": "청구서"
  },
  "Payroll": {
    "es": "Nómina",
    "ko": "급여"
  },
  "Message Center": {
    "es": "Centro de mensajes",
    "ko": "메시지 센터"
  },
  "main_logo": {
    "es": "main_logo",
    "ko": "main_logo"
  },
  "Portal": {
    "es": "Portal",
    "ko": "포털"
  },
  "Static": {
    "es": "Estático",
    "ko": "고정"
  },
  "Select": {
    "es": "Seleccionar",
    "ko": "선택"
  },
  "Messages": {
    "es": "Mensajes",
    "ko": "메시지"
  },
  "Enrollment Employer": {
    "es": "Empleador de esta inscripción",
    "ko": "등록 대상 고용주"
  },
  "Choose the client/employer this enrollment belongs to. Your uploads stay tied to that employer.": {
    "es": "Elija el cliente o empleador al que corresponde esta inscripción. Los archivos que suba permanecerán vinculados a ese empleador.",
    "ko": "이 등록이 적용되는 클라이언트 또는 고용주를 선택하세요. 업로드한 파일은 해당 고용주에게 연결됩니다."
  },
  "Select employer": {
    "es": "Seleccione un empleador",
    "ko": "고용주 선택"
  },
  "Loading enrollment...": {
    "es": "Cargando inscripción...",
    "ko": "등록 정보를 불러오는 중입니다..."
  },
  "Enrollment #{0}": {
    "es": "Inscripción n.º {0}",
    "ko": "등록 #{0}"
  },
  "Employer required": {
    "es": "Se requiere un empleador",
    "ko": "고용주 선택 필요"
  },
  "Government form generation is intentionally not exposed on this page yet. BFMS should only enable I-9, W-4, DE-4 and related downloads after the backend is filling the official government PDF templates rather than custom recreations.": {
    "es": "La generación de formularios oficiales aún no está disponible en esta página. BFMS solo debe habilitar las descargas de I-9, W-4, DE-4 y documentos relacionados cuando el sistema complete las plantillas PDF oficiales, en lugar de recreaciones propias.",
    "ko": "이 페이지에서는 아직 정부 양식을 생성할 수 없습니다. BFMS는 자체 제작 양식이 아니라 공식 PDF 양식에 정보를 채우는 기능이 준비된 후 I-9, W-4, DE-4 및 관련 다운로드를 활성화해야 합니다."
  },
  "Submit Invoice": {
    "es": "Enviar factura",
    "ko": "청구서 제출"
  },
  "Record the date, specific services and hours performed for your approved client. Client approval comes first; Admin then confirms the payroll details and converts the invoice into payroll. Do not submit the same work through both Invoice Sheets and Time Sheet.": {
    "es": "Registre la fecha, los servicios específicos y las horas trabajadas para su cliente aprobado. Primero aprueba el cliente; después, el administrador confirma los datos de nómina y convierte la factura en un registro de nómina. No presente el mismo trabajo en Facturas y en Hoja de horas.",
    "ko": "승인된 클라이언트에게 제공한 서비스의 날짜, 구체적인 내용 및 근무 시간을 기록하세요. 클라이언트가 먼저 승인한 후 관리자가 급여 정보를 확인하고 청구서를 급여 기록으로 전환합니다. 같은 업무를 청구서와 근무 시간표 양쪽에 중복 제출하지 마세요."
  },
  "Invoice submission is available for every approved client relationship. Applicable enrollment, clearance and EVV requirements still apply.": {
    "es": "La presentación de facturas está disponible para todas las relaciones con clientes aprobadas. Siguen siendo aplicables los requisitos de inscripción, verificación de antecedentes y EVV que correspondan.",
    "ko": "승인된 모든 클라이언트 관계에서 청구서를 제출할 수 있습니다. 해당하는 등록, 신원 조회 및 EVV 요건은 계속 적용됩니다."
  },
  "Submit service invoice": {
    "es": "Enviar factura de servicios",
    "ko": "서비스 청구서 제출"
  },
  "Select client": {
    "es": "Seleccione un cliente",
    "ko": "클라이언트 선택"
  },
  "Service date": {
    "es": "Fecha del servicio",
    "ko": "서비스 제공일"
  },
  "This client needs an active spending-plan year before invoices can be submitted.": {
    "es": "Este cliente necesita un año activo del plan de gastos para que se puedan enviar facturas.",
    "ko": "청구서를 제출하려면 이 클라이언트에게 활성 지출 계획 연차가 있어야 합니다."
  },
  "Service code": {
    "es": "Código de servicio",
    "ko": "서비스 코드"
  },
  "Select service": {
    "es": "Seleccione un servicio",
    "ko": "서비스 선택"
  },
  "Select your authorized duties in Enrollment → Service Details. The code must also be in the client's active spending plan.": {
    "es": "Seleccione sus tareas autorizadas en Inscripción → Datos del servicio. El código también debe estar incluido en el plan de gastos activo del cliente.",
    "ko": "등록 → 서비스 정보에서 승인된 업무를 선택하세요. 해당 코드가 클라이언트의 활성 지출 계획에도 포함되어 있어야 합니다."
  },
  "Hours worked": {
    "es": "Horas trabajadas",
    "ko": "근무 시간"
  },
  "Rate basis": {
    "es": "Base de la tarifa",
    "ko": "요율 기준"
  },
  "Per hour": {
    "es": "Por hora",
    "ko": "시간당"
  },
  "Per day": {
    "es": "Por día",
    "ko": "일당"
  },
  "Agreed service rate ($)": {
    "es": "Tarifa de servicio acordada ($)",
    "ko": "합의된 서비스 요율 ($)"
  },
  "Total invoice": {
    "es": "Total de la factura",
    "ko": "청구서 총액"
  },
  "One day at the agreed daily rate. Still record the actual hours worked.": {
    "es": "Un día a la tarifa diaria acordada. Registre también las horas realmente trabajadas.",
    "ko": "합의된 일당을 기준으로 하루분을 계산합니다. 실제 근무 시간도 기록해 주세요."
  },
  "Specific services / tasks performed": {
    "es": "Servicios o tareas específicos realizados",
    "ko": "구체적으로 수행한 서비스 / 업무"
  },
  "Describe the personal assistance or other authorized services delivered on this date.": {
    "es": "Describa la asistencia personal u otros servicios autorizados prestados en esta fecha.",
    "ko": "해당 날짜에 제공한 개인 지원 또는 기타 승인된 서비스 내용을 설명해 주세요."
  },
  "Supporting invoice/document (optional)": {
    "es": "Factura o documento de respaldo (opcional)",
    "ko": "증빙 청구서 / 서류 (선택 사항)"
  },
  "Maximum 10 MB. One invoice per client, service code and date; combine that day's tasks.": {
    "es": "Máximo: 10 MB. Una factura por cliente, código de servicio y fecha; reúna las tareas de ese día.",
    "ko": "최대 10MB입니다. 클라이언트, 서비스 코드 및 날짜별로 청구서 한 건을 제출하세요. 같은 날 수행한 업무는 한 건으로 합쳐 주세요."
  },
  "I certify that these services were provided to this client, reflect the work and time recorded, and agree with the authorized service agreement. I have not billed this work through payroll or another invoice.": {
    "es": "Certifico que estos servicios se prestaron a este cliente, reflejan el trabajo y el tiempo registrados y concuerdan con el acuerdo de servicios autorizado. No he facturado este trabajo mediante nómina ni en otra factura.",
    "ko": "본인은 해당 서비스를 이 클라이언트에게 실제로 제공했으며, 기록된 업무와 시간이 사실이고 승인된 서비스 계약에 부합함을 확인합니다. 이 업무를 급여 또는 다른 청구서로 중복 청구하지 않았습니다."
  },
  "Submitted": {
    "es": "Enviado",
    "ko": "제출됨"
  },
  "Client / Year": {
    "es": "Cliente / año",
    "ko": "클라이언트 / 연차"
  },
  "Code / Work": {
    "es": "Código / trabajo",
    "ko": "코드 / 업무"
  },
  "Hours": {
    "es": "Horas",
    "ko": "시간"
  },
  "Rate": {
    "es": "Tarifa",
    "ko": "요율"
  },
  "Client approval": {
    "es": "Aprobación del cliente",
    "ko": "클라이언트 승인"
  },
  "Admin approval": {
    "es": "Aprobación del administrador",
    "ko": "관리자 승인"
  },
  "Files / Action": {
    "es": "Archivos / acción",
    "ko": "파일 / 작업"
  },
  "Withdraw": {
    "es": "Retirar",
    "ko": "철회"
  },
  "No invoices for the current spending-plan year.": {
    "es": "No hay facturas para el año actual del plan de gastos.",
    "ko": "현재 지출 계획 연차에 해당하는 청구서가 없습니다."
  },
  "This message will be sent to your patient.": {
    "es": "Este mensaje se enviará a su paciente.",
    "ko": "이 메시지는 담당 환자에게 발송됩니다."
  },
  "Please specify the details of your concern.": {
    "es": "Describa los detalles de su consulta.",
    "ko": "문의 내용을 구체적으로 설명해 주세요."
  },
  "Payroll Records": {
    "es": "Registros de nómina",
    "ko": "급여 기록"
  },
  "Employee Payroll Details": {
    "es": "Detalles de nómina del empleado",
    "ko": "직원 급여 상세 내역"
  },
  "Net Pay": {
    "es": "Pago neto",
    "ko": "실수령액"
  },
  "Deductions": {
    "es": "Deducciones",
    "ko": "공제액"
  },
  "Paystub": {
    "es": "Comprobante de pago",
    "ko": "급여 명세서"
  },
  "Invoice #{0}": {
    "es": "Factura n.º {0}",
    "ko": "청구서 #{0}"
  },
  "Not available": {
    "es": "No disponible",
    "ko": "이용 불가"
  },
  "profile_image": {
    "es": "profile_image",
    "ko": "profile_image"
  },
  "Alec Thompson": {
    "es": "Alec Thompson",
    "ko": "Alec Thompson"
  },
  "CEO / Co-Founder": {
    "es": "Director ejecutivo / cofundador",
    "ko": "최고경영자 / 공동 설립자"
  },
  "App": {
    "es": "Aplicación",
    "ko": "앱"
  },
  "document": {
    "es": "documento",
    "ko": "서류"
  },
  "settings": {
    "es": "configuración",
    "ko": "설정"
  },
  "Platform Settings": {
    "es": "Configuración de la plataforma",
    "ko": "플랫폼 설정"
  },
  "Account": {
    "es": "Cuenta",
    "ko": "계정"
  },
  "Email me when someone follows me": {
    "es": "Enviarme un correo cuando alguien me siga",
    "ko": "누군가 나를 팔로우하면 이메일 받기"
  },
  "Email me when someone answers on my post": {
    "es": "Enviarme un correo cuando alguien responda a mi publicación",
    "ko": "내 게시물에 답글이 달리면 이메일 받기"
  },
  "Email me when someone mentions me": {
    "es": "Enviarme un correo cuando alguien me mencione",
    "ko": "누군가 나를 언급하면 이메일 받기"
  },
  "Application": {
    "es": "Aplicación",
    "ko": "애플리케이션"
  },
  "New launches and projects": {
    "es": "Nuevos lanzamientos y proyectos",
    "ko": "새로운 출시 및 프로젝트"
  },
  "Monthly product updates": {
    "es": "Actualizaciones mensuales del producto",
    "ko": "월간 제품 업데이트"
  },
  "Subscribe to newsletter": {
    "es": "Suscribirme al boletín",
    "ko": "뉴스레터 구독"
  },
  "Profile Information": {
    "es": "Información del perfil",
    "ko": "프로필 정보"
  },
  "Conversations": {
    "es": "Conversaciones",
    "ko": "대화"
  },
  "kal": {
    "es": "kal",
    "ko": "kal"
  },
  "Sophie B.": {
    "es": "Sophie B.",
    "ko": "Sophie B."
  },
  "Hi! I need more information..": {
    "es": "Hola. Necesito más información.",
    "ko": "안녕하세요. 자세한 정보를 알고 싶습니다."
  },
  "Reply": {
    "es": "Responder",
    "ko": "답장"
  },
  "Anne Marie": {
    "es": "Anne Marie",
    "ko": "Anne Marie"
  },
  "Awesome work, can you..": {
    "es": "Excelente trabajo, ¿podría...?",
    "ko": "훌륭한 작업입니다. 혹시 ...해 주실 수 있나요?"
  },
  "Ivanna": {
    "es": "Ivanna",
    "ko": "Ivanna"
  },
  "About files I can..": {
    "es": "Sobre los archivos, puedo...",
    "ko": "파일과 관련하여 제가 ...할 수 있습니다."
  },
  "Peterson": {
    "es": "Peterson",
    "ko": "Peterson"
  },
  "Have a great afternoon..": {
    "es": "Que tenga una buena tarde.",
    "ko": "좋은 오후 보내세요."
  },
  "Nick Daniel": {
    "es": "Nick Daniel",
    "ko": "Nick Daniel"
  },
  "Projects": {
    "es": "Proyectos",
    "ko": "프로젝트"
  },
  "Architects design houses": {
    "es": "Los arquitectos diseñan casas.",
    "ko": "건축가는 집을 설계합니다."
  },
  "Modern": {
    "es": "Moderno",
    "ko": "모던"
  },
  "Project #2": {
    "es": "Proyecto n.º 2",
    "ko": "프로젝트 #2"
  },
  "Scandinavian": {
    "es": "Escandinavo",
    "ko": "스칸디나비아"
  },
  "Project #1": {
    "es": "Proyecto n.º 1",
    "ko": "프로젝트 #1"
  },
  "Minimalist": {
    "es": "Minimalista",
    "ko": "미니멀리스트"
  },
  "Project #3": {
    "es": "Proyecto n.º 3",
    "ko": "프로젝트 #3"
  },
  "Use the reset link from your email to set a new password, or request a new one below.": {
    "es": "Utilice el enlace de restablecimiento de su correo para establecer una contraseña nueva, o solicite otro enlace a continuación.",
    "ko": "이메일의 재설정 링크를 사용하여 새 비밀번호를 설정하거나 아래에서 새 링크를 요청하세요."
  },
  "Forgot password": {
    "es": "Olvidé mi contraseña",
    "ko": "비밀번호 찾기"
  },
  "Sign in": {
    "es": "Iniciar sesión",
    "ko": "로그인"
  },
  "Soft UI Dashboard": {
    "es": "Soft UI Dashboard",
    "ko": "Soft UI Dashboard"
  },
  "waves": {
    "es": "waves",
    "ko": "waves"
  },
  "Soft UI XD الإصدار": {
    "es": "Soft UI XD الإصدار",
    "ko": "Soft UI XD الإصدار"
  },
  "Image placeholder": {
    "es": "Marcador de imagen",
    "ko": "이미지 자리 표시자"
  },
  "Welcome back": {
    "es": "Le damos la bienvenida",
    "ko": "다시 오신 것을 환영합니다"
  },
  "Enter your email and password to sign in": {
    "es": "Introduzca su correo electrónico y contraseña para iniciar sesión.",
    "ko": "이메일과 비밀번호를 입력하여 로그인하세요."
  },
  "DOWNLOAD APP": {
    "es": "DESCARGAR APLICACIÓN",
    "ko": "앱 다운로드"
  },
  "Validating your invitation...": {
    "es": "Validando su invitación...",
    "ko": "초대를 확인하는 중입니다..."
  },
  "Invalid Invitation": {
    "es": "Invitación no válida",
    "ko": "유효하지 않은 초대"
  },
  "Go to Sign In": {
    "es": "Ir al inicio de sesión",
    "ko": "로그인 화면으로 이동"
  },
  "BFMSCare Employee Registration": {
    "es": "Registro de empleados de BFMSCare",
    "ko": "BFMSCare 직원 가입"
  },
  "You've been invited to create your account.": {
    "es": "Ha recibido una invitación para crear su cuenta.",
    "ko": "계정 생성 초대를 받으셨습니다."
  },
  "ZIP Code": {
    "es": "Código postal",
    "ko": "우편번호"
  },
  "Client's UCI number": {
    "es": "Número UCI del cliente",
    "ko": "클라이언트의 UCI 번호"
  },
  "Email is pre-filled from your invitation.": {
    "es": "El correo electrónico se ha rellenado con los datos de su invitación.",
    "ko": "초대장에 등록된 이메일 주소가 자동으로 입력됩니다."
  },
  "I agree the": {
    "es": "Acepto los",
    "ko": "다음 항목에 동의합니다:"
  },
  "Terms and Conditions": {
    "es": "Términos y condiciones",
    "ko": "이용약관"
  },
  "Time Entry": {
    "es": "Registro de horas",
    "ko": "근무 시간 입력"
  },
  "Clear Filter": {
    "es": "Borrar filtros",
    "ko": "필터 초기화"
  },
  "Specifications": {
    "es": "Especificaciones",
    "ko": "세부 내용"
  },
  "Payroll Status": {
    "es": "Estado de la nómina",
    "ko": "급여 처리 상태"
  },
  "My Profile": {
    "es": "Mi perfil",
    "ko": "내 프로필"
  },
  "Home": {
    "es": "Inicio",
    "ko": "홈"
  },
  "Search": {
    "es": "Buscar",
    "ko": "검색"
  },
  "Minimize": {
    "es": "Minimizar",
    "ko": "최소화"
  },
  "28°C": {
    "es": "28 °C",
    "ko": "28°C"
  },
  "Cloudy": {
    "es": "Nublado",
    "ko": "흐림"
  },
  "image sun": {
    "es": "imagen del sol",
    "ko": "태양 이미지"
  },
  "Validation Error": {
    "es": "Error de validación",
    "ko": "입력값 확인 필요"
  },
  "Show More": {
    "es": "Mostrar más",
    "ko": "더 보기"
  },
  "img-blur-shadow": {
    "es": "img-blur-shadow",
    "ko": "img-blur-shadow"
  },
  "Check": {
    "es": "Comprobar",
    "ko": "확인"
  },
  "Full Name:": {
    "es": "Nombre completo:",
    "ko": "성명:"
  },
  "Mobile:": {
    "es": "Móvil:",
    "ko": "휴대전화:"
  },
  "Email:": {
    "es": "Correo electrónico:",
    "ko": "이메일:"
  },
  "Location:": {
    "es": "Ubicación:",
    "ko": "위치:"
  },
  "Social:": {
    "es": "Redes sociales:",
    "ko": "소셜 미디어:"
  },
  "To Do": {
    "es": "Tareas pendientes",
    "ko": "할 일"
  },
  "items": {
    "es": "elementos",
    "ko": "항목"
  },
  "Employee Documents": {
    "es": "Documentos del empleado",
    "ko": "직원 서류"
  },
  "View and download employee-required documents.": {
    "es": "Consulte y descargue los documentos obligatorios para empleados.",
    "ko": "직원 필수 서류를 확인하고 다운로드하세요."
  },
  "Loading documents...": {
    "es": "Cargando documentos...",
    "ko": "서류를 불러오는 중입니다..."
  },
  "Employment, Tax & Exemptions": {
    "es": "Empleo, impuestos y exenciones",
    "ko": "고용, 세금 및 면제"
  },
  "Information for this employer-specific enrollment.": {
    "es": "Información para esta inscripción específica del empleador.",
    "ko": "해당 고용주에 대한 등록 정보입니다."
  },
  "Employer: {0}": {
    "es": "Empleador: {0}",
    "ko": "고용주: {0}"
  },
  "Select an employer before completing this section.": {
    "es": "Seleccione un empleador antes de completar esta sección.",
    "ko": "이 항목을 작성하기 전에 고용주를 선택하세요."
  },
  "Employment": {
    "es": "Empleo",
    "ko": "고용"
  },
  "Hourly Wage": {
    "es": "Salario por hora",
    "ko": "시급"
  },
  "Pay Frequency": {
    "es": "Frecuencia de pago",
    "ko": "급여 지급 주기"
  },
  "Weekly": {
    "es": "Semanal",
    "ko": "매주"
  },
  "Bi-weekly": {
    "es": "Cada dos semanas",
    "ko": "2주마다"
  },
  "Semi-monthly": {
    "es": "Dos veces al mes",
    "ko": "월 2회"
  },
  "Monthly": {
    "es": "Mensual",
    "ko": "매월"
  },
  "Overtime Rate": {
    "es": "Tarifa de horas extra",
    "ko": "초과근무 요율"
  },
  "Job Title": {
    "es": "Puesto de trabajo",
    "ko": "직책"
  },
  "Work Location": {
    "es": "Lugar de trabajo",
    "ko": "근무 장소"
  },
  "Tax Withholding": {
    "es": "Retención de impuestos",
    "ko": "원천징수"
  },
  "Federal Filing Status": {
    "es": "Estado civil para la declaración federal",
    "ko": "연방 세금 신고 유형"
  },
  "Single or Married filing separately": {
    "es": "Soltero/a o casado/a con declaración por separado",
    "ko": "미혼 또는 부부 개별 신고"
  },
  "Married filing jointly": {
    "es": "Casado/a con declaración conjunta",
    "ko": "부부 공동 신고"
  },
  "Married, higher withholding rate": {
    "es": "Casado/a, con tasa de retención más alta",
    "ko": "기혼, 높은 원천징수율 적용"
  },
  "Head of household": {
    "es": "Cabeza de familia",
    "ko": "세대주"
  },
  "State Filing Status": {
    "es": "Estado civil para la declaración estatal",
    "ko": "주 세금 신고 유형"
  },
  "Tax Allowances": {
    "es": "Exenciones para la retención de impuestos",
    "ko": "원천징수 공제 항목 수"
  },
  "Additional Federal Withholding": {
    "es": "Retención federal adicional",
    "ko": "추가 연방 원천징수액"
  },
  "Additional State Withholding": {
    "es": "Retención estatal adicional",
    "ko": "추가 주 원천징수액"
  },
  "Exemptions & Work Requirements": {
    "es": "Exenciones y requisitos laborales",
    "ko": "면제 및 근무 요건"
  },
  "Relationship to Employer": {
    "es": "Relación con el empleador",
    "ko": "고용주와의 관계"
  },
  "Example: unrelated employee, parent, spouse": {
    "es": "Ejemplo: empleado sin parentesco, padre/madre, cónyuge",
    "ko": "예: 친족 관계가 없는 직원, 부모, 배우자"
  },
  "Live-in Employee?": {
    "es": "¿Empleado que reside con el empleador?",
    "ko": "동거 직원인가요?"
  },
  "Driving Required?": {
    "es": "¿Se requiere conducir?",
    "ko": "운전이 필요한가요?"
  },
  "Auto Insurance and Driver's License uploads will be required in the Required Documents section.": {
    "es": "Será obligatorio subir el seguro del automóvil y la licencia de conducir en la sección Documentos obligatorios.",
    "ko": "필수 서류 항목에서 자동차 보험 및 운전면허증을 업로드해야 합니다."
  },
  "Required Enrollment Documents": {
    "es": "Documentos obligatorios de inscripción",
    "ko": "등록 필수 서류"
  },
  "Upload your own documents. Your employer can see completion status only, not the source files.": {
    "es": "Suba sus propios documentos. Su empleador solo puede ver el estado de finalización, no los archivos originales.",
    "ko": "본인의 서류를 업로드하세요. 고용주는 완료 여부만 확인할 수 있으며 원본 파일은 볼 수 없습니다."
  },
  "Select an employer before uploading documents.": {
    "es": "Seleccione un empleador antes de subir documentos.",
    "ko": "서류를 업로드하기 전에 고용주를 선택하세요."
  },
  "Current file: {0}": {
    "es": "Archivo actual: {0}",
    "ko": "현재 파일: {0}"
  },
  "Enrollment Signatures": {
    "es": "Firmas de inscripción",
    "ko": "등록 서명"
  },
  "Draw your signature once, then apply it only to the form you choose below.": {
    "es": "Dibuje su firma una vez y aplíquela únicamente al formulario que elija a continuación.",
    "ko": "서명을 한 번 그린 후 아래에서 선택한 양식에만 적용하세요."
  },
  "Select an employer before signing enrollment documents.": {
    "es": "Seleccione un empleador antes de firmar los documentos de inscripción.",
    "ko": "등록 서류에 서명하기 전에 고용주를 선택하세요."
  },
  "Draw Signature": {
    "es": "Dibujar firma",
    "ko": "서명 그리기"
  },
  "Clear Signature": {
    "es": "Borrar firma",
    "ko": "서명 지우기"
  },
  "Signed By": {
    "es": "Firmante",
    "ko": "서명자"
  },
  "I intend this electronic signature to represent my signature on the specific form I choose to sign.": {
    "es": "Deseo que esta firma electrónica represente mi firma en el formulario específico que decida firmar.",
    "ko": "본인은 이 전자서명이 직접 선택하여 서명하는 특정 양식에 대한 본인의 서명을 나타내는 것임에 동의합니다."
  },
  "Form": {
    "es": "Formulario",
    "ko": "양식"
  },
  "Requirement": {
    "es": "Requisito",
    "ko": "요건"
  },
  "Signed": {
    "es": "Firmado",
    "ko": "서명 완료"
  },
  "Not Signed": {
    "es": "Sin firmar",
    "ko": "미서명"
  },
  "Payment Form": {
    "es": "Formulario de pago",
    "ko": "지급 정보 양식"
  },
  "Bank Name": {
    "es": "Nombre del banco",
    "ko": "은행명"
  },
  "Account Holder": {
    "es": "Titular de la cuenta",
    "ko": "예금주"
  },
  "Account Holder Name": {
    "es": "Nombre del titular de la cuenta",
    "ko": "예금주 성명"
  },
  "Account Type": {
    "es": "Tipo de cuenta",
    "ko": "계좌 유형"
  },
  "Routing Number": {
    "es": "Número de ruta bancaria",
    "ko": "은행 라우팅 번호"
  },
  "Account Number": {
    "es": "Número de cuenta",
    "ko": "계좌번호"
  },
  "Sample Voided Check (Image or PDF)": {
    "es": "Ejemplo de cheque anulado (imagen o PDF)",
    "ko": "무효 수표 샘플 (이미지 또는 PDF)"
  },
  "Selected file: {0}": {
    "es": "Archivo seleccionado: {0}",
    "ko": "선택한 파일: {0}"
  },
  "View Uploaded File": {
    "es": "Ver archivo subido",
    "ko": "업로드한 파일 보기"
  },
  "Uploaded Voided Check": {
    "es": "Cheque anulado subido",
    "ko": "업로드된 무효 수표"
  },
  "Unable to preview this file type.": {
    "es": "No se puede previsualizar este tipo de archivo.",
    "ko": "이 파일 형식은 미리 볼 수 없습니다."
  },
  "Update Personal Information": {
    "es": "Actualizar información personal",
    "ko": "개인정보 수정"
  },
  "Middle Name (if any)": {
    "es": "Segundo nombre (si corresponde)",
    "ko": "중간 이름 (있는 경우)"
  },
  "Single / Married": {
    "es": "Soltero/a / casado/a",
    "ko": "미혼 / 기혼"
  },
  "Other Filing Status": {
    "es": "Otro estado para la declaración",
    "ko": "기타 세금 신고 유형"
  },
  "Head of Household": {
    "es": "Cabeza de familia",
    "ko": "세대주"
  },
  "only if you’re unmarried and pay more than half the costs of keeping up a home for yourself and a qualifying individual.": {
    "es": "Solo si no está casado/a y paga más de la mitad de los gastos de mantenimiento de un hogar para usted y una persona que cumpla los requisitos.",
    "ko": "미혼이며 본인과 자격 요건에 해당하는 사람의 가정을 유지하는 데 드는 비용의 절반을 초과하여 부담하는 경우에만 해당합니다."
  },
  "Citizenship or Immigration Status": {
    "es": "Ciudadanía o situación migratoria",
    "ko": "시민권 또는 체류 신분"
  },
  "A citizen of the United States": {
    "es": "Ciudadano/a de Estados Unidos",
    "ko": "미국 시민권자"
  },
  "A noncitizen national of the United States": {
    "es": "Nacional de Estados Unidos sin ciudadanía",
    "ko": "미국 국적 비시민권자"
  },
  "A lawful permanent resident": {
    "es": "Residente permanente legal",
    "ko": "합법적 영주권자"
  },
  "An alien authorized to work until": {
    "es": "Extranjero/a con autorización para trabajar hasta",
    "ko": "외국인 취업 허가 소지자 (허가 만료일 기재)"
  },
  "USCIS or A-Number": {
    "es": "USCIS o A-Number",
    "ko": "USCIS 또는 A-Number"
  },
  "Expiry Date:": {
    "es": "Fecha de vencimiento:",
    "ko": "만료일:"
  },
  "Number (if any)": {
    "es": "Número (si corresponde)",
    "ko": "번호 (있는 경우)"
  },
  "USCIS A-Number / Form I-94 Admission Number / Foreign Passport Number and Country of Issuance": {
    "es": "A-Number de USCIS / número de admisión del formulario I-94 / número de pasaporte extranjero y país de expedición",
    "ko": "USCIS A-Number / I-94 입국 번호 / 외국 여권 번호 및 발급 국가"
  },
  "Mobile Number (if any)": {
    "es": "Número de móvil (si corresponde)",
    "ko": "휴대전화 번호 (있는 경우)"
  },
  "Phone Number (if any)": {
    "es": "Número de teléfono (si corresponde)",
    "ko": "전화번호 (있는 경우)"
  },
  "City or Town": {
    "es": "Ciudad o localidad",
    "ko": "도시 또는 지역"
  },
  "California": {
    "es": "California",
    "ko": "California"
  },
  "Texas": {
    "es": "Texas",
    "ko": "Texas"
  },
  "New York": {
    "es": "New York",
    "ko": "New York"
  },
  "Florida": {
    "es": "Florida",
    "ko": "Florida"
  },
  "Illinois": {
    "es": "Illinois",
    "ko": "Illinois"
  },
  "Save Changes": {
    "es": "Guardar cambios",
    "ko": "변경 사항 저장"
  },
  "Service List": {
    "es": "Lista de servicios",
    "ko": "서비스 목록"
  },
  "Please check all the services listed below that applies to your duty.": {
    "es": "Marque todos los servicios siguientes que correspondan a sus funciones.",
    "ko": "담당 업무에 해당하는 서비스를 모두 선택하세요."
  },
  "-- Select Service Code --": {
    "es": "-- Seleccione un código de servicio --",
    "ko": "-- 서비스 코드 선택 --"
  },
  "Start Date": {
    "es": "Fecha de inicio",
    "ko": "시작일"
  },
  "Start Time": {
    "es": "Hora de inicio",
    "ko": "시작 시간"
  },
  "End Date": {
    "es": "Fecha de finalización",
    "ko": "종료일"
  },
  "End Time": {
    "es": "Hora de finalización",
    "ko": "종료 시간"
  },
  "{0} Hrs": {
    "es": "{0} h",
    "ko": "{0}시간"
  },
  "Specifications:": {
    "es": "Especificaciones:",
    "ko": "세부 내용:"
  },
  "Please specify task done in this time entry": {
    "es": "Describa la tarea realizada durante este registro de horas.",
    "ko": "이 근무 시간에 수행한 업무를 설명해 주세요."
  },
  "Password Reset": {
    "es": "Restablecimiento de contraseña",
    "ko": "비밀번호 재설정"
  },
  "Enter your email to get your password reset": {
    "es": "Introduzca su correo electrónico para restablecer la contraseña.",
    "ko": "비밀번호를 재설정하려면 이메일을 입력하세요."
  },
  "Select Client": {
    "es": "Seleccione un cliente",
    "ko": "클라이언트 선택"
  },
  "switches": {
    "es": "switches",
    "ko": "switches"
  },
  "BFMSCare Vendor Portal": {
    "es": "Portal de proveedores de BFMSCare",
    "ko": "BFMSCare 공급업체 포털"
  },
  "Account Information": {
    "es": "Información de la cuenta",
    "ko": "계정 정보"
  },
  "Banking Information": {
    "es": "Información bancaria",
    "ko": "은행 정보"
  },
  "Payroll & Rates": {
    "es": "Nómina y tarifas",
    "ko": "급여 및 요율"
  },
  "Files": {
    "es": "Archivos",
    "ko": "파일"
  },
  "Details": {
    "es": "Detalles",
    "ko": "상세 정보"
  },
  "Enrolled Accounts": {
    "es": "Cuentas inscritas",
    "ko": "등록된 계정"
  },
  "No enrolled accounts found.": {
    "es": "No se encontraron cuentas inscritas.",
    "ko": "등록된 계정이 없습니다."
  },
  "Import Invoices": {
    "es": "Importar facturas",
    "ko": "청구서 가져오기"
  },
  "Create New Invoice": {
    "es": "Crear factura nueva",
    "ko": "새 청구서 작성"
  },
  "Submitted Date": {
    "es": "Fecha de envío",
    "ko": "제출일"
  },
  "Service Date": {
    "es": "Fecha del servicio",
    "ko": "서비스 제공일"
  },
  "Client Name": {
    "es": "Nombre del cliente",
    "ko": "클라이언트 성명"
  },
  "Service Unit": {
    "es": "Unidad de servicio",
    "ko": "서비스 단위"
  },
  "Service Rate": {
    "es": "Tarifa del servicio",
    "ko": "서비스 요율"
  },
  "Total Invoice Submitted ($)": {
    "es": "Total de la factura enviada ($)",
    "ko": "제출한 청구서 총액 ($)"
  },
  "Document Uploaded": {
    "es": "Documento subido",
    "ko": "업로드된 서류"
  },
  "Receipt File": {
    "es": "Archivo del recibo",
    "ko": "영수증 파일"
  },
  "Waiting for admin's receipt": {
    "es": "Esperando el recibo del administrador",
    "ko": "관리자의 영수증 등록 대기 중"
  },
  "Edit": {
    "es": "Editar",
    "ko": "수정"
  },
  "Edit awaiting admin approval": {
    "es": "Edición pendiente de aprobación del administrador",
    "ko": "수정 사항 관리자 승인 대기 중"
  },
  "No invoices found.": {
    "es": "No se encontraron facturas.",
    "ko": "청구서가 없습니다."
  },
  "Account Type:": {
    "es": "Tipo de cuenta:",
    "ko": "계좌 유형:"
  },
  "Savings": {
    "es": "Ahorros",
    "ko": "저축예금"
  },
  "Checking": {
    "es": "Cuenta corriente",
    "ko": "당좌예금"
  },
  "Bank Name:": {
    "es": "Nombre del banco:",
    "ko": "은행명:"
  },
  "Enter bank name": {
    "es": "Introduzca el nombre del banco.",
    "ko": "은행명을 입력해 주세요."
  },
  "Routing Number:": {
    "es": "Número de ruta bancaria:",
    "ko": "은행 라우팅 번호:"
  },
  "Enter routing number": {
    "es": "Introduzca el número de ruta bancaria.",
    "ko": "라우팅 번호를 입력해 주세요."
  },
  "Account Number:": {
    "es": "Número de cuenta:",
    "ko": "계좌번호:"
  },
  "Enter account number": {
    "es": "Introduzca el número de cuenta.",
    "ko": "계좌번호를 입력해 주세요."
  },
  "Upload Voided Check:": {
    "es": "Subir cheque anulado:",
    "ko": "무효 수표 업로드:"
  },
  "View Uploaded Check": {
    "es": "Ver cheque subido",
    "ko": "업로드한 수표 보기"
  },
  "Please fill out your payroll and rate information below.": {
    "es": "Complete sus datos de nómina y tarifas a continuación.",
    "ko": "아래에 급여 및 요율 정보를 입력해 주세요."
  },
  "Vendor Name": {
    "es": "Nombre del proveedor",
    "ko": "공급업체명"
  },
  "Enter vendor name": {
    "es": "Introduzca el nombre del proveedor.",
    "ko": "공급업체명을 입력해 주세요."
  },
  "Enter hourly rate": {
    "es": "Introduzca la tarifa por hora.",
    "ko": "시간당 요율을 입력해 주세요."
  },
  "Select frequency": {
    "es": "Seleccione la frecuencia.",
    "ko": "지급 주기를 선택해 주세요."
  },
  "Semi-Monthly": {
    "es": "Dos veces al mes",
    "ko": "월 2회"
  },
  "Biweekly": {
    "es": "Cada dos semanas",
    "ko": "2주마다"
  },
  "Reset": {
    "es": "Restablecer",
    "ko": "초기화"
  },
  "Current Saved Record": {
    "es": "Registro guardado actualmente",
    "ko": "현재 저장된 기록"
  },
  "This section shows the data currently saved on the server.": {
    "es": "Esta sección muestra los datos guardados actualmente en el servidor.",
    "ko": "현재 서버에 저장된 데이터를 보여주는 항목입니다."
  },
  "Loading saved record...": {
    "es": "Cargando el registro guardado...",
    "ko": "저장된 기록을 불러오는 중입니다..."
  },
  "Edit Information": {
    "es": "Editar información",
    "ko": "정보 수정"
  },
  "Tin": {
    "es": "TIN",
    "ko": "TIN"
  },
  "Sign Up": {
    "es": "Registrarse",
    "ko": "회원 가입"
  },
  "Vendor Registration!": {
    "es": "¡Registro de proveedores!",
    "ko": "공급업체 가입"
  },
  "Use these form to create new account.": {
    "es": "Utilice este formulario para crear una cuenta nueva.",
    "ko": "이 양식을 작성하여 새 계정을 만드세요."
  },
  "You were invited to register with this email:": {
    "es": "Se le invitó a registrarse con este correo electrónico:",
    "ko": "다음 이메일 주소로 가입 초대를 받으셨습니다:"
  },
  "First Name:": {
    "es": "Nombre:",
    "ko": "이름:"
  },
  "first name is required": {
    "es": "El nombre es obligatorio.",
    "ko": "이름을 입력해 주세요."
  },
  "Last Name:": {
    "es": "Apellidos:",
    "ko": "성:"
  },
  "last name is required": {
    "es": "Los apellidos son obligatorios.",
    "ko": "성을 입력해 주세요."
  },
  "Company Name:": {
    "es": "Nombre de la empresa:",
    "ko": "회사명:"
  },
  "company_name": {
    "es": "company_name",
    "ko": "company_name"
  },
  "mobile number": {
    "es": "número de móvil",
    "ko": "휴대전화 번호"
  },
  "mobile number is required": {
    "es": "El número de móvil es obligatorio.",
    "ko": "휴대전화 번호를 입력해 주세요."
  },
  "Phone:": {
    "es": "Teléfono:",
    "ko": "전화번호:"
  },
  "phone": {
    "es": "teléfono",
    "ko": "전화번호"
  },
  "TIN (Tax Identification Number)": {
    "es": "TIN (número de identificación fiscal)",
    "ko": "TIN (납세자 식별번호)"
  },
  "TIN Number": {
    "es": "Número TIN",
    "ko": "TIN 번호"
  },
  "Address 1:": {
    "es": "Dirección, línea 1:",
    "ko": "주소 1:"
  },
  "Enter Location": {
    "es": "Introduzca la ubicación.",
    "ko": "주소를 입력해 주세요."
  },
  "address_1": {
    "es": "address_1",
    "ko": "address_1"
  },
  "Location is required": {
    "es": "La ubicación es obligatoria.",
    "ko": "주소를 입력해 주세요."
  },
  "Address 2:": {
    "es": "Dirección, línea 2:",
    "ko": "주소 2:"
  },
  "address_2": {
    "es": "address_2",
    "ko": "address_2"
  },
  "City:": {
    "es": "Ciudad:",
    "ko": "도시:"
  },
  "city": {
    "es": "ciudad",
    "ko": "도시"
  },
  "State:": {
    "es": "Estado:",
    "ko": "주:"
  },
  "state": {
    "es": "estado",
    "ko": "주"
  },
  "ZIP Code:": {
    "es": "Código postal:",
    "ko": "우편번호:"
  },
  "zipcode": {
    "es": "código postal",
    "ko": "우편번호"
  },
  "ZIP Code is required": {
    "es": "El código postal es obligatorio.",
    "ko": "우편번호를 입력해 주세요."
  },
  "email": {
    "es": "correo electrónico",
    "ko": "이메일"
  },
  "email is required": {
    "es": "El correo electrónico es obligatorio.",
    "ko": "이메일을 입력해 주세요."
  },
  "Password:": {
    "es": "Contraseña:",
    "ko": "비밀번호:"
  },
  "password is required": {
    "es": "La contraseña es obligatoria.",
    "ko": "비밀번호를 입력해 주세요."
  },
  "password must be at least 8 characters.": {
    "es": "La contraseña debe tener al menos 8 caracteres.",
    "ko": "비밀번호는 8자 이상이어야 합니다."
  },
  "Confirm Password:": {
    "es": "Confirmar contraseña:",
    "ko": "비밀번호 확인:"
  },
  "confirm password is required": {
    "es": "La confirmación de contraseña es obligatoria.",
    "ko": "비밀번호 확인을 입력해 주세요."
  },
  "password did not match": {
    "es": "Las contraseñas no coinciden.",
    "ko": "비밀번호가 일치하지 않습니다."
  },
  "Sign up": {
    "es": "Registrarse",
    "ko": "회원 가입"
  },
  "Already have an account?": {
    "es": "¿Ya tiene una cuenta?",
    "ko": "이미 계정이 있으신가요?"
  },
  "Generate Your Signature": {
    "es": "Crear su firma",
    "ko": "서명 만들기"
  },
  "Type Signature": {
    "es": "Escribir firma",
    "ko": "서명 입력"
  },
  "Customize Style": {
    "es": "Personalizar estilo",
    "ko": "스타일 설정"
  },
  "Font Family:": {
    "es": "Tipo de letra:",
    "ko": "글꼴:"
  },
  "Font Size:": {
    "es": "Tamaño de letra:",
    "ko": "글자 크기:"
  },
  "Small": {
    "es": "Pequeño",
    "ko": "작게"
  },
  "Medium": {
    "es": "Mediano",
    "ko": "보통"
  },
  "Large": {
    "es": "Grande",
    "ko": "크게"
  },
  "Enter Your Name:": {
    "es": "Introduzca su nombre:",
    "ko": "성명을 입력해 주세요:"
  },
  "Type your name": {
    "es": "Escriba su nombre.",
    "ko": "성명을 입력해 주세요."
  },
  "Save Typed Signature": {
    "es": "Guardar firma escrita",
    "ko": "입력한 서명 저장"
  },
  "Save Drawn Signature": {
    "es": "Guardar firma dibujada",
    "ko": "그린 서명 저장"
  },
  "Drawn Signature": {
    "es": "Firma dibujada",
    "ko": "직접 그린 서명"
  },
  "W9 Form": {
    "es": "Formulario W-9",
    "ko": "W-9 양식"
  },
  "bfmscare_w9_form.pdf": {
    "es": "bfmscare_w9_form.pdf",
    "ko": "bfmscare_w9_form.pdf"
  },
  "Download PDF": {
    "es": "Descargar PDF",
    "ko": "PDF 다운로드"
  },
  "View PDF": {
    "es": "Ver PDF",
    "ko": "PDF 보기"
  },
  "Edit Invoice #{0}": {
    "es": "Editar factura n.º {0}",
    "ko": "청구서 #{0} 수정"
  },
  "Changes remain pending until an admin approves them. Your current invoice, client approval and payment status stay in effect.": {
    "es": "Los cambios permanecerán pendientes hasta que un administrador los apruebe. Mientras tanto, seguirán vigentes la factura actual, la aprobación del cliente y el estado de pago.",
    "ko": "관리자가 승인할 때까지 수정 사항은 대기 상태로 유지됩니다. 그동안 기존 청구서, 클라이언트 승인 및 지급 상태가 유지됩니다."
  },
  "Service Date From": {
    "es": "Inicio del período del servicio",
    "ko": "서비스 시작일"
  },
  "Service Date To": {
    "es": "Fin del período del servicio",
    "ko": "서비스 종료일"
  },
  "Select service code": {
    "es": "Seleccione un código de servicio.",
    "ko": "서비스 코드 선택"
  },
  "Service Rate ($)": {
    "es": "Tarifa del servicio ($)",
    "ko": "서비스 요율 ($)"
  },
  "Description / Notes": {
    "es": "Descripción / notas",
    "ko": "설명 / 메모"
  },
  "Replace Invoice Document (optional)": {
    "es": "Reemplazar documento de factura (opcional)",
    "ko": "청구서 서류 교체 (선택 사항)"
  },
  "Leave blank to keep the current document. Receipt files are managed by the admin.": {
    "es": "Déjelo en blanco para conservar el documento actual. Los archivos de recibos los gestiona el administrador.",
    "ko": "현재 서류를 유지하려면 비워 두세요. 영수증 파일은 관리자가 관리합니다."
  },
  "Tin:": {
    "es": "TIN:",
    "ko": "TIN:"
  },
  "X": {
    "es": "X",
    "ko": "X"
  },
  "Invoice Spreadsheet": {
    "es": "Hoja de cálculo de facturas",
    "ko": "청구서 스프레드시트"
  },
  "Upload .xls, .xlsx, or .csv file.": {
    "es": "Suba un archivo .xls, .xlsx o .csv.",
    "ko": ".xls, .xlsx 또는 .csv 파일을 업로드하세요."
  },
  "Import": {
    "es": "Importar",
    "ko": "가져오기"
  },
  "Invoice Information": {
    "es": "Información de la factura",
    "ko": "청구서 정보"
  },
  "Optional. You can attach one file and it will be submitted with each saved line.": {
    "es": "Opcional. Puede adjuntar un archivo que se enviará con cada línea guardada.",
    "ko": "선택 사항입니다. 파일 한 개를 첨부하면 저장된 각 항목과 함께 제출됩니다."
  },
  "Add New Line": {
    "es": "Añadir línea nueva",
    "ko": "새 항목 추가"
  },
  "New Invoice Line": {
    "es": "Línea nueva de factura",
    "ko": "새 청구서 항목"
  },
  "Optional notes for this line": {
    "es": "Notas opcionales para esta línea",
    "ko": "이 항목에 대한 메모 (선택 사항)"
  },
  "Save": {
    "es": "Guardar",
    "ko": "저장"
  },
  "Saved Invoice Lines": {
    "es": "Líneas de factura guardadas",
    "ko": "저장된 청구서 항목"
  },
  "No lines added yet.": {
    "es": "Todavía no se han añadido líneas.",
    "ko": "아직 추가된 항목이 없습니다."
  },
  "Delete": {
    "es": "Eliminar",
    "ko": "삭제"
  },
  "Total Invoice Submitted ($):": {
    "es": "Total de la factura enviada ($):",
    "ko": "제출한 청구서 총액 ($):"
  },
  "Orders Chart": {
    "es": "Gráfico de pedidos",
    "ko": "주문 차트"
  },
  "Sales Charts": {
    "es": "Gráficos de ventas",
    "ko": "매출 차트"
  },
  "Unsupported file type": {
    "es": "Tipo de archivo no compatible",
    "ko": "지원하지 않는 파일 형식"
  },
  "The guide could not start. Use Guide or Retry to try again.": {
    "es": "No se pudo iniciar la guía. Utilice Guía o Reintentar para volver a intentarlo.",
    "ko": "이용 안내를 시작하지 못했습니다. 이용 안내 또는 다시 시도를 눌러 주세요."
  },
  "Replay the Client Portal guide?": {
    "es": "¿Desea volver a ver la guía del portal del cliente?",
    "ko": "클라이언트 포털 이용 안내를 다시 보시겠어요?"
  },
  "This guide tab is unavailable. Please reload the portal and try Guide again.": {
    "es": "Esta pestaña de la guía no está disponible. Vuelva a cargar el portal e inténtelo desde Guía.",
    "ko": "안내할 메뉴를 찾을 수 없습니다. 포털을 새로고침한 후 이용 안내를 다시 실행해 주세요."
  },
  "Guide closed. Your preference could not be saved, so it may appear again next visit.": {
    "es": "La guía se ha cerrado. No se pudo guardar su preferencia, por lo que podría volver a aparecer en su próxima visita.",
    "ko": "이용 안내를 닫았습니다. 설정을 저장하지 못해 다음 방문 때 다시 표시될 수 있습니다."
  },
  "Welcome to your Client Portal": {
    "es": "Bienvenido al portal del cliente",
    "ko": "클라이언트 포털에 오신 것을 환영합니다"
  },
  "This guide walks through every sidebar tab. The arrow points to the tab being explained. Nothing will be submitted, approved or changed as you follow along.": {
    "es": "Esta guía explica todas las pestañas de la barra lateral. La flecha señala la pestaña que se está explicando. Mientras sigue la guía, no se enviará, aprobará ni modificará nada.",
    "ko": "이 안내에서는 사이드바의 모든 메뉴를 설명합니다. 화살표가 현재 설명 중인 메뉴를 가리킵니다. 안내를 보는 동안에는 어떤 항목도 제출, 승인 또는 변경되지 않습니다."
  },
  "Dashboard is your starting point. The budget summary at the top shows your authorized budget, recorded spending and available balance.": {
    "es": "El Panel de inicio es su punto de partida. El resumen superior muestra su presupuesto autorizado, los gastos registrados y el saldo disponible.",
    "ko": "대시보드는 포털의 시작 화면입니다. 상단의 예산 요약에는 승인 예산, 기록된 지출 및 사용 가능한 잔액이 표시됩니다."
  },
  "On a phone, Show budget summary expands those figures. Use the menu button to open the sidebar after this guide.": {
    "es": "En un teléfono, Mostrar resumen del presupuesto despliega esas cifras. Después de la guía, utilice el botón de menú para abrir la barra lateral.",
    "ko": "휴대폰에서는 ‘예산 요약 보기’를 누르면 해당 금액을 펼쳐 볼 수 있습니다. 안내를 마친 후 메뉴 버튼으로 사이드바를 열 수 있습니다."
  },
  "Press Next to continue, or Skip to close the guide. You can replay it from Guide whenever you need help.": {
    "es": "Pulse Siguiente para continuar u Omitir para cerrar la guía. Puede volver a verla desde Guía cuando necesite ayuda.",
    "ko": "‘다음’을 눌러 계속 보거나 ‘건너뛰기’를 눌러 닫으세요. 도움이 필요할 때 언제든 ‘이용 안내’에서 다시 볼 수 있습니다."
  },
  "Budget Monitoring": {
    "es": "Seguimiento del presupuesto",
    "ko": "예산 모니터링"
  },
  "Open Budget Monitoring to understand your current Self-Determination Program (SDP) spending-plan year. Your SDP year can differ from the calendar year or the year you joined BFMS.": {
    "es": "Abra Seguimiento del presupuesto para consultar el año actual de su plan de gastos del Self-Determination Program (SDP). El año de SDP puede ser diferente del año natural o del año en que se incorporó a BFMS.",
    "ko": "예산 모니터링에서 현재 Self-Determination Program(SDP) 지출 계획 연차를 확인하세요. SDP 연차는 달력 연도 또는 BFMS 가입 연도와 다를 수 있습니다."
  },
  "Review the plan dates, authorized budget, spending and remaining funds together.": {
    "es": "Revise conjuntamente las fechas del plan, el presupuesto autorizado, los gastos y los fondos restantes.",
    "ko": "계획 기간, 승인 예산, 지출 및 남은 예산을 함께 확인하세요."
  },
  "The three spending groups are Living Arrangements (310–330), Employment & Community Participation (331–355), and Health & Safety (356–399).": {
    "es": "Los tres grupos de gastos son Apoyo para la vida diaria (310–330), Empleo y participación comunitaria (331–355) y Salud y seguridad (356–399).",
    "ko": "지출은 일상생활 지원(310–330), 고용 및 지역사회 참여(331–355), 건강 및 안전(356–399)의 세 영역으로 나뉩니다."
  },
  "Spending Plan Files contains PDFs assigned to your current plan year. BFMS Admin maintains the plan, extensions and allocations; contact BFMS if a date, amount or file looks wrong.": {
    "es": "Archivos del plan de gastos contiene los PDF asignados al año actual del plan. El administrador de BFMS gestiona el plan, las prórrogas y las asignaciones; contacte con BFMS si alguna fecha, importe o archivo parece incorrecto.",
    "ko": "지출 계획 파일에는 현재 계획 연차에 연결된 PDF가 표시됩니다. BFMS 관리자가 계획, 연장 및 예산 배정을 관리하므로 날짜, 금액 또는 파일이 잘못된 것 같으면 BFMS에 문의하세요."
  },
  "My Expenditure helps you review the records behind your spending totals. Use it when you want to understand what a charge relates to rather than looking only at the budget summary.": {
    "es": "Mis gastos le permite revisar los registros que componen sus totales. Utilícelo para entender a qué corresponde un cargo, además de consultar el resumen del presupuesto.",
    "ko": "내 지출에서 지출 총액을 구성하는 기록을 확인할 수 있습니다. 예산 요약뿐 아니라 각 지출이 무엇에 대한 것인지 알아볼 때 이용하세요."
  },
  "Use the available filters to narrow the list, then check the service date, worker or vendor, service code and amount.": {
    "es": "Utilice los filtros disponibles para reducir la lista y compruebe la fecha del servicio, el trabajador o proveedor, el código de servicio y el importe.",
    "ko": "필터로 목록을 좁힌 후 서비스 제공일, 직원 또는 공급업체, 서비스 코드 및 금액을 확인하세요."
  },
  "Compare a record with its invoice or payment information before raising a question.": {
    "es": "Compare el registro con su factura o información de pago antes de consultar cualquier duda.",
    "ko": "문의하기 전에 해당 기록을 청구서 또는 지급 정보와 비교해 보세요."
  },
  "Client views focus on the current SDP year. BFMS Admin retains the historical records; a new year does not delete that history.": {
    "es": "Las vistas del cliente se centran en el año actual de SDP. El administrador de BFMS conserva los registros históricos; iniciar un año nuevo no elimina ese historial.",
    "ko": "클라이언트 화면에는 현재 SDP 연차의 기록을 중심으로 표시합니다. 이전 기록은 BFMS 관리자가 보관하며, 새 연차가 시작되어도 삭제되지 않습니다."
  },
  "Purchase Order": {
    "es": "Orden de compra",
    "ko": "구매 주문"
  },
  "Use Purchase Order to create and follow purchase requests for services or items. A request describes what is needed; its status tells you where it is in the review process.": {
    "es": "Utilice Orden de compra para crear y seguir solicitudes de servicios o artículos. La solicitud describe lo que necesita y su estado indica en qué fase de revisión se encuentra.",
    "ko": "구매 주문에서 서비스나 물품의 구매를 요청하고 진행 상황을 확인할 수 있습니다. 요청에는 필요한 내용을 작성하며, 상태를 통해 검토 단계를 확인할 수 있습니다."
  },
  "Check the description, service information, dates, quantities and amount before saving a request.": {
    "es": "Compruebe la descripción, los datos del servicio, las fechas, las cantidades y el importe antes de guardar la solicitud.",
    "ko": "요청을 저장하기 전에 설명, 서비스 정보, 날짜, 수량 및 금액을 확인하세요."
  },
  "Advanced View opens the details of an existing request. Review its status before making another request for the same item.": {
    "es": "Vista detallada abre los detalles de una solicitud existente. Revise su estado antes de crear otra solicitud para el mismo artículo.",
    "ko": "상세 보기를 누르면 기존 요청의 자세한 내용을 확인할 수 있습니다. 같은 물품을 다시 요청하기 전에 기존 요청의 상태를 확인하세요."
  },
  "Creating a purchase request is separate from reviewing an invoice for services already provided. Ask BFMS if you are unsure which process applies.": {
    "es": "Crear una solicitud de compra es un proceso distinto de revisar una factura por servicios ya prestados. Consulte con BFMS si no sabe qué proceso corresponde.",
    "ko": "구매 요청 작성과 이미 제공된 서비스에 대한 청구서 검토는 별도의 절차입니다. 어떤 절차를 이용해야 할지 확실하지 않으면 BFMS에 문의하세요."
  },
  "My Documents": {
    "es": "Mis documentos",
    "ko": "내 서류"
  },
  "My Documents contains your client enrollment information and documents. It is separate from the Employee Enrollment tab, which monitors the people working with you.": {
    "es": "Mis documentos contiene su información y sus documentos de inscripción como cliente. Es una sección distinta de Inscripción de empleados, que permite consultar a las personas que trabajan con usted.",
    "ko": "내 서류에는 클라이언트 본인의 등록 정보와 서류가 있습니다. 함께 일하는 직원의 등록 현황을 확인하는 ‘직원 등록’ 메뉴와는 별도입니다."
  },
  "Review Personal Information and keep your contact details accurate.": {
    "es": "Revise Información personal y mantenga actualizados sus datos de contacto.",
    "ko": "개인정보를 검토하고 연락처를 최신 상태로 유지하세요."
  },
  "Read Terms and Agreement, complete your Signature when required, and check Resource Documents for reference material.": {
    "es": "Lea Términos y acuerdo, complete su Firma cuando corresponda y consulte Documentos de referencia para ver material de ayuda.",
    "ko": "약관 및 동의를 읽고 필요한 서명을 완료하세요. 참고 자료에서 관련 문서를 확인할 수 있습니다."
  },
  "Use each form’s own save or submit action. Moving between tabs is not a substitute for saving your changes.": {
    "es": "Utilice la acción Guardar o Enviar de cada formulario. Cambiar de pestaña no guarda los cambios.",
    "ko": "각 양식의 저장 또는 제출 버튼을 사용하세요. 메뉴를 이동하는 것만으로는 변경 사항이 저장되지 않습니다."
  },
  "Employee menu": {
    "es": "Menú de empleados",
    "ko": "직원 메뉴"
  },
  "The Employee menu brings together your employee relationships, onboarding progress, service invoices, payroll records and timesheets.": {
    "es": "El menú de empleados reúne sus vínculos con trabajadores, el avance de incorporación, las facturas de servicios, los registros de nómina y las hojas de horas.",
    "ko": "직원 메뉴에서는 직원 연결 관계, 등록 진행 상황, 서비스 청구서, 급여 기록 및 근무 시간표를 관리합니다."
  },
  "Use the arrow beside Employee to expand or collapse its tabs.": {
    "es": "Utilice la flecha junto a Empleado para desplegar o contraer sus pestañas.",
    "ko": "직원 옆 화살표로 하위 메뉴를 펼치거나 접을 수 있습니다."
  },
  "Start with Employees to invite or review a worker, then Employee Enrollment to check onboarding progress.": {
    "es": "Comience en Empleados para invitar o consultar a un trabajador y, después, utilice Inscripción de empleados para revisar su incorporación.",
    "ko": "직원 메뉴에서 직원을 초대하거나 확인한 뒤 직원 등록에서 등록 진행 상황을 살펴보세요."
  },
  "Invoice Sheets and Time Sheets are different submission paths. Review the work carefully so the same service is not approved twice.": {
    "es": "Facturas y Hojas de horas son vías de presentación diferentes. Revise el trabajo para no aprobar dos veces el mismo servicio.",
    "ko": "청구서와 근무 시간표는 서로 다른 제출 경로입니다. 같은 서비스를 두 번 승인하지 않도록 업무 내용을 꼼꼼히 확인하세요."
  },
  "Employees lists the workers connected to your client account. Invitations connect a worker’s sign-up to the client who invited them.": {
    "es": "Empleados muestra los trabajadores vinculados a su cuenta. Las invitaciones vinculan el registro del trabajador con el cliente que lo invitó.",
    "ko": "직원 목록에는 회원님의 계정에 연결된 직원이 표시됩니다. 초대를 통해 직원의 가입이 초대한 클라이언트에게 연결됩니다."
  },
  "Use Invite Employee and carefully check the recipient’s email address.": {
    "es": "Utilice Invitar empleado y compruebe con cuidado el correo electrónico del destinatario.",
    "ko": "직원 초대를 누르고 받는 사람의 이메일 주소를 정확히 확인하세요."
  },
  "The worker should use that invitation and your Client’s UCI number during registration. Share the correct number directly with the worker.": {
    "es": "El trabajador debe utilizar esa invitación y el número UCI del cliente al registrarse. Comparta el número correcto directamente con él.",
    "ko": "직원은 해당 초대와 클라이언트의 UCI 번호를 사용하여 가입해야 합니다. 정확한 UCI 번호를 직원에게 직접 알려 주세요."
  },
  "Check the relationship and account status. An invitation alone does not complete onboarding or grant every work permission; contact BFMS if activation or approval is still needed.": {
    "es": "Compruebe el estado de la relación y de la cuenta. La invitación por sí sola no completa la incorporación ni concede todos los permisos; contacte con BFMS si falta activación o aprobación.",
    "ko": "연결 관계와 계정 상태를 확인하세요. 초대만으로 등록이 완료되거나 모든 근무 권한이 부여되지는 않습니다. 활성화 또는 승인이 필요하면 BFMS에 문의하세요."
  },
  "Employee Enrollment shows pending invitations and enrollment progress for connected employees. This is a status view for you; workers complete their own enrollment in the Employee Portal.": {
    "es": "Inscripción de empleados muestra las invitaciones pendientes y el avance de inscripción de los empleados vinculados. Usted consulta el estado; los trabajadores completan su inscripción en el portal del empleado.",
    "ko": "직원 등록에서는 연결된 직원의 초대 대기 및 등록 진행 상황을 확인할 수 있습니다. 클라이언트는 상태를 확인하며, 실제 등록은 직원이 직원 포털에서 직접 완료합니다."
  },
  "Pending Invitations identifies people who have not finished joining.": {
    "es": "Invitaciones pendientes identifica a quienes aún no han terminado de incorporarse.",
    "ko": "가입 대기 중인 초대에서 아직 가입을 완료하지 않은 사람을 확인할 수 있습니다."
  },
  "Review the completion and relationship status for the correct employee, and use Refresh after an update.": {
    "es": "Revise la finalización y el estado de la relación del empleado correcto. Pulse Actualizar después de un cambio.",
    "ko": "해당 직원의 등록 완료 여부와 연결 상태를 확인하세요. 변경 후에는 새로고침을 눌러 주세요."
  },
  "You see completion information rather than the employee’s sensitive source documents. Ask the employee or BFMS about missing requirements.": {
    "es": "Solo verá información de finalización, no los documentos originales confidenciales del empleado. Consulte con el empleado o BFMS sobre los requisitos que falten.",
    "ko": "직원의 민감한 원본 서류가 아니라 완료 여부만 표시됩니다. 누락된 요건은 직원 또는 BFMS에 문의하세요."
  },
  "This is where you review employee service invoices submitted for work actually provided to you. Your review comes before BFMS Admin’s final review.": {
    "es": "Aquí revisa las facturas de servicios que los empleados presentan por el trabajo que realmente le han prestado. Su revisión precede a la revisión final del administrador de BFMS.",
    "ko": "직원이 실제로 제공한 업무에 대해 제출한 서비스 청구서를 검토하는 화면입니다. 클라이언트가 검토한 후 BFMS 관리자가 최종 검토합니다."
  },
  "Check the worker, service date and code, work description, hours, rate, total and any supporting document.": {
    "es": "Compruebe el trabajador, la fecha y el código del servicio, la descripción del trabajo, las horas, la tarifa, el total y los documentos de respaldo.",
    "ko": "직원, 서비스 제공일과 코드, 업무 설명, 근무 시간, 요율, 총액 및 증빙 서류를 확인하세요."
  },
  "Approve only when the details match the service provided. Decline an incorrect submission with a clear reason so it can be addressed.": {
    "es": "Apruebe solo si los datos coinciden con el servicio recibido. Rechace una presentación incorrecta con un motivo claro para que pueda corregirse.",
    "ko": "실제로 제공받은 서비스와 일치하는 경우에만 승인하세요. 잘못된 제출은 수정할 수 있도록 명확한 사유와 함께 거절하세요."
  },
  "Client approval alone does not create a completed payment. Admin must confirm the invoice and create payroll; follow the Client review and Admin review columns.": {
    "es": "La aprobación del cliente no completa un pago. El administrador debe confirmar la factura y crear la nómina; consulte las columnas Revisión del cliente y Revisión del administrador.",
    "ko": "클라이언트 승인만으로 지급이 완료되지는 않습니다. 관리자가 청구서를 확인하고 급여 기록을 생성해야 합니다. 클라이언트 검토 및 관리자 검토 열에서 진행 상황을 확인하세요."
  },
  "Payroll lets you review payroll records connected to your employees, including records created after the invoice approval process.": {
    "es": "Nómina permite consultar los registros de sus empleados, incluidos los creados tras el proceso de aprobación de facturas.",
    "ko": "급여 메뉴에서는 청구서 승인 후 생성된 기록을 포함하여 직원의 급여 기록을 확인할 수 있습니다."
  },
  "Check the employee, applicable dates, amount and status for the record you need.": {
    "es": "Compruebe el empleado, las fechas aplicables, el importe y el estado del registro que necesite.",
    "ko": "직원, 해당 기간, 금액 및 기록의 상태를 확인하세요."
  },
  "Where a file is available, use View or Download to inspect it.": {
    "es": "Si hay un archivo disponible, utilice Ver o Descargar para consultarlo.",
    "ko": "파일이 있으면 보기 또는 다운로드를 눌러 확인하세요."
  },
  "Payroll is a record view, not a replacement for approving a pending employee invoice. A submitted invoice or your approval does not by itself mean payment has been issued.": {
    "es": "Nómina es una vista de registros y no sustituye la aprobación de una factura pendiente. Enviar una factura o aprobarla como cliente no significa por sí solo que se haya emitido el pago.",
    "ko": "급여 메뉴는 기록 조회 화면이며 대기 중인 직원 청구서 승인을 대신하지 않습니다. 청구서 제출 또는 클라이언트 승인만으로 지급이 이루어졌다는 뜻은 아닙니다."
  },
  "Time Sheets": {
    "es": "Hojas de horas",
    "ko": "근무 시간표"
  },
  "Time Sheets is where you review time-based work records. These are separate from the service invoices explained earlier.": {
    "es": "En Hojas de horas revisa los registros de trabajo por tiempo. Son distintos de las facturas de servicios explicadas anteriormente.",
    "ko": "근무 시간표에서는 근무 시간을 기준으로 한 업무 기록을 확인합니다. 앞서 설명한 서비스 청구서와는 별도입니다."
  },
  "Check the employee, service dates and code, time worked and current status before approving or declining.": {
    "es": "Compruebe el empleado, las fechas y el código del servicio, el tiempo trabajado y el estado actual antes de aprobar o rechazar.",
    "ko": "승인 또는 거절 전에 직원, 서비스 날짜와 코드, 근무 시간 및 현재 상태를 확인하세요."
  },
  "Employee Changes lets you review the available timesheet change records. Check corrections carefully before relying on an earlier total.": {
    "es": "Cambios de empleados permite consultar los cambios disponibles de las hojas de horas. Revise las correcciones antes de utilizar un total anterior.",
    "ko": "직원 변경 내역에서 근무 시간표의 변경 기록을 확인할 수 있습니다. 이전 합계를 사용하기 전에 수정 사항을 검토하세요."
  },
  "Use the date filters and PDF or Excel exports when needed. Do not approve the same work through both a timesheet and an invoice.": {
    "es": "Utilice los filtros de fecha y las exportaciones a PDF o Excel cuando los necesite. No apruebe el mismo trabajo mediante una hoja de horas y una factura.",
    "ko": "필요한 경우 날짜 필터와 PDF 또는 Excel 내보내기를 사용하세요. 같은 업무를 근무 시간표와 청구서 양쪽에서 중복 승인하지 마세요."
  },
  "Vendor menu": {
    "es": "Menú de proveedores",
    "ko": "공급업체 메뉴"
  },
  "The Vendor menu keeps vendor relationships and their submitted invoices together. Vendors use their own portal to provide invoice details and supporting files.": {
    "es": "El menú de proveedores reúne sus relaciones con proveedores y sus facturas. Los proveedores utilizan su propio portal para presentar los datos y los archivos de respaldo.",
    "ko": "공급업체 메뉴에서는 공급업체 연결 관계와 제출된 청구서를 함께 확인할 수 있습니다. 공급업체는 전용 포털에서 청구 정보와 증빙 파일을 제출합니다."
  },
  "Expand this menu to find Vendors and Vendors Invoice.": {
    "es": "Despliegue este menú para encontrar Proveedores y Facturas de proveedores.",
    "ko": "이 메뉴를 펼치면 공급업체와 공급업체 청구서 메뉴가 나타납니다."
  },
  "Use Vendors for invitations and connections; use Vendors Invoice for reviewing the services or purchases billed to you.": {
    "es": "Utilice Proveedores para invitaciones y vínculos; utilice Facturas de proveedores para revisar los servicios o compras que se le facturan.",
    "ko": "공급업체 메뉴에서 초대 및 연결을 관리하고 공급업체 청구서에서 청구된 서비스 또는 구매 내역을 검토하세요."
  },
  "An invitation is not invoice approval. Each invoice still needs its own review.": {
    "es": "Una invitación no equivale a aprobar una factura. Cada factura requiere su propia revisión.",
    "ko": "초대는 청구서 승인이 아닙니다. 각 청구서는 별도로 검토해야 합니다."
  },
  "Vendors lists providers connected to your account. Use this tab when arranging access for a provider who will submit invoices for your services.": {
    "es": "Proveedores muestra los prestadores vinculados a su cuenta. Utilice esta pestaña para gestionar el acceso de un proveedor que presentará facturas por sus servicios.",
    "ko": "공급업체 목록에는 회원님의 계정에 연결된 서비스 제공자가 표시됩니다. 서비스를 청구할 공급업체의 접근을 준비할 때 이 메뉴를 이용하세요."
  },
  "Use Invite Vendor and check that the email belongs to the intended provider.": {
    "es": "Utilice Invitar proveedor y compruebe que el correo pertenece al proveedor correcto.",
    "ko": "공급업체 초대를 누르고 올바른 업체의 이메일 주소인지 확인하세요."
  },
  "Review the connected vendor and enrollment details after the vendor completes registration.": {
    "es": "Revise los datos del proveedor vinculado y de su inscripción cuando complete el registro.",
    "ko": "공급업체가 가입을 완료한 후 연결 정보와 등록 내용을 확인하세요."
  },
  "Be careful with actions that end a relationship. Contact BFMS if you are unsure about a vendor’s connection or required paperwork.": {
    "es": "Tenga cuidado con las acciones que finalizan una relación. Consulte con BFMS si tiene dudas sobre el vínculo o los documentos necesarios de un proveedor.",
    "ko": "연결 관계를 종료하는 작업은 신중하게 진행하세요. 공급업체 연결 또는 필수 서류가 불확실하면 BFMS에 문의하세요."
  },
  "Vendors Invoice": {
    "es": "Facturas de proveedores",
    "ko": "공급업체 청구서"
  },
  "Vendors Invoice contains the invoices vendors have submitted for your review. Use the available date and sort controls to find a specific submission.": {
    "es": "Facturas de proveedores contiene las facturas enviadas para su revisión. Utilice los filtros de fecha y orden para encontrar una presentación específica.",
    "ko": "공급업체 청구서에는 검토를 요청받은 청구서가 표시됩니다. 날짜 및 정렬 기능으로 특정 제출 건을 찾을 수 있습니다."
  },
  "Open View to inspect the invoice or supporting file. Compare its date, description and total with the service or purchase.": {
    "es": "Abra Ver para consultar la factura o el archivo de respaldo. Compare su fecha, descripción y total con el servicio o la compra.",
    "ko": "보기를 눌러 청구서 또는 증빙 파일을 확인하세요. 날짜, 설명 및 총액을 실제 서비스 또는 구매 내역과 비교하세요."
  },
  "Approve correct invoices; decline an incorrect one rather than approving an amount you cannot confirm.": {
    "es": "Apruebe las facturas correctas y rechace las incorrectas en lugar de aprobar un importe que no puede confirmar.",
    "ko": "정확한 청구서만 승인하세요. 금액을 확인할 수 없거나 잘못된 청구서는 거절해 주세요."
  },
  "Your review is one part of processing the invoice. BFMS handles the remaining administrative review and payment process.": {
    "es": "Su revisión forma parte del procesamiento de la factura. BFMS se encarga de la revisión administrativa y del proceso de pago restantes.",
    "ko": "클라이언트 검토는 청구서 처리 과정의 한 단계입니다. 이후의 관리자 검토와 지급 절차는 BFMS가 진행합니다."
  },
  "Use Message Center to send BFMS a question about your account, enrollment, budget or a record you are reviewing.": {
    "es": "Utilice Centro de mensajes para consultar con BFMS sobre su cuenta, inscripción, presupuesto o un registro que esté revisando.",
    "ko": "메시지 센터에서 계정, 등록, 예산 또는 검토 중인 기록에 대해 BFMS에 문의할 수 있습니다."
  },
  "Choose a clear subject, then explain what happened and what help you need.": {
    "es": "Escriba un asunto claro y explique qué ocurrió y qué ayuda necesita.",
    "ko": "명확한 제목을 입력한 뒤 발생한 상황과 필요한 도움을 설명하세요."
  },
  "Include a useful record reference or service date when available. Do not include passwords or verification codes.": {
    "es": "Incluya una referencia del registro o la fecha del servicio cuando sea posible. No incluya contraseñas ni códigos de verificación.",
    "ko": "가능하면 기록 번호 또는 서비스 제공일을 함께 적어 주세요. 비밀번호나 인증 코드는 포함하지 마세요."
  },
  "Press the form’s Send action when ready and check its delivery result. Simply typing a message or visiting this tab does not send it.": {
    "es": "Pulse Enviar cuando esté listo y compruebe el resultado. Escribir un mensaje o abrir esta pestaña no lo envía automáticamente.",
    "ko": "작성을 마치면 보내기를 누르고 발송 결과를 확인하세요. 메시지를 입력하거나 메뉴에 방문하는 것만으로 발송되지는 않습니다."
  },
  "Account Management groups the tools for protecting your sign-in. It contains Change Password, Device Management and Settings.": {
    "es": "Gestión de la cuenta reúne las herramientas para proteger su acceso: Cambiar contraseña, Gestión de dispositivos y Configuración.",
    "ko": "계정 관리에는 로그인을 보호하기 위한 비밀번호 변경, 기기 관리 및 설정 메뉴가 있습니다."
  },
  "Change Password updates your account password.": {
    "es": "Cambiar contraseña actualiza la contraseña de su cuenta.",
    "ko": "비밀번호 변경에서 계정 비밀번호를 바꿀 수 있습니다."
  },
  "Device Management lets you recognize and remove signed-in devices.": {
    "es": "Gestión de dispositivos permite reconocer y eliminar dispositivos con sesiones abiertas.",
    "ko": "기기 관리에서 로그인한 기기를 확인하고 삭제할 수 있습니다."
  },
  "Settings controls email two-factor authentication. The next steps explain these separately so you can choose the right action.": {
    "es": "Configuración controla la autenticación de dos factores por correo electrónico. Los siguientes pasos explican estas opciones para que elija la adecuada.",
    "ko": "설정에서 이메일 2단계 인증을 관리할 수 있습니다. 다음 단계에서 각 기능을 따로 설명하므로 필요한 작업을 선택하세요."
  },
  "Use Change Password when you need to replace the password for this client account, especially if you suspect someone else knows it.": {
    "es": "Utilice Cambiar contraseña para reemplazar la contraseña de esta cuenta, especialmente si sospecha que otra persona la conoce.",
    "ko": "이 클라이언트 계정의 비밀번호를 바꾸려면 비밀번호 변경을 이용하세요. 특히 다른 사람이 비밀번호를 알고 있다고 의심될 때 변경해 주세요."
  },
  "Enter a new password that meets the form’s requirements and save it.": {
    "es": "Introduzca una contraseña nueva que cumpla los requisitos del formulario y guárdela.",
    "ko": "양식의 요건에 맞는 새 비밀번호를 입력하고 저장하세요."
  },
  "After a successful change, sign in again with the new password. Previous account sessions are invalidated.": {
    "es": "Después de cambiarla, inicie sesión con la contraseña nueva. Las sesiones anteriores de la cuenta quedarán invalidadas.",
    "ko": "변경이 완료되면 새 비밀번호로 다시 로그인하세요. 기존 계정 세션은 무효화됩니다."
  },
  "Keep your password private. BFMS will not need you to send your password or an email verification code in a message.": {
    "es": "Mantenga privada su contraseña. BFMS no necesita que envíe su contraseña ni un código de verificación por mensaje.",
    "ko": "비밀번호를 다른 사람에게 알려주지 마세요. BFMS는 메시지로 비밀번호나 이메일 인증 코드를 보내 달라고 요청하지 않습니다."
  },
  "Device Management shows general device names, browser names, device types and last activity for your tracked sessions. Device names are descriptions, not proof of who is using a device.": {
    "es": "Gestión de dispositivos muestra nombres generales, navegadores, tipos de dispositivo y actividad reciente de las sesiones registradas. Los nombres describen dispositivos; no demuestran quién los utiliza.",
    "ko": "기기 관리에는 기록된 세션의 일반적인 기기 이름, 브라우저, 기기 유형 및 최근 활동이 표시됩니다. 기기 이름은 설명일 뿐 사용자의 신원을 증명하지는 않습니다."
  },
  "Rename familiar devices so you can recognize them. Remove a device you no longer use or do not recognize; this signs out its sessions and removes its trusted status.": {
    "es": "Cambie el nombre de los dispositivos conocidos para identificarlos. Elimine los que ya no use o no reconozca; sus sesiones se cerrarán y dejarán de ser de confianza.",
    "ko": "알고 있는 기기의 이름을 바꾸면 구분하기 쉽습니다. 더 이상 사용하지 않거나 알 수 없는 기기를 삭제하면 해당 세션이 종료되고 신뢰 상태가 해제됩니다."
  },
  "Removing your current device signs you out too. An Existing session can represent older browsers sharing a session.": {
    "es": "Eliminar el dispositivo actual también cerrará su sesión. Una Sesión existente puede representar navegadores antiguos que comparten una sesión.",
    "ko": "현재 사용 중인 기기를 삭제하면 본인도 로그아웃됩니다. 기존 세션 하나가 같은 세션을 공유하는 이전 브라우저 여러 개를 나타낼 수 있습니다."
  },
  "The device list does not store IP addresses. If a device looks suspicious, review your password and keep email 2FA enabled as well.": {
    "es": "La lista de dispositivos no guarda direcciones IP. Si alguno parece sospechoso, revise su contraseña y mantenga activada la autenticación de dos factores por correo electrónico.",
    "ko": "기기 목록에는 IP 주소가 저장되지 않습니다. 의심스러운 기기가 보이면 비밀번호를 확인하고 이메일 2단계 인증도 켜 두세요."
  },
  "Settings controls email two-factor authentication for ordinary account-password sign-ins. When enabled, a new device needs a code sent to your account email; verified devices stay trusted.": {
    "es": "Configuración controla la autenticación de dos factores de los inicios de sesión con la contraseña habitual. Cuando está activada, los dispositivos nuevos necesitan un código por correo; los verificados siguen siendo de confianza.",
    "ko": "설정에서 일반 계정 비밀번호 로그인에 적용되는 이메일 2단계 인증을 관리합니다. 켜져 있으면 새 기기는 계정 이메일로 받은 코드가 필요하며, 인증된 기기는 신뢰 상태를 유지합니다."
  },
  "Follow the on-screen confirmation process when changing this setting.": {
    "es": "Siga el proceso de confirmación que aparece en pantalla para cambiar esta opción.",
    "ko": "설정을 변경하려면 화면에 표시되는 확인 절차를 진행하세요."
  },
  "Turning 2FA off allows a correct account password to sign in from a new device without an email code. Device tracking and removal still work.": {
    "es": "Desactivar la autenticación de dos factores permite iniciar sesión desde un dispositivo nuevo con la contraseña correcta, sin código por correo. El registro y la eliminación de dispositivos siguen funcionando.",
    "ko": "2단계 인증을 끄면 새 기기에서도 이메일 코드 없이 올바른 비밀번호로 로그인할 수 있습니다. 기기 기록과 삭제 기능은 계속 작동합니다."
  },
  "Keep access to your account email and never share verification codes. Contact BFMS if you cannot receive a required code.": {
    "es": "Mantenga el acceso al correo de su cuenta y no comparta códigos de verificación. Contacte con BFMS si no puede recibir un código necesario.",
    "ko": "계정 이메일에 계속 접근할 수 있도록 관리하고 인증 코드를 공유하지 마세요. 필요한 코드를 받을 수 없다면 BFMS에 문의하세요."
  },
  "Guide — replay any time": {
    "es": "Guía: vuelva a verla cuando quiera",
    "ko": "이용 안내 — 언제든 다시 보기"
  },
  "This question-mark button reopens the Client Portal guide when you need a reminder. You do not need to wait for a new account or a new browser.": {
    "es": "Este botón con un signo de interrogación vuelve a abrir la guía del portal cuando necesita recordarla. No es necesario crear otra cuenta ni utilizar otro navegador.",
    "ko": "물음표 버튼을 누르면 필요할 때 클라이언트 포털 이용 안내를 다시 볼 수 있습니다. 새 계정이나 새 브라우저를 사용할 필요가 없습니다."
  },
  "Press Guide, then answer “Replay the Client Portal guide?” with Yes to begin or No to keep working.": {
    "es": "Pulse Guía y responda Sí a «¿Desea volver a ver la guía del portal del cliente?» para comenzar, o No para seguir trabajando.",
    "ko": "이용 안내를 누른 뒤 ‘클라이언트 포털 이용 안내를 다시 보시겠어요?’에서 ‘예’를 선택하면 시작됩니다. 계속 작업하려면 ‘아니요’를 선택하세요."
  },
  "You can stop any replay with Skip or the Escape key.": {
    "es": "Puede detener la guía con Omitir o con la tecla Escape.",
    "ko": "건너뛰기 또는 Escape 키로 언제든 안내를 중단할 수 있습니다."
  },
  "Finishing or skipping the first guide is remembered for your client account across browsers. The guide only explains the tabs; it never approves records or sends forms for you.": {
    "es": "El sistema recuerda en su cuenta si ha terminado u omitido la primera guía, incluso en otros navegadores. La guía solo explica las pestañas; nunca aprueba registros ni envía formularios por usted.",
    "ko": "첫 안내를 완료하거나 건너뛴 기록은 클라이언트 계정에 저장되어 다른 브라우저에서도 유지됩니다. 안내는 메뉴를 설명할 뿐 기록을 승인하거나 양식을 대신 제출하지 않습니다."
  },
  "Logout and finish": {
    "es": "Cerrar sesión y finalizar",
    "ko": "로그아웃 및 마무리"
  },
  "Use Logout when you have finished, especially on a shared computer. Signing out is different from removing a trusted device.": {
    "es": "Utilice Cerrar sesión al terminar, sobre todo en un equipo compartido. Cerrar sesión es distinto de eliminar un dispositivo de confianza.",
    "ko": "특히 공용 컴퓨터에서는 사용을 마친 후 로그아웃하세요. 로그아웃과 신뢰 기기 삭제는 서로 다른 작업입니다."
  },
  "Confirm Logout to end your current session. Your other devices can remain signed in.": {
    "es": "Confirme Cerrar sesión para finalizar la sesión actual. Los demás dispositivos pueden seguir conectados.",
    "ko": "로그아웃을 확인하면 현재 세션이 종료됩니다. 다른 기기의 로그인은 유지될 수 있습니다."
  },
  "To remove a device’s trusted status as well, use Device Management.": {
    "es": "Para eliminar también la confianza de un dispositivo, utilice Gestión de dispositivos.",
    "ko": "기기의 신뢰 상태까지 해제하려면 기기 관리를 이용하세요."
  },
  "You are ready to explore. Press Finish to close this guide and return to the same page. Guide remains available in the sidebar.": {
    "es": "Ya puede explorar el portal. Pulse Finalizar para cerrar la guía y volver a la misma página. Guía seguirá disponible en la barra lateral.",
    "ko": "이제 포털을 이용하실 준비가 되었습니다. 완료를 누르면 안내를 닫고 원래 페이지로 돌아갑니다. 이용 안내는 사이드바에서 계속 사용할 수 있습니다."
  },
  "Please complete required fields.": {
    "es": "Complete los campos obligatorios.",
    "ko": "필수 항목을 입력해 주세요."
  },
  "Employee was added": {
    "es": "Se ha añadido el empleado.",
    "ko": "직원이 추가되었습니다."
  },
  "Error Processing your request.": {
    "es": "Error al procesar su solicitud.",
    "ko": "요청을 처리하는 중 오류가 발생했습니다."
  },
  "saving data.": {
    "es": "Guardando datos.",
    "ko": "데이터를 저장하는 중입니다."
  },
  "Failed to add employee.": {
    "es": "No se pudo añadir al empleado.",
    "ko": "직원을 추가하지 못했습니다."
  },
  "Please wait...": {
    "es": "Espere un momento...",
    "ko": "잠시 기다려 주세요..."
  },
  "Please wait while the file is being uploaded.": {
    "es": "Espere mientras se sube el archivo.",
    "ko": "파일을 업로드하는 동안 기다려 주세요."
  },
  "My Invoices": {
    "es": "Mis facturas",
    "ko": "내 청구서"
  },
  "Could not sign out this server session": {
    "es": "No se pudo cerrar esta sesión del servidor.",
    "ko": "이 서버 세션을 종료하지 못했습니다."
  },
  "Please try again, or remove this device in Device Management.": {
    "es": "Vuelva a intentarlo o elimine este dispositivo en Gestión de dispositivos.",
    "ko": "다시 시도하거나 기기 관리에서 이 기기를 삭제해 주세요."
  },
  "Account is not yet active.": {
    "es": "La cuenta todavía no está activa.",
    "ko": "계정이 아직 활성화되지 않았습니다."
  },
  "Could not verify this device. Please try again.": {
    "es": "No se pudo verificar este dispositivo. Vuelva a intentarlo.",
    "ko": "이 기기를 인증하지 못했습니다. 다시 시도해 주세요."
  },
  "Could not resend the code. Please try again.": {
    "es": "No se pudo reenviar el código. Vuelva a intentarlo.",
    "ko": "코드를 다시 보내지 못했습니다. 다시 시도해 주세요."
  },
  "inactive": {
    "es": "inactivo",
    "ko": "비활성"
  },
  "not active": {
    "es": "no activo",
    "ko": "비활성"
  },
  "not yet active": {
    "es": "aún no activo",
    "ko": "아직 비활성"
  },
  "Sign-in could not be completed. Please try again.": {
    "es": "No se pudo completar el inicio de sesión. Vuelva a intentarlo.",
    "ko": "로그인을 완료하지 못했습니다. 다시 시도해 주세요."
  },
  "Registration was submitted": {
    "es": "Se ha enviado la inscripción.",
    "ko": "가입 신청이 제출되었습니다."
  },
  "An error occurred. Please try again.": {
    "es": "Se ha producido un error. Vuelva a intentarlo.",
    "ko": "오류가 발생했습니다. 다시 시도해 주세요."
  },
  "EMPLOYEE REGISTRATION": {
    "es": "REGISTRO DE EMPLEADOS",
    "ko": "직원 가입"
  },
  "VENDOR REGISTRATION": {
    "es": "REGISTRO DE PROVEEDORES",
    "ko": "공급업체 가입"
  },
  "ACCOUNT REGISTRATION": {
    "es": "REGISTRO DE CUENTA",
    "ko": "계정 가입"
  },
  "Invalid invitation link.": {
    "es": "Enlace de invitación no válido.",
    "ko": "유효하지 않은 초대 링크입니다."
  },
  "This invitation link is invalid or has already been used.": {
    "es": "Su factura está pendiente de aprobación del cliente.",
    "ko": "클라이언트의 청구서 승인을 기다리고 있습니다."
  },
  "Unable to validate this invitation link. Please try again later.": {
    "es": "No se pudo validar esta invitación. Vuelva a intentarlo más tarde.",
    "ko": "초대 링크를 확인하지 못했습니다. 나중에 다시 시도해 주세요."
  },
  "Creating your account...": {
    "es": "Creando su cuenta...",
    "ko": "계정을 생성하는 중입니다..."
  },
  "Registration completed successfully.": {
    "es": "El registro se ha completado correctamente.",
    "ko": "가입이 완료되었습니다."
  },
  "Your account is pending admin activation.": {
    "es": "Su cuenta está pendiente de activación por el administrador.",
    "ko": "관리자의 계정 활성화를 기다리고 있습니다."
  },
  "Unable to complete registration.": {
    "es": "No se pudo completar el registro.",
    "ko": "가입을 완료하지 못했습니다."
  },
  "Check your email for your new password": {
    "es": "Revise su correo electrónico para consultar la nueva contraseña.",
    "ko": "이메일에서 새 비밀번호를 확인해 주세요."
  },
  "Could not complete this request. Please try again.": {
    "es": "No se pudo completar esta solicitud. Vuelva a intentarlo.",
    "ko": "요청을 완료하지 못했습니다. 다시 시도해 주세요."
  },
  "Two-factor authentication is off.": {
    "es": "La autenticación de dos factores está desactivada.",
    "ko": "2단계 인증이 꺼졌습니다."
  },
  "Two-factor authentication is on.": {
    "es": "La autenticación de dos factores está activada.",
    "ko": "2단계 인증이 켜졌습니다."
  },
  "Administrator session verified.": {
    "es": "Sesión de administrador verificada.",
    "ko": "관리자 세션이 인증되었습니다."
  },
  "This device is verified.": {
    "es": "Este dispositivo está verificado.",
    "ko": "이 기기가 인증되었습니다."
  },
  "Rename device": {
    "es": "Cambiar el nombre del dispositivo",
    "ko": "기기 이름 변경"
  },
  "Enter a device name.": {
    "es": "Introduzca un nombre para el dispositivo.",
    "ko": "기기 이름을 입력해 주세요."
  },
  "Remove this device?": {
    "es": "¿Desea eliminar este dispositivo?",
    "ko": "이 기기를 삭제하시겠어요?"
  },
  "This will sign you out of this device.": {
    "es": "Se cerrará la sesión en este dispositivo.",
    "ko": "이 기기에서 로그아웃됩니다."
  },
  "Its active sessions will be signed out.": {
    "es": "Se cerrarán sus sesiones activas.",
    "ko": "해당 기기의 활성 세션이 종료됩니다."
  },
  "Remove device": {
    "es": "Eliminar dispositivo",
    "ko": "기기 삭제"
  },
  "Device removed. Its sessions can no longer access your account.": {
    "es": "Dispositivo eliminado. Sus sesiones ya no pueden acceder a su cuenta.",
    "ko": "기기가 삭제되었습니다. 해당 세션에서는 더 이상 계정에 접근할 수 없습니다."
  },
  "Not recorded": {
    "es": "Sin registro",
    "ko": "기록 없음"
  },
  "Living Arrangements": {
    "es": "Apoyo para la vida diaria",
    "ko": "일상생활 지원"
  },
  "Employment & Community Participation": {
    "es": "Empleo y participación comunitaria",
    "ko": "고용 및 지역사회 참여"
  },
  "Health & Safety": {
    "es": "Salud y seguridad",
    "ko": "건강 및 안전"
  },
  "Budget Distribution": {
    "es": "Distribución del presupuesto",
    "ko": "예산 배분"
  },
  "ID Copy": {
    "es": "Copia de identificación",
    "ko": "신분증 사본"
  },
  "Social Security Card": {
    "es": "Tarjeta de Seguro Social",
    "ko": "사회보장카드"
  },
  "Live Scan": {
    "es": "Live Scan",
    "ko": "Live Scan"
  },
  "Government Approval": {
    "es": "Aprobación gubernamental",
    "ko": "정부 기관 승인"
  },
  "Identification Number": {
    "es": "Número de identificación",
    "ko": "식별번호"
  },
  "Auto Insurance": {
    "es": "Seguro del automóvil",
    "ko": "자동차 보험"
  },
  "Driver's License": {
    "es": "Licencia de conducir",
    "ko": "운전면허증"
  },
  "Could not load employee enrollment status.": {
    "es": "No se pudo cargar el estado de inscripción de los empleados.",
    "ko": "직원 등록 현황을 불러오지 못했습니다."
  },
  "Enter the employee email address. The employee will complete their own enrollment and document uploads.": {
    "es": "Introduzca el correo electrónico del empleado. El empleado completará su inscripción y subirá sus propios documentos.",
    "ko": "직원의 이메일 주소를 입력하세요. 직원이 직접 등록하고 서류를 업로드합니다."
  },
  "Send Invitation": {
    "es": "Enviar invitación",
    "ko": "초대 보내기"
  },
  "Please enter an email address.": {
    "es": "Introduzca un correo electrónico.",
    "ko": "이메일 주소를 입력해 주세요."
  },
  "Sending invitation...": {
    "es": "Enviando invitación...",
    "ko": "초대를 보내는 중입니다..."
  },
  "Invitation created": {
    "es": "Invitación creada",
    "ko": "초대 생성 완료"
  },
  "{0} Manual signup link: {1}": {
    "es": "{0} Enlace de registro manual: {1}",
    "ko": "{0} 수동 가입 링크: {1}"
  },
  "Email delivery failed.": {
    "es": "No se pudo entregar el correo electrónico.",
    "ko": "이메일을 전달하지 못했습니다."
  },
  "Invitation sent": {
    "es": "Invitación enviada",
    "ko": "초대 발송 완료"
  },
  "Invitation sent to {0}": {
    "es": "Invitación enviada a {0}",
    "ko": "{0}(으)로 초대를 보냈습니다."
  },
  "Invitation failed": {
    "es": "No se pudo enviar la invitación",
    "ko": "초대 발송 실패"
  },
  "Could not send the invitation.": {
    "es": "No se pudo enviar la invitación.",
    "ko": "초대를 보내지 못했습니다."
  },
  "Not Started": {
    "es": "Sin iniciar",
    "ko": "시작 전"
  },
  "rejected": {
    "es": "rechazado",
    "ko": "거절됨"
  },
  "Pending for approval": {
    "es": "Pendiente de aprobación",
    "ko": "승인 대기 중"
  },
  "approved": {
    "es": "aprobado",
    "ko": "승인됨"
  },
  "Rejected": {
    "es": "Rechazado",
    "ko": "거절됨"
  },
  "Not Submitted": {
    "es": "Sin enviar",
    "ko": "미제출"
  },
  "Could not complete the request. Please retry.": {
    "es": "No se pudo completar la solicitud. Vuelva a intentarlo.",
    "ko": "요청을 완료하지 못했습니다. 다시 시도해 주세요."
  },
  "Approve these services?": {
    "es": "¿Desea aprobar estos servicios?",
    "ko": "이 서비스를 승인하시겠어요?"
  },
  "Decline this invoice?": {
    "es": "¿Desea rechazar esta factura?",
    "ko": "이 청구서를 거절하시겠어요?"
  },
  "Confirm the described services, hours and amount were provided as agreed. BFMS admin must still approve payment.": {
    "es": "Confirme que los servicios, las horas y el importe descritos corresponden a lo acordado y realmente prestado. El administrador de BFMS todavía debe aprobar el pago.",
    "ko": "기재된 서비스, 근무 시간 및 금액이 합의한 내용에 따라 실제 제공된 것인지 확인하세요. 지급을 진행하려면 BFMS 관리자의 승인도 필요합니다."
  },
  "Reason for declining": {
    "es": "Motivo del rechazo",
    "ko": "거절 사유"
  },
  "Enter a reason.": {
    "es": "Introduzca un motivo.",
    "ko": "사유를 입력해 주세요."
  },
  "Could not review invoice": {
    "es": "No se pudo revisar la factura",
    "ko": "청구서 검토 실패"
  },
  "Could not download": {
    "es": "No se pudo descargar",
    "ko": "다운로드 실패"
  },
  "Are you sure you want to send this message?": {
    "es": "¿Seguro que desea enviar este mensaje?",
    "ko": "이 메시지를 보내시겠어요?"
  },
  "Yes, send it!": {
    "es": "Sí, enviar",
    "ko": "예, 보냅니다"
  },
  "Failed to send email": {
    "es": "No se pudo enviar el correo electrónico.",
    "ko": "이메일을 보내지 못했습니다."
  },
  "Email sending cancelled": {
    "es": "Se ha cancelado el envío del correo.",
    "ko": "이메일 발송이 취소되었습니다."
  },
  "Downloading file": {
    "es": "Descargando archivo",
    "ko": "파일 다운로드 중"
  },
  "Please wait while the file is being downloaded...": {
    "es": "Espere mientras se descarga el archivo...",
    "ko": "파일을 다운로드하는 동안 기다려 주세요..."
  },
  "Download completed": {
    "es": "Descarga completada",
    "ko": "다운로드 완료"
  },
  "Download error": {
    "es": "Error de descarga",
    "ko": "다운로드 오류"
  },
  "An error occurred while downloading the file.": {
    "es": "Se ha producido un error al descargar el archivo.",
    "ko": "파일을 다운로드하는 중 오류가 발생했습니다."
  },
  "No date": {
    "es": "Sin fecha",
    "ko": "날짜 없음"
  },
  "pending": {
    "es": "pendiente",
    "ko": "대기 중"
  },
  "No store": {
    "es": "Sin tienda",
    "ko": "판매처 없음"
  },
  "Best Buy": {
    "es": "Best Buy",
    "ko": "Best Buy"
  },
  "External link": {
    "es": "Enlace externo",
    "ko": "외부 링크"
  },
  "Purchase Request Details": {
    "es": "Detalles de la solicitud de compra",
    "ko": "구매 요청 상세 정보"
  },
  "No description": {
    "es": "Sin descripción",
    "ko": "설명 없음"
  },
  "Purchase Request Updated!": {
    "es": "¡Solicitud de compra actualizada!",
    "ko": "구매 요청이 수정되었습니다!"
  },
  "Purchase Request Created!": {
    "es": "¡Solicitud de compra creada!",
    "ko": "구매 요청이 생성되었습니다!"
  },
  "Error Saving Request": {
    "es": "Error al guardar la solicitud",
    "ko": "요청 저장 오류"
  },
  "Something went wrong.": {
    "es": "Algo ha salido mal.",
    "ko": "문제가 발생했습니다."
  },
  "Are you sure?": {
    "es": "¿Está seguro/a?",
    "ko": "계속 진행하시겠어요?"
  },
  "This action cannot be undone.": {
    "es": "Esta acción no se puede deshacer.",
    "ko": "이 작업은 되돌릴 수 없습니다."
  },
  "Yes, delete it!": {
    "es": "Sí, eliminar",
    "ko": "예, 삭제합니다"
  },
  "Purchase request deleted successfully.": {
    "es": "La solicitud de compra se ha eliminado correctamente.",
    "ko": "구매 요청이 삭제되었습니다."
  },
  "Error Deleting": {
    "es": "Error al eliminar",
    "ko": "삭제 오류"
  },
  "Failed to delete the request.": {
    "es": "No se pudo eliminar la solicitud.",
    "ko": "요청을 삭제하지 못했습니다."
  },
  "Could not load resources": {
    "es": "No se pudieron cargar los recursos",
    "ko": "자료 불러오기 실패"
  },
  "Please try again later.": {
    "es": "Vuelva a intentarlo más tarde.",
    "ko": "나중에 다시 시도해 주세요."
  },
  "No file available": {
    "es": "No hay archivo disponible",
    "ko": "파일 없음"
  },
  "This resource does not have a valid file URL.": {
    "es": "Este recurso no tiene una URL de archivo válida.",
    "ko": "이 자료에 유효한 파일 URL이 없습니다."
  },
  "Loading preview...": {
    "es": "Cargando vista previa...",
    "ko": "미리보기를 불러오는 중입니다..."
  },
  "this file type": {
    "es": "este tipo de archivo",
    "ko": "이 파일 형식"
  },
  "Preview failed": {
    "es": "Error de vista previa",
    "ko": "미리보기 실패"
  },
  "Could not load this file. Please try downloading it instead.": {
    "es": "No se pudo cargar este archivo. Pruebe a descargarlo.",
    "ko": "이 파일을 불러오지 못했습니다. 다운로드하여 확인해 주세요."
  },
  "Download failed": {
    "es": "Error de descarga",
    "ko": "다운로드 실패"
  },
  "Could not download this file.": {
    "es": "No se pudo descargar este archivo.",
    "ko": "이 파일을 다운로드하지 못했습니다."
  },
  "Failed to submit signature": {
    "es": "No se pudo enviar la firma.",
    "ko": "서명을 제출하지 못했습니다."
  },
  "Unknown error": {
    "es": "Error desconocido",
    "ko": "알 수 없는 오류"
  },
  "Unable to load expenditure records. Please try again.": {
    "es": "No se pudieron cargar los gastos. Vuelva a intentarlo.",
    "ko": "지출 기록을 불러오지 못했습니다. 다시 시도해 주세요."
  },
  "active": {
    "es": "activo",
    "ko": "활성"
  },
  "Could not load employee changes": {
    "es": "No se pudieron cargar los cambios de empleados.",
    "ko": "직원 변경 내역을 불러오지 못했습니다."
  },
  "Please try again.": {
    "es": "Vuelva a intentarlo.",
    "ko": "다시 시도해 주세요."
  },
  "Revert this change?": {
    "es": "¿Desea revertir este cambio?",
    "ko": "이 변경을 되돌리시겠어요?"
  },
  "This will restore the original timesheet values.": {
    "es": "Se restaurarán los valores originales de la hoja de horas.",
    "ko": "근무 시간표가 변경 전 값으로 복원됩니다."
  },
  "Admin reason": {
    "es": "Motivo del administrador",
    "ko": "관리자 사유"
  },
  "Reason for reverting this employee change": {
    "es": "Motivo para revertir este cambio del empleado",
    "ko": "직원 변경 내역을 되돌리는 사유"
  },
  "Admin reason is required.": {
    "es": "El motivo del administrador es obligatorio.",
    "ko": "관리자 사유를 입력해 주세요."
  },
  "The employee change has been reverted.": {
    "es": "Se ha revertido el cambio del empleado.",
    "ko": "직원의 변경 사항을 되돌렸습니다."
  },
  "Revert failed": {
    "es": "No se pudo revertir",
    "ko": "되돌리기 실패"
  },
  "Are you sure you want to decline this?": {
    "es": "¿Seguro que desea rechazarlo?",
    "ko": "거절하시겠어요?"
  },
  "Are you sure you want to approve this timesheet?": {
    "es": "¿Seguro que desea aprobar esta hoja de horas?",
    "ko": "이 근무 시간표를 승인하시겠어요?"
  },
  "You won't be able to revert this!": {
    "es": "No podrá revertir esta acción.",
    "ko": "이 작업은 되돌릴 수 없습니다."
  },
  "timesheet approved": {
    "es": "Hoja de horas aprobada",
    "ko": "근무 시간표가 승인되었습니다."
  },
  "No specifications": {
    "es": "Sin especificaciones",
    "ko": "세부 내용 없음"
  },
  "Could not open file": {
    "es": "No se pudo abrir el archivo",
    "ko": "파일 열기 실패"
  },
  "Do you want to approve this invoice?": {
    "es": "¿Desea aprobar esta factura?",
    "ko": "이 청구서를 승인하시겠어요?"
  },
  "Yes, approve it!": {
    "es": "Sí, aprobar",
    "ko": "예, 승인합니다"
  },
  "Invoice Approved": {
    "es": "Factura aprobada",
    "ko": "청구서 승인 완료"
  },
  "The invoice has been successfully approved.": {
    "es": "La factura se ha aprobado correctamente.",
    "ko": "청구서가 승인되었습니다."
  },
  "Approval Failed": {
    "es": "Error de aprobación",
    "ko": "승인 실패"
  },
  "An error occurred while approving the invoice.": {
    "es": "Se ha producido un error al aprobar la factura.",
    "ko": "청구서를 승인하는 중 오류가 발생했습니다."
  },
  "Failed to approve the invoice. Please try again later.": {
    "es": "No se pudo aprobar la factura. Vuelva a intentarlo más tarde.",
    "ko": "청구서를 승인하지 못했습니다. 나중에 다시 시도해 주세요."
  },
  "Do you want to decline this invoice?": {
    "es": "¿Desea rechazar esta factura?",
    "ko": "이 청구서를 거절하시겠어요?"
  },
  "Yes, decline it!": {
    "es": "Sí, rechazar",
    "ko": "예, 거절합니다"
  },
  "Invoice Declined": {
    "es": "Factura rechazada",
    "ko": "청구서 거절 완료"
  },
  "The invoice has been successfully declined.": {
    "es": "La factura se ha rechazado correctamente.",
    "ko": "청구서가 거절되었습니다."
  },
  "Decline Failed": {
    "es": "Error de rechazo",
    "ko": "거절 실패"
  },
  "An error occurred while declining the invoice.": {
    "es": "Se ha producido un error al rechazar la factura.",
    "ko": "청구서를 거절하는 중 오류가 발생했습니다."
  },
  "Failed to decline the invoice. Please try again later.": {
    "es": "No se pudo rechazar la factura. Vuelva a intentarlo más tarde.",
    "ko": "청구서를 거절하지 못했습니다. 나중에 다시 시도해 주세요."
  },
  "Your session has expired. Please log in again.": {
    "es": "Su sesión ha caducado. Vuelva a iniciar sesión.",
    "ko": "세션이 만료되었습니다. 다시 로그인해 주세요."
  },
  "Failed to load invoices. Please try again.": {
    "es": "No se pudieron cargar las facturas. Vuelva a intentarlo.",
    "ko": "청구서를 불러오지 못했습니다. 다시 시도해 주세요."
  },
  "Invoice Submitted": {
    "es": "Factura enviada",
    "ko": "청구서 제출 완료"
  },
  "Your invoice has been submitted.": {
    "es": "Su factura se ha enviado.",
    "ko": "청구서가 제출되었습니다."
  },
  "Upload Failed": {
    "es": "Error al subir",
    "ko": "업로드 실패"
  },
  "An error occurred while uploading the invoice.": {
    "es": "Se ha producido un error al subir la factura.",
    "ko": "청구서를 업로드하는 중 오류가 발생했습니다."
  },
  "Failed to upload the invoice. Please try again.": {
    "es": "No se pudo subir la factura. Vuelva a intentarlo.",
    "ko": "청구서를 업로드하지 못했습니다. 다시 시도해 주세요."
  },
  "Download Failed": {
    "es": "Error de descarga",
    "ko": "다운로드 실패"
  },
  "Could not download the file. Please try again.": {
    "es": "No se pudo descargar el archivo. Vuelva a intentarlo.",
    "ko": "파일을 다운로드하지 못했습니다. 다시 시도해 주세요."
  },
  "Vendor sign-up link | BFMS": {
    "es": "Enlace de registro de proveedor — BFMS",
    "ko": "공급업체 가입 링크 — BFMS"
  },
  "Please use this vendor sign-up link:": {
    "es": "Utilice este enlace de registro de proveedor:",
    "ko": "다음 공급업체 가입 링크를 사용하세요:"
  },
  "Blessed FMS": {
    "es": "Blessed FMS",
    "ko": "Blessed FMS"
  },
  "Enter the vendor's email address. They will receive a vendor sign-up link.": {
    "es": "Introduzca el correo del proveedor. Recibirá un enlace para registrarse como proveedor.",
    "ko": "공급업체의 이메일 주소를 입력하세요. 공급업체 가입 링크가 발송됩니다."
  },
  "Send Invite": {
    "es": "Enviar invitación",
    "ko": "초대 보내기"
  },
  "Gmail opened": {
    "es": "Gmail abierto",
    "ko": "Gmail이 열렸습니다."
  },
  "Invitation sent!": {
    "es": "¡Invitación enviada!",
    "ko": "초대를 보냈습니다!"
  },
  "Vendor sign-up link sent to {0}": {
    "es": "Enlace de registro de proveedor enviado a {0}",
    "ko": "{0}(으)로 공급업체 가입 링크를 보냈습니다."
  },
  "The vendor invitation was created.": {
    "es": "Se ha creado la invitación del proveedor.",
    "ko": "공급업체 초대가 생성되었습니다."
  },
  "Network error. Please try again.": {
    "es": "Error de red. Vuelva a intentarlo.",
    "ko": "네트워크 오류입니다. 다시 시도해 주세요."
  },
  "Failed to send vendor invitation": {
    "es": "No se pudo enviar la invitación del proveedor.",
    "ko": "공급업체 초대를 보내지 못했습니다."
  },
  "Do you really want to terminate this enrollment?": {
    "es": "¿Desea finalizar esta inscripción?",
    "ko": "이 등록 관계를 종료하시겠어요?"
  },
  "Yes, terminate it!": {
    "es": "Sí, finalizar",
    "ko": "예, 종료합니다"
  },
  "Terminating enrollment...": {
    "es": "Finalizando inscripción...",
    "ko": "등록 관계를 종료하는 중입니다..."
  },
  "Enrollment terminated successfully!": {
    "es": "¡La inscripción se ha finalizado correctamente!",
    "ko": "등록 관계가 종료되었습니다!"
  },
  "Failed to terminate enrollment": {
    "es": "No se pudo finalizar la inscripción.",
    "ko": "등록 관계를 종료하지 못했습니다."
  },
  "Terminate enrollment failed": {
    "es": "Error al finalizar la inscripción",
    "ko": "등록 관계 종료 실패"
  },
  "Please wait.": {
    "es": "Espere un momento.",
    "ko": "잠시 기다려 주세요."
  },
  "Enrollment Successful": {
    "es": "Inscripción completada",
    "ko": "등록 완료"
  },
  "Failed to add vendor.": {
    "es": "No se pudo añadir al proveedor.",
    "ko": "공급업체를 추가하지 못했습니다."
  },
  "No file selected": {
    "es": "No se ha seleccionado ningún archivo.",
    "ko": "선택한 파일이 없습니다."
  },
  "Household Employer": {
    "es": "Empleador doméstico",
    "ko": "가정 고용주"
  },
  "Complete the missing fields": {
    "es": "Complete los campos que faltan.",
    "ko": "누락된 항목을 입력해 주세요."
  },
  "Failed to update information.": {
    "es": "No se pudo actualizar la información.",
    "ko": "정보를 수정하지 못했습니다."
  },
  "Current file saved": {
    "es": "Archivo actual guardado",
    "ko": "현재 파일이 저장되었습니다."
  },
  "Information was updated successfully": {
    "es": "La información se ha actualizado correctamente.",
    "ko": "정보가 수정되었습니다."
  },
  "Something went wrong. Please try again.": {
    "es": "Algo ha salido mal. Vuelva a intentarlo.",
    "ko": "문제가 발생했습니다. 다시 시도해 주세요."
  },
  "Please check the acknowledge box to continue...": {
    "es": "Marque la casilla de aceptación para continuar.",
    "ko": "계속하려면 동의 확인란을 선택해 주세요."
  },
  "Agreement Success": {
    "es": "Acuerdo aceptado",
    "ko": "약관 동의 완료"
  },
  "Terms declined by user": {
    "es": "El usuario rechazó las condiciones.",
    "ko": "사용자가 약관에 동의하지 않았습니다."
  },
  "Are you sure you want to decline the Terms of Service? You will not be able to use the service without accepting these terms.": {
    "es": "¿Desea rechazar las condiciones del servicio? No podrá utilizar el servicio sin aceptarlas.",
    "ko": "서비스 이용약관에 동의하지 않으시겠어요? 약관에 동의하지 않으면 서비스를 이용할 수 없습니다."
  },
  "Terms of Service declined. Please contact support if you have questions.": {
    "es": "Se han rechazado las condiciones del servicio. Si tiene preguntas, póngase en contacto con soporte.",
    "ko": "서비스 이용약관에 동의하지 않으셨습니다. 궁금한 점은 지원팀에 문의하세요."
  },
  "Sign in link | BFMS": {
    "es": "Enlace de inicio de sesión — BFMS",
    "ko": "로그인 링크 — BFMS"
  },
  "Please use this sign in link:": {
    "es": "Utilice este enlace para iniciar sesión:",
    "ko": "다음 로그인 링크를 사용하세요:"
  },
  "Enter the employee's email address. They will receive a signup link.": {
    "es": "Introduzca el correo del empleado. Recibirá un enlace de registro.",
    "ko": "직원의 이메일 주소를 입력하세요. 가입 링크가 발송됩니다."
  },
  "Signup link sent to {0}": {
    "es": "Enlace de registro enviado a {0}",
    "ko": "{0}(으)로 가입 링크를 보냈습니다."
  },
  "The invitation was created, but no signup link was returned.": {
    "es": "Se creó la invitación, pero el sistema no devolvió un enlace de registro.",
    "ko": "초대는 생성되었지만 가입 링크를 받지 못했습니다."
  },
  "Failed to send invitation": {
    "es": "No se pudo enviar la invitación.",
    "ko": "초대를 보내지 못했습니다."
  },
  "Type here...": {
    "es": "Escriba aquí...",
    "ko": "여기에 입력하세요..."
  },
  "Your text here...": {
    "es": "Su texto aquí...",
    "ko": "텍스트를 입력하세요..."
  },
  "Could not fetch employee data": {
    "es": "No se pudieron obtener los datos del empleado.",
    "ko": "직원 정보를 불러오지 못했습니다."
  },
  "Personal Information not completed": {
    "es": "Información personal incompleta",
    "ko": "개인정보 작성 미완료"
  },
  "Payment Details missing": {
    "es": "Faltan los datos de pago",
    "ko": "지급 정보 누락"
  },
  "Service Details not set": {
    "es": "No se han establecido los datos del servicio",
    "ko": "서비스 정보 미설정"
  },
  "Eligibility requirements not met": {
    "es": "No se cumplen los requisitos de elegibilidad",
    "ko": "자격 요건 미충족"
  },
  "Signature not uploaded": {
    "es": "No se ha subido la firma",
    "ko": "서명 미업로드"
  },
  "Checklist Incomplete": {
    "es": "Lista de requisitos incompleta",
    "ko": "필수 항목 미완료"
  },
  "Please Select a Client to clock in": {
    "es": "Seleccione un cliente para registrar la entrada.",
    "ko": "출근을 기록하려면 클라이언트를 선택하세요."
  },
  "Please add your service code in the enrollment menu.": {
    "es": "Añada su código de servicio en el menú de inscripción.",
    "ko": "등록 메뉴에서 서비스 코드를 추가해 주세요."
  },
  "Some Kind Of Blues": {
    "es": "Some Kind Of Blues",
    "ko": "Some Kind Of Blues"
  },
  "Open Sans": {
    "es": "Open Sans",
    "ko": "Open Sans"
  },
  "You will be signed out!": {
    "es": "Se cerrará su sesión.",
    "ko": "로그아웃됩니다."
  },
  "Yes, sign me out!": {
    "es": "Sí, cerrar sesión",
    "ko": "예, 로그아웃합니다"
  },
  "Soft UI Dashboard PRO": {
    "es": "Soft UI Dashboard PRO",
    "ko": "Soft UI Dashboard PRO"
  },
  "Virtual Reality": {
    "es": "Realidad virtual",
    "ko": "가상현실"
  },
  "forgot Password": {
    "es": "Olvidé mi contraseña",
    "ko": "비밀번호 찾기"
  },
  "Reset Password": {
    "es": "Restablecer contraseña",
    "ko": "비밀번호 재설정"
  },
  "Swith Client": {
    "es": "Cambiar cliente",
    "ko": "클라이언트 전환"
  },
  "Payment Details": {
    "es": "Datos de pago",
    "ko": "지급 정보"
  },
  "Service Details": {
    "es": "Datos del servicio",
    "ko": "서비스 정보"
  },
  "Employment & Tax": {
    "es": "Empleo e impuestos",
    "ko": "고용 및 세금"
  },
  "Required Documents": {
    "es": "Documentos obligatorios",
    "ko": "필수 서류"
  },
  "Client #{0}": {
    "es": "Cliente n.º {0}",
    "ko": "클라이언트 #{0}"
  },
  "Could not load your employer list.": {
    "es": "No se pudo cargar su lista de empleadores.",
    "ko": "고용주 목록을 불러오지 못했습니다."
  },
  "Enrollment ID was not returned by the server.": {
    "es": "El servidor no devolvió el ID de inscripción.",
    "ko": "서버에서 등록 ID를 반환하지 않았습니다."
  },
  "Could not open the enrollment for this employer.": {
    "es": "No se pudo abrir la inscripción para este empleador.",
    "ko": "이 고용주에 대한 등록을 열지 못했습니다."
  },
  "hour": {
    "es": "hora",
    "ko": "시간"
  },
  "day": {
    "es": "día",
    "ko": "일"
  },
  "Maximum file size is 10 MB.": {
    "es": "El tamaño máximo del archivo es de 10 MB.",
    "ko": "최대 파일 크기는 10MB입니다."
  },
  "Your invoice is awaiting client approval.": {
    "es": "Su factura está pendiente de aprobación del cliente.",
    "ko": "클라이언트의 청구서 승인을 기다리고 있습니다."
  },
  "Withdraw this invoice?": {
    "es": "¿Desea retirar esta factura?",
    "ko": "이 청구서를 철회하시겠어요?"
  },
  "Could not withdraw": {
    "es": "No se pudo retirar",
    "ko": "철회 실패"
  },
  "Could not download the receipt. Please retry.": {
    "es": "No se pudo descargar el recibo. Vuelva a intentarlo.",
    "ko": "영수증을 다운로드하지 못했습니다. 다시 시도해 주세요."
  },
  "Your session is no longer valid. Please sign in again. An old browser page can remain visible after your session ends.": {
    "es": "Su sesión ya no es válida. Vuelva a iniciar sesión. Una página antigua puede seguir visible después de finalizar la sesión.",
    "ko": "세션이 더 이상 유효하지 않습니다. 다시 로그인해 주세요. 세션이 종료된 후에도 이전 페이지가 화면에 남아 있을 수 있습니다."
  },
  "This employee account is not active. Ask an administrator to activate it, then sign in again.": {
    "es": "Esta cuenta de empleado no está activa. Pida a un administrador que la active y vuelva a iniciar sesión.",
    "ko": "이 직원 계정은 활성화되지 않았습니다. 관리자에게 활성화를 요청한 후 다시 로그인하세요."
  },
  "Could not verify your session. Check your connection and try again. Your saved session has not been cleared.": {
    "es": "No se pudo verificar su sesión. Compruebe la conexión y vuelva a intentarlo. Su sesión guardada no se ha borrado.",
    "ko": "세션을 확인하지 못했습니다. 연결 상태를 확인한 후 다시 시도하세요. 저장된 세션은 삭제되지 않았습니다."
  },
  "email and password did not match.": {
    "es": "El correo electrónico y la contraseña no coinciden.",
    "ko": "이메일과 비밀번호가 일치하지 않습니다."
  },
  "Could not sign in": {
    "es": "No se pudo iniciar sesión",
    "ko": "로그인 실패"
  },
  "Check your connection and try again.": {
    "es": "Compruebe su conexión y vuelva a intentarlo.",
    "ko": "연결 상태를 확인한 후 다시 시도해 주세요."
  },
  "This page requires a valid invitation link. Please ask your employer to send you an invite.": {
    "es": "Esta página requiere un enlace de invitación válido. Pida a su empleador que le envíe una invitación.",
    "ko": "이 페이지를 이용하려면 유효한 초대 링크가 필요합니다. 고용주에게 초대 발송을 요청해 주세요."
  },
  "First name is required.": {
    "es": "El nombre es obligatorio.",
    "ko": "이름을 입력해 주세요."
  },
  "Last name is required.": {
    "es": "Los apellidos son obligatorios.",
    "ko": "성을 입력해 주세요."
  },
  "Phone number is required.": {
    "es": "El número de teléfono es obligatorio.",
    "ko": "전화번호를 입력해 주세요."
  },
  "SS number is required.": {
    "es": "El número de Seguro Social es obligatorio.",
    "ko": "사회보장번호를 입력해 주세요."
  },
  "Gender is required.": {
    "es": "El género es obligatorio.",
    "ko": "성별을 선택해 주세요."
  },
  "Date of Birth is required.": {
    "es": "La fecha de nacimiento es obligatoria.",
    "ko": "생년월일을 입력해 주세요."
  },
  "Address is required.": {
    "es": "La dirección es obligatoria.",
    "ko": "주소를 입력해 주세요."
  },
  "City is required.": {
    "es": "La ciudad es obligatoria.",
    "ko": "도시를 입력해 주세요."
  },
  "State is required.": {
    "es": "El estado es obligatorio.",
    "ko": "주를 입력해 주세요."
  },
  "Zip Code is required.": {
    "es": "El código postal es obligatorio.",
    "ko": "우편번호를 입력해 주세요."
  },
  "Client's UCI number is required.": {
    "es": "El número UCI del cliente es obligatorio.",
    "ko": "클라이언트의 UCI 번호를 입력해 주세요."
  },
  "Email is required.": {
    "es": "El correo electrónico es obligatorio.",
    "ko": "이메일을 입력해 주세요."
  },
  "Password must be at least 8 characters.": {
    "es": "La contraseña debe tener al menos 8 caracteres.",
    "ko": "비밀번호는 8자 이상이어야 합니다."
  },
  "Passwords do not match.": {
    "es": "Las contraseñas no coinciden.",
    "ko": "비밀번호가 일치하지 않습니다."
  },
  "You must agree to the terms.": {
    "es": "Debe aceptar las condiciones.",
    "ko": "약관에 동의해 주세요."
  },
  "Please fix the following:": {
    "es": "Corrija lo siguiente:",
    "ko": "다음 항목을 수정해 주세요:"
  },
  "Account Created!": {
    "es": "¡Cuenta creada!",
    "ko": "계정 생성 완료!"
  },
  "Please wait for the admin to activate your account. You can then sign in.": {
    "es": "Espere a que el administrador active su cuenta. Después podrá iniciar sesión.",
    "ko": "관리자가 계정을 활성화할 때까지 기다려 주세요. 활성화 후 로그인할 수 있습니다."
  },
  "Registration Failed": {
    "es": "Error de registro",
    "ko": "가입 실패"
  },
  "Something went wrong": {
    "es": "Algo ha salido mal",
    "ko": "문제가 발생했습니다"
  },
  "Please select a client before time entry.": {
    "es": "Seleccione un cliente antes de registrar horas.",
    "ko": "근무 시간을 입력하기 전에 클라이언트를 선택하세요."
  },
  "Are you sure you want to update your password?": {
    "es": "¿Seguro que desea actualizar su contraseña?",
    "ko": "비밀번호를 변경하시겠어요?"
  },
  "Yes, update it!": {
    "es": "Sí, actualizar",
    "ko": "예, 변경합니다"
  },
  "Please sign in with your new password.": {
    "es": "Inicie sesión con su nueva contraseña.",
    "ko": "새 비밀번호로 로그인해 주세요."
  },
  "Default Project Card": {
    "es": "Tarjeta de proyecto predeterminada",
    "ko": "기본 프로젝트 카드"
  },
  "Emails (21)": {
    "es": "Correos electrónicos (21)",
    "ko": "이메일 (21)"
  },
  "Check your emails": {
    "es": "Revise su correo electrónico.",
    "ko": "이메일을 확인해 주세요."
  },
  "Employment details were updated.": {
    "es": "Se han actualizado los datos de empleo.",
    "ko": "고용 정보가 수정되었습니다."
  },
  "Save Failed": {
    "es": "Error al guardar",
    "ko": "저장 실패"
  },
  "Could not save employment details.": {
    "es": "No se pudieron guardar los datos de empleo.",
    "ko": "고용 정보를 저장하지 못했습니다."
  },
  "Government-issued photo identification.": {
    "es": "Identificación con fotografía emitida por el gobierno.",
    "ko": "정부가 발급한 사진이 있는 신분증입니다."
  },
  "Social Security card or accepted equivalent record.": {
    "es": "Tarjeta de Seguro Social o documento equivalente aceptado.",
    "ko": "사회보장카드 또는 인정되는 대체 서류입니다."
  },
  "Live Scan Results": {
    "es": "Resultados de Live Scan",
    "ko": "Live Scan 결과"
  },
  "Upload the employee's fingerprint/background-check document requested by BFMS. This upload records a document; it does not enter a fee or change the client's budget. PDF, JPG, PNG, DOC or DOCX, up to 10 MB.": {
    "es": "Suba el documento de huellas digitales o verificación de antecedentes solicitado por BFMS. Esta carga registra un documento; no introduce una tarifa ni cambia el presupuesto del cliente. PDF, JPG, PNG, DOC o DOCX, hasta 10 MB.",
    "ko": "BFMS가 요청한 직원의 지문 또는 신원 조회 서류를 업로드하세요. 이 기능은 서류를 등록할 뿐 수수료를 입력하거나 클라이언트 예산을 변경하지 않습니다. PDF, JPG, PNG, DOC 또는 DOCX 형식, 최대 10MB입니다."
  },
  "Regional Center or agency approval documentation.": {
    "es": "Documentación de aprobación del Centro Regional o de la agencia.",
    "ko": "Regional Center 또는 기관의 승인 서류입니다."
  },
  "Identification Number Document": {
    "es": "Documento de número de identificación",
    "ko": "식별번호 증빙 서류"
  },
  "Required identification or tax-number documentation.": {
    "es": "Documentación obligatoria de identificación o número fiscal.",
    "ko": "필수 신원 또는 납세자 번호 증빙 서류입니다."
  },
  "Current auto insurance certificate when driving is required.": {
    "es": "Certificado vigente de seguro de automóvil cuando se requiera conducir.",
    "ko": "운전이 필요한 경우 유효한 자동차 보험 증명서입니다."
  },
  "Valid driver license when driving is required.": {
    "es": "Licencia de conducir vigente cuando se requiera conducir.",
    "ko": "운전이 필요한 경우 유효한 운전면허증입니다."
  },
  "File Too Large": {
    "es": "Archivo demasiado grande",
    "ko": "파일 크기 초과"
  },
  "Document uploaded successfully.": {
    "es": "El documento se ha subido correctamente.",
    "ko": "서류가 업로드되었습니다."
  },
  "Could not upload the document.": {
    "es": "No se pudo subir el documento.",
    "ko": "서류를 업로드하지 못했습니다."
  },
  "Worker Agreement": {
    "es": "Acuerdo del trabajador",
    "ko": "근로자 계약서"
  },
  "Direct Deposit": {
    "es": "Depósito directo",
    "ko": "계좌 이체"
  },
  "Federal W-4": {
    "es": "W-4 federal",
    "ko": "연방 W-4"
  },
  "California DE-4": {
    "es": "DE-4 de California",
    "ko": "California DE-4"
  },
  "Form I-9": {
    "es": "Formulario I-9",
    "ko": "I-9 양식"
  },
  "Signature recorded for this form.": {
    "es": "Se ha registrado la firma para este formulario.",
    "ko": "이 양식의 서명이 등록되었습니다."
  },
  "Signature Failed": {
    "es": "Error de firma",
    "ko": "서명 실패"
  },
  "Could not save the signature.": {
    "es": "No se pudo guardar la firma.",
    "ko": "서명을 저장하지 못했습니다."
  },
  "Savings Account": {
    "es": "Cuenta de ahorros",
    "ko": "저축예금 계좌"
  },
  "Payment details saved successfully": {
    "es": "Los datos de pago se han guardado correctamente.",
    "ko": "지급 정보가 저장되었습니다."
  },
  "Failed to save payment details.": {
    "es": "No se pudieron guardar los datos de pago.",
    "ko": "지급 정보를 저장하지 못했습니다."
  },
  "No File": {
    "es": "Sin archivo",
    "ko": "파일 없음"
  },
  "No voided check uploaded.": {
    "es": "No se ha subido ningún cheque anulado.",
    "ko": "업로드된 무효 수표가 없습니다."
  },
  "Loading File...": {
    "es": "Cargando archivo...",
    "ko": "파일을 불러오는 중입니다..."
  },
  "Unable to preview file.": {
    "es": "No se puede previsualizar el archivo.",
    "ko": "파일을 미리 볼 수 없습니다."
  },
  "Invalid File": {
    "es": "Archivo no válido",
    "ko": "유효하지 않은 파일"
  },
  "Only JPG, PNG, or PDF files allowed.": {
    "es": "Solo se permiten archivos JPG, PNG o PDF.",
    "ko": "JPG, PNG 또는 PDF 파일만 허용됩니다."
  },
  "{0} {1} required": {
    "es": "{0} {1} obligatorio(s)",
    "ko": "{0} {1} 입력이 필요합니다."
  },
  "Please wait while the records is being updated.": {
    "es": "Espere mientras se actualizan los registros.",
    "ko": "기록을 수정하는 동안 기다려 주세요."
  },
  "Personal information updated successfully": {
    "es": "La información personal se ha actualizado correctamente.",
    "ko": "개인정보가 수정되었습니다."
  },
  "Update failed. Please try again.": {
    "es": "No se pudo actualizar. Vuelva a intentarlo.",
    "ko": "수정하지 못했습니다. 다시 시도해 주세요."
  },
  "Please wait while we update the service codes.": {
    "es": "Espere mientras actualizamos los códigos de servicio.",
    "ko": "서비스 코드를 수정하는 동안 기다려 주세요."
  },
  "Service codes updated successfully.": {
    "es": "Los códigos de servicio se han actualizado correctamente.",
    "ko": "서비스 코드가 수정되었습니다."
  },
  "Update Failed": {
    "es": "Error de actualización",
    "ko": "수정 실패"
  },
  "Something went wrong while updating the service codes.": {
    "es": "Se ha producido un error al actualizar los códigos de servicio.",
    "ko": "서비스 코드를 수정하는 중 문제가 발생했습니다."
  },
  "Invalid Time": {
    "es": "Hora no válida",
    "ko": "유효하지 않은 시간"
  },
  "Your work has been saved": {
    "es": "Se ha guardado su trabajo.",
    "ko": "입력한 내용이 저장되었습니다."
  },
  "{0} Available hours for this week: {1}": {
    "es": "{0} Horas disponibles para esta semana: {1}",
    "ko": "{0} 이번 주 사용 가능한 시간: {1}"
  },
  "Failed to submit time entry.": {
    "es": "No se pudo enviar el registro de horas.",
    "ko": "근무 시간을 제출하지 못했습니다."
  },
  "Please check your connection and try again.": {
    "es": "Compruebe su conexión y vuelva a intentarlo.",
    "ko": "연결 상태를 확인한 후 다시 시도해 주세요."
  },
  "We send you a reset password in your email account.": {
    "es": "Le hemos enviado un correo para restablecer su contraseña.",
    "ko": "비밀번호 재설정 이메일을 보내드렸습니다."
  },
  "no record with that email in our system.": {
    "es": "No hay ningún registro con ese correo electrónico en nuestro sistema.",
    "ko": "해당 이메일로 등록된 계정이 없습니다."
  },
  "Payment Dtails": {
    "es": "Datos de pago",
    "ko": "지급 정보"
  },
  "Payroll Rates": {
    "es": "Tarifas de nómina",
    "ko": "급여 요율"
  },
  "Vendor Forms": {
    "es": "Formularios de proveedores",
    "ko": "공급업체 양식"
  },
  "Failed to search for clients. Please try again.": {
    "es": "No se pudieron buscar clientes. Vuelva a intentarlo.",
    "ko": "클라이언트를 검색하지 못했습니다. 다시 시도해 주세요."
  },
  "An unexpected error occurred.": {
    "es": "Se ha producido un error inesperado.",
    "ko": "예기치 않은 오류가 발생했습니다."
  },
  "Failed to fetch enrolled accounts. Please try again.": {
    "es": "No se pudieron obtener las cuentas inscritas. Vuelva a intentarlo.",
    "ko": "등록된 계정을 불러오지 못했습니다. 다시 시도해 주세요."
  },
  "Invoice Page": {
    "es": "Página de facturas",
    "ko": "청구서 페이지"
  },
  "You need to complete your": {
    "es": "Debe completar su",
    "ko": "다음 항목을 완료해야 합니다:"
  },
  "to access this feature": {
    "es": "para acceder a esta función",
    "ko": "완료 후 이 기능을 이용할 수 있습니다."
  },
  "Could not open invoice form": {
    "es": "No se pudo abrir el formulario de factura",
    "ko": "청구서 양식 열기 실패"
  },
  "Could not load invoices": {
    "es": "No se pudieron cargar las facturas",
    "ko": "청구서 불러오기 실패"
  },
  "No existing bank account found.": {
    "es": "No se ha encontrado ninguna cuenta bancaria existente.",
    "ko": "등록된 은행 계좌가 없습니다."
  },
  "Please wait while we upload your details.": {
    "es": "Espere mientras se suben sus datos.",
    "ko": "정보를 업로드하는 동안 기다려 주세요."
  },
  "Bank account updated successfully!": {
    "es": "¡La cuenta bancaria se ha actualizado correctamente!",
    "ko": "은행 계좌가 수정되었습니다!"
  },
  "Bank account registered successfully!": {
    "es": "¡La cuenta bancaria se ha registrado correctamente!",
    "ko": "은행 계좌가 등록되었습니다!"
  },
  "Failed to save bank account details.": {
    "es": "No se pudieron guardar los datos de la cuenta bancaria.",
    "ko": "은행 계좌 정보를 저장하지 못했습니다."
  },
  "Loading file...": {
    "es": "Cargando archivo...",
    "ko": "파일을 불러오는 중입니다..."
  },
  "Please wait while we fetch your voided check.": {
    "es": "Espere mientras obtenemos su cheque anulado.",
    "ko": "무효 수표를 불러오는 동안 기다려 주세요."
  },
  "Failed to load file preview.": {
    "es": "No se pudo cargar la vista previa del archivo.",
    "ko": "파일 미리보기를 불러오지 못했습니다."
  },
  "310 - Respite (Individual and Agency) In-home": {
    "es": "310 - Respiro (individual y de agencia) en el hogar",
    "ko": "310 - 가정 내 휴식 지원 (개인 및 기관)"
  },
  "320 - Community Living Supports (Individual and Agency)": {
    "es": "320 - Apoyos para la vida comunitaria (individuales y de agencia)",
    "ko": "320 - 지역사회 생활 지원 (개인 및 기관)"
  },
  "331 - Community Integration Supports": {
    "es": "331 - Apoyos para la integración comunitaria",
    "ko": "331 - 지역사회 통합 지원"
  },
  "333 - Participant-Directed Goods and Services": {
    "es": "333 - Bienes y servicios dirigidos por el participante",
    "ko": "333 - 참여자 주도 물품 및 서비스"
  },
  "335 - Employment Supports": {
    "es": "335 - Apoyos para el empleo",
    "ko": "335 - 고용 지원"
  },
  "336 - Technology Supports": {
    "es": "336 - Apoyos tecnológicos",
    "ko": "336 - 기술 지원"
  },
  "338 - Non-Medical Transportation": {
    "es": "338 - Transporte no médico",
    "ko": "338 - 비의료 교통 지원"
  },
  "340 - Independent Facilitator": {
    "es": "340 - Facilitador independiente",
    "ko": "340 - 독립 조력자"
  },
  "358 - Non-Medical Transportation": {
    "es": "358 - Transporte no médico",
    "ko": "358 - 비의료 교통 지원"
  },
  "366 - Family/Consumer Training": {
    "es": "366 - Formación para familiares y consumidores",
    "ko": "366 - 가족 / 이용자 교육"
  },
  "Saved record could not be loaded. Please check backend connection.": {
    "es": "No se pudo cargar el registro guardado. Compruebe la conexión con el servidor.",
    "ko": "저장된 기록을 불러오지 못했습니다. 서버 연결을 확인해 주세요."
  },
  "Payroll & Rates saved": {
    "es": "Se han guardado la nómina y las tarifas.",
    "ko": "급여 및 요율 정보가 저장되었습니다."
  },
  "Save failed": {
    "es": "El perfil se ha actualizado correctamente.",
    "ko": "프로필이 수정되었습니다."
  },
  "Backend save endpoint is not connected yet or returned an error.": {
    "es": "La función de guardado del servidor aún no está conectada o devolvió un error.",
    "ko": "서버의 저장 기능이 아직 연결되지 않았거나 오류를 반환했습니다."
  },
  "Profile updated successfully!": {
    "es": "¡El perfil se ha actualizado correctamente!",
    "ko": "프로필이 수정되었습니다!"
  },
  "An unexpected error occurred. Please try again.": {
    "es": "Se ha producido un error inesperado. Vuelva a intentarlo.",
    "ko": "예기치 않은 오류가 발생했습니다. 다시 시도해 주세요."
  },
  "Account not yet activated.": {
    "es": "La cuenta todavía no está activada.",
    "ko": "계정이 아직 활성화되지 않았습니다."
  },
  "Invitation Link Problem": {
    "es": "Problema con el enlace de invitación",
    "ko": "초대 링크 문제"
  },
  "This vendor invitation link is invalid or has already been used. You can still register without the invitation link if needed.": {
    "es": "Este enlace de invitación de proveedor no es válido o ya se ha utilizado. Si lo necesita, puede registrarse sin el enlace de invitación.",
    "ko": "이 공급업체 초대 링크는 유효하지 않거나 이미 사용되었습니다. 필요한 경우 초대 링크 없이도 가입할 수 있습니다."
  },
  "Please complete the registration form required fields.": {
    "es": "Complete los campos obligatorios del formulario de registro.",
    "ko": "가입 양식의 필수 항목을 입력해 주세요."
  },
  "Account created successfully. Your account is now pending for activation.": {
    "es": "La cuenta se ha creado correctamente y está pendiente de activación.",
    "ko": "계정이 생성되었으며 활성화를 기다리고 있습니다."
  },
  "You need to complete your Signature to access this feature": {
    "es": "Debe completar su firma para acceder a esta función.",
    "ko": "이 기능을 이용하려면 서명을 완료해야 합니다."
  },
  "Could not generate W-9": {
    "es": "No se pudo generar el formulario W-9",
    "ko": "W-9 생성 실패"
  },
  "Please try again. If this continues, contact support.": {
    "es": "Vuelva a intentarlo. Si el problema continúa, contacte con soporte.",
    "ko": "다시 시도해 주세요. 문제가 계속되면 지원팀에 문의하세요."
  },
  "submitted": {
    "es": "enviado",
    "ko": "제출됨"
  },
  "Community Integration Supports": {
    "es": "Apoyos para la integración comunitaria",
    "ko": "지역사회 통합 지원"
  },
  "Technology Supports": {
    "es": "Apoyos tecnológicos",
    "ko": "기술 지원"
  },
  "Employment Supports": {
    "es": "Apoyos para el empleo",
    "ko": "고용 지원"
  },
  "Non-Medical Transportation": {
    "es": "Transporte no médico",
    "ko": "비의료 교통 지원"
  },
  "Independent Facilitator": {
    "es": "Facilitador independiente",
    "ko": "독립 조력자"
  },
  "Current client": {
    "es": "Cliente actual",
    "ko": "현재 클라이언트"
  },
  "Could not load enrolled clients. You can keep the current client or reopen this form to retry.": {
    "es": "No se pudieron cargar los clientes inscritos. Puede mantener el cliente actual o abrir de nuevo este formulario para reintentar.",
    "ko": "등록된 클라이언트를 불러오지 못했습니다. 현재 클라이언트를 유지하거나 양식을 다시 열어 시도할 수 있습니다."
  },
  "Please select a valid service code.": {
    "es": "Seleccione un código de servicio válido.",
    "ko": "올바른 서비스 코드를 선택해 주세요."
  },
  "Unable to submit the edit. Please try again.": {
    "es": "No se pudo enviar la edición. Vuelva a intentarlo.",
    "ko": "수정 사항을 제출하지 못했습니다. 다시 시도해 주세요."
  },
  "Please enter Submitted Date.": {
    "es": "Introduzca la fecha de envío.",
    "ko": "제출일을 입력해 주세요."
  },
  "Please select Client Name.": {
    "es": "Seleccione el nombre del cliente.",
    "ko": "클라이언트 성명을 선택해 주세요."
  },
  "Please select a valid Service Code.": {
    "es": "Seleccione un código de servicio válido.",
    "ko": "올바른 서비스 코드를 선택해 주세요."
  },
  "Please enter Service Date From.": {
    "es": "Introduzca la fecha de inicio del servicio.",
    "ko": "서비스 시작일을 입력해 주세요."
  },
  "Please enter Service Date To.": {
    "es": "Introduzca la fecha de finalización del servicio.",
    "ko": "서비스 종료일을 입력해 주세요."
  },
  "Service Date To must be on or after Service Date From.": {
    "es": "La fecha de finalización debe ser igual o posterior a la de inicio del servicio.",
    "ko": "서비스 종료일은 시작일과 같거나 그 이후여야 합니다."
  },
  "Please enter a valid Service Unit.": {
    "es": "Introduzca una unidad de servicio válida.",
    "ko": "올바른 서비스 단위를 입력해 주세요."
  },
  "Please enter a valid Service Rate.": {
    "es": "Introduzca una tarifa de servicio válida.",
    "ko": "올바른 서비스 요율을 입력해 주세요."
  },
  "Submitted {0} | Service Date {1} | Service Unit {2} | Service Rate {3}": {
    "es": "Enviado: {0} / Fecha del servicio: {1} / Unidad: {2} / Tarifa: {3}",
    "ko": "제출일 {0} / 서비스 제공일 {1} / 서비스 단위 {2} / 서비스 요율 {3}"
  },
  "{0} | Service Code {1}": {
    "es": "{0} / Código de servicio: {1}",
    "ko": "{0} / 서비스 코드 {1}"
  },
  "Missing vendor token. Please sign in again.": {
    "es": "Falta el token del proveedor. Vuelva a iniciar sesión.",
    "ko": "공급업체 세션 토큰이 없습니다. 다시 로그인해 주세요."
  },
  "Please save at least one invoice line.": {
    "es": "Guarde al menos una línea de factura.",
    "ko": "청구서 항목을 한 개 이상 저장해 주세요."
  },
  "Please select a valid Service Code for each saved invoice line.": {
    "es": "Seleccione un código de servicio válido en cada línea guardada.",
    "ko": "저장된 청구서 항목마다 올바른 서비스 코드를 선택해 주세요."
  },
  "Submitting invoices...": {
    "es": "Enviando facturas...",
    "ko": "청구서를 제출하는 중입니다..."
  },
  "Please wait": {
    "es": "Espere un momento",
    "ko": "잠시 기다려 주세요"
  },
  "Your invoices have been saved": {
    "es": "Sus facturas se han guardado.",
    "ko": "청구서가 저장되었습니다."
  },
  "Failed to submit invoice.": {
    "es": "No se pudo enviar la factura.",
    "ko": "청구서를 제출하지 못했습니다."
  },
  "Please select a spreadsheet file.": {
    "es": "Seleccione un archivo de hoja de cálculo.",
    "ko": "스프레드시트 파일을 선택해 주세요."
  },
  "Import not connected yet": {
    "es": "La importación aún no está conectada.",
    "ko": "가져오기 기능이 아직 연결되지 않았습니다."
  },
  "The import UI is ready, but backend import handling still needs to be wired.": {
    "es": "La interfaz de importación está preparada, pero falta conectar el procesamiento del servidor.",
    "ko": "가져오기 화면은 준비되어 있지만 서버의 가져오기 처리 기능은 아직 연결되지 않았습니다."
  },
  "Failed to fetch enrolled accounts.": {
    "es": "No se pudieron obtener las cuentas inscritas.",
    "ko": "등록된 계정을 불러오지 못했습니다."
  },
  "Finish": {
    "es": "Finalizar",
    "ko": "완료"
  },
  "Hide budget summary": {
    "es": "Ocultar resumen del presupuesto",
    "ko": "예산 요약 숨기기"
  },
  "Show budget summary": {
    "es": "Mostrar resumen del presupuesto",
    "ko": "예산 요약 보기"
  },
  "Edit Purchase Order": {
    "es": "Editar orden de compra",
    "ko": "구매 주문 수정"
  },
  "Create Purchase Order": {
    "es": "Crear orden de compra",
    "ko": "구매 주문 작성"
  },
  "Update": {
    "es": "Actualizar",
    "ko": "수정"
  },
  "Collapse": {
    "es": "Contraer",
    "ko": "접기"
  },
  "Expand": {
    "es": "Desplegar",
    "ko": "펼치기"
  },
  "On: new devices need a code sent to your email. Verified devices stay trusted.": {
    "es": "Activada: los dispositivos nuevos necesitan un código enviado por correo. Los dispositivos verificados siguen siendo de confianza.",
    "ko": "켜짐: 새 기기는 이메일로 발송된 코드가 필요합니다. 인증된 기기는 신뢰 상태를 유지합니다."
  },
  "Off: a correct password can sign in from a new device without an email code.": {
    "es": "Desactivada: una contraseña correcta permite iniciar sesión desde un dispositivo nuevo sin código por correo.",
    "ko": "꺼짐: 올바른 비밀번호로 새 기기에서 이메일 코드 없이 로그인할 수 있습니다."
  },
  "Turn off 2FA": {
    "es": "Desactivar la autenticación de dos factores",
    "ko": "2단계 인증 끄기"
  },
  "Turn on 2FA": {
    "es": "Activar la autenticación de dos factores",
    "ko": "2단계 인증 켜기"
  },
  "this administrator session": {
    "es": "esta sesión de administrador",
    "ko": "이 관리자 세션"
  },
  "this browser": {
    "es": "este navegador",
    "ko": "이 브라우저"
  },
  "Verify this session": {
    "es": "Verificar esta sesión",
    "ko": "이 세션 인증"
  },
  "Verify this device": {
    "es": "Verificar este dispositivo",
    "ko": "이 기기 인증"
  },
  "Trusted": {
    "es": "De confianza",
    "ko": "신뢰됨"
  },
  "Email not verified": {
    "es": "Correo no verificado",
    "ko": "이메일 미인증"
  },
  "turning off 2FA": {
    "es": "desactivar la autenticación de dos factores",
    "ko": "2단계 인증 끄기"
  },
  "turning on 2FA": {
    "es": "activar la autenticación de dos factores",
    "ko": "2단계 인증 켜기"
  },
  "Required": {
    "es": "Obligatorio",
    "ko": "필수"
  },
  "Not required": {
    "es": "No obligatorio",
    "ko": "필수 아님"
  },
  "Incomplete": {
    "es": "Incompleto",
    "ko": "미완료"
  },
  "Untitled Resource": {
    "es": "Recurso sin título",
    "ko": "제목 없는 자료"
  },
  "Unassigned": {
    "es": "Sin asignar",
    "ko": "미지정"
  },
  "Unknown Employee": {
    "es": "Empleado desconocido",
    "ko": "알 수 없는 직원"
  },
  "Uploading...": {
    "es": "Subiendo...",
    "ko": "업로드 중..."
  },
  "Updating...": {
    "es": "Actualizando...",
    "ko": "수정 중..."
  },
  "N/A": {
    "es": "N/D",
    "ko": "해당 없음"
  },
  "---Select Service Code---": {
    "es": "---Seleccione un código de servicio---",
    "ko": "---서비스 코드 선택---"
  },
  "No service code available": {
    "es": "No hay códigos de servicio disponibles.",
    "ko": "사용 가능한 서비스 코드가 없습니다."
  },
  "Document Preview": {
    "es": "Vista previa del documento",
    "ko": "서류 미리보기"
  },
  "Submitting...": {
    "es": "Enviando...",
    "ko": "제출 중..."
  },
  "Submit for Approval": {
    "es": "Enviar para aprobación",
    "ko": "승인 요청 제출"
  },
  "New project": {
    "es": "Proyecto nuevo",
    "ko": "새 프로젝트"
  },
  "Saving...": {
    "es": "Guardando...",
    "ko": "저장 중..."
  },
  "Save Employment Details": {
    "es": "Guardar datos de empleo",
    "ko": "고용 정보 저장"
  },
  "Replace": {
    "es": "Reemplazar",
    "ko": "교체"
  },
  "Upload": {
    "es": "Subir",
    "ko": "업로드"
  },
  "When applicable": {
    "es": "Cuando corresponda",
    "ko": "해당하는 경우"
  },
  "Re-sign": {
    "es": "Volver a firmar",
    "ko": "다시 서명"
  },
  "Sign": {
    "es": "Firmar",
    "ko": "서명"
  },
  "Update Bank Account": {
    "es": "Actualizar cuenta bancaria",
    "ko": "은행 계좌 수정"
  },
  "Register Bank Account": {
    "es": "Registrar cuenta bancaria",
    "ko": "은행 계좌 등록"
  },
  "Submitting…": {
    "es": "Enviando…",
    "ko": "제출 중…"
  },
  "Submit Edit for Admin Review": {
    "es": "Enviar edición al administrador para revisión",
    "ko": "관리자에게 수정 검토 요청"
  },
  "Login successful": {
    "es": "Inicio de sesión correcto",
    "ko": "로그인되었습니다."
  },
  "Logged out successfully": {
    "es": "Sesión cerrada correctamente",
    "ko": "로그아웃되었습니다."
  },
  "Missing token.": {
    "es": "Falta el token de sesión.",
    "ko": "세션 토큰이 없습니다."
  },
  "Invalid token format.": {
    "es": "El formato del token no es válido.",
    "ko": "세션 토큰 형식이 올바르지 않습니다."
  },
  "Invalid request": {
    "es": "Solicitud no válida",
    "ko": "유효하지 않은 요청"
  },
  "Invalid Vendor Account": {
    "es": "Cuenta de proveedor no válida",
    "ko": "유효하지 않은 공급업체 계정"
  },
  "signature updated successfully": {
    "es": "La firma se ha actualizado correctamente.",
    "ko": "서명이 수정되었습니다."
  },
  "Invalid Client Account": {
    "es": "Cuenta de cliente no válida",
    "ko": "유효하지 않은 클라이언트 계정"
  },
  "Invalid session": {
    "es": "Sesión no válida",
    "ko": "유효하지 않은 세션"
  },
  "Client not found": {
    "es": "No se ha encontrado al cliente.",
    "ko": "클라이언트를 찾을 수 없습니다."
  },
  "Documents folder not found": {
    "es": "No se ha encontrado la carpeta de documentos.",
    "ko": "서류 폴더를 찾을 수 없습니다."
  },
  "Failed to fetch documents": {
    "es": "No se pudieron obtener los documentos.",
    "ko": "서류를 불러오지 못했습니다."
  },
  "Information not found": {
    "es": "No se ha encontrado la información.",
    "ko": "정보를 찾을 수 없습니다."
  },
  "Client information updated successfully": {
    "es": "La información del cliente se ha actualizado correctamente.",
    "ko": "클라이언트 정보가 수정되었습니다."
  },
  "Validation failed.": {
    "es": "La validación ha fallado.",
    "ko": "입력값을 확인해 주세요."
  },
  "Payment information saved successfully.": {
    "es": "Los datos de pago se han guardado correctamente.",
    "ko": "지급 정보가 저장되었습니다."
  },
  "Client details not found": {
    "es": "No se han encontrado los datos del cliente.",
    "ko": "클라이언트 정보를 찾을 수 없습니다."
  },
  "Payment information fetch successfully.": {
    "es": "Se han obtenido los datos de pago.",
    "ko": "지급 정보를 불러왔습니다."
  },
  "All requirements are complete": {
    "es": "Se han completado todos los requisitos.",
    "ko": "모든 필수 요건이 완료되었습니다."
  },
  "Agreement Policy": {
    "es": "Política del acuerdo",
    "ko": "동의 정책"
  },
  "Authenticated client was not resolved.": {
    "es": "No se pudo identificar al cliente autenticado.",
    "ko": "인증된 클라이언트를 확인하지 못했습니다."
  },
  "Please start sign-in again to request a code.": {
    "es": "Vuelva a iniciar el acceso para solicitar un código.",
    "ko": "코드를 요청하려면 로그인을 다시 시작해 주세요."
  },
  "Invoice Declined Successfully!": {
    "es": "¡Factura rechazada correctamente!",
    "ko": "청구서가 거절되었습니다!"
  },
  "Invoice not found": {
    "es": "No se ha encontrado la factura.",
    "ko": "청구서를 찾을 수 없습니다."
  },
  "Invoice Accepted Successfully!": {
    "es": "¡Factura aceptada correctamente!",
    "ko": "청구서가 승인되었습니다!"
  },
  "Registration was submitted successfully. Please wait for account approval before signing in.": {
    "es": "Su registro se ha enviado correctamente. Espere a que se apruebe su cuenta antes de iniciar sesión.",
    "ko": "가입 신청이 제출되었습니다. 계정 승인이 완료된 후 로그인해 주세요."
  },
  "account was created successfully": {
    "es": "La cuenta se ha creado correctamente.",
    "ko": "계정이 생성되었습니다."
  },
  "Invalid email or password": {
    "es": "Correo electrónico o contraseña no válidos",
    "ko": "이메일 또는 비밀번호가 올바르지 않습니다."
  },
  "Status Failed": {
    "es": "Estado fallido",
    "ko": "상태 확인 실패"
  },
  "Verification": {
    "es": "Verificación",
    "ko": "인증"
  },
  "Validation failed": {
    "es": "La validación ha fallado.",
    "ko": "입력값을 확인해 주세요."
  },
  "your password is not valid": {
    "es": "Su contraseña no es válida.",
    "ko": "비밀번호가 올바르지 않습니다."
  },
  "Account created successfully! Please wait for the admin to activate your account.": {
    "es": "¡Cuenta creada! Espere a que el administrador la active.",
    "ko": "계정이 생성되었습니다! 관리자가 활성화할 때까지 기다려 주세요."
  },
  "Account is not yet active": {
    "es": "La cuenta todavía no está activa.",
    "ko": "계정이 아직 활성화되지 않았습니다."
  },
  "Waiting for employer to hire you.": {
    "es": "Pendiente de contratación por el empleador.",
    "ko": "고용주의 채용을 기다리고 있습니다."
  },
  "Unregistered": {
    "es": "Sin registrar",
    "ko": "미등록"
  },
  "You are not employed by this client.": {
    "es": "No tiene una relación laboral con este cliente.",
    "ko": "이 클라이언트와 고용 관계가 없습니다."
  },
  "You exceeded the maximum number of hours for this week": {
    "es": "Ha superado el máximo de horas de esta semana.",
    "ko": "이번 주 최대 근무 시간을 초과했습니다."
  },
  "You will exceed the maximum number of hours for this week": {
    "es": "Superaría el máximo de horas de esta semana.",
    "ko": "이대로 제출하면 이번 주 최대 근무 시간을 초과합니다."
  },
  "timesheet was added successfully": {
    "es": "La hoja de horas se ha añadido correctamente.",
    "ko": "근무 시간표가 추가되었습니다."
  },
  "query successful": {
    "es": "Consulta completada",
    "ko": "조회를 완료했습니다."
  },
  "timesheet not found": {
    "es": "No se ha encontrado la hoja de horas.",
    "ko": "근무 시간표를 찾을 수 없습니다."
  },
  "Please submit the required documents and signatures for this employer before clocking in.": {
    "es": "Envíe los documentos y las firmas obligatorios para este empleador antes de registrar la entrada.",
    "ko": "출근을 기록하기 전에 이 고용주에 대한 필수 서류와 서명을 제출해 주세요."
  },
  "Timesheet not found": {
    "es": "No se ha encontrado la hoja de horas.",
    "ko": "근무 시간표를 찾을 수 없습니다."
  },
  "This timesheet belongs to another employee.": {
    "es": "Esta hoja de horas pertenece a otro empleado.",
    "ko": "다른 직원의 근무 시간표입니다."
  },
  "This timesheet is already clocked out.": {
    "es": "Ya se ha registrado la salida en esta hoja de horas.",
    "ko": "이 근무 시간표에는 이미 퇴근이 기록되어 있습니다."
  },
  "Bank details not found.": {
    "es": "No se han encontrado los datos bancarios.",
    "ko": "은행 정보를 찾을 수 없습니다."
  },
  "Employee not found.": {
    "es": "No se ha encontrado al empleado.",
    "ko": "직원을 찾을 수 없습니다."
  },
  "Invalid service code(s) provided.": {
    "es": "Se han indicado códigos de servicio no válidos.",
    "ko": "유효하지 않은 서비스 코드가 포함되어 있습니다."
  },
  "Service codes validated successfully.": {
    "es": "Se han validado los códigos de servicio.",
    "ko": "서비스 코드를 확인했습니다."
  },
  "Not Found": {
    "es": "No encontrado",
    "ko": "찾을 수 없음"
  },
  "Employee updated successfully": {
    "es": "Los datos del empleado se han actualizado correctamente.",
    "ko": "직원 정보가 수정되었습니다."
  },
  "Please select your current employer.": {
    "es": "Seleccione su empleador actual.",
    "ko": "현재 고용주를 선택해 주세요."
  },
  "Unauthorized": {
    "es": "No autorizado",
    "ko": "인증되지 않았습니다."
  },
  "Employee not found": {
    "es": "No se ha encontrado al empleado.",
    "ko": "직원을 찾을 수 없습니다."
  },
  "Employee is not associated with the specified client.": {
    "es": "El empleado no está vinculado al cliente indicado.",
    "ko": "직원이 지정한 클라이언트와 연결되어 있지 않습니다."
  },
  "Enrollment saved successfully.": {
    "es": "La inscripción se ha guardado correctamente.",
    "ko": "등록 정보가 저장되었습니다."
  },
  "Enrollment record not found": {
    "es": "No se ha encontrado el registro de inscripción.",
    "ko": "등록 기록을 찾을 수 없습니다."
  },
  "This enrollment is already associated with a different client.": {
    "es": "Esta inscripción ya está vinculada a otro cliente.",
    "ko": "이 등록은 이미 다른 클라이언트에 연결되어 있습니다."
  },
  "Enrollment updated successfully.": {
    "es": "La inscripción se ha actualizado correctamente.",
    "ko": "등록 정보가 수정되었습니다."
  },
  "Signature saved successfully.": {
    "es": "La firma se ha guardado correctamente.",
    "ko": "서명이 저장되었습니다."
  },
  "PDF generation failed. Please try again or contact support.": {
    "es": "No se pudo generar el PDF. Vuelva a intentarlo o contacte con soporte.",
    "ko": "PDF를 생성하지 못했습니다. 다시 시도하거나 지원팀에 문의해 주세요."
  },
  "Unknown document type": {
    "es": "Tipo de documento desconocido",
    "ko": "알 수 없는 서류 유형"
  },
  "Document uploaded and analysed.": {
    "es": "Documento subido y analizado.",
    "ko": "서류를 업로드하고 분석했습니다."
  },
  "Enrollment completely cleared": {
    "es": "La inscripción se ha borrado por completo.",
    "ko": "등록 정보가 모두 삭제되었습니다."
  },
  "The document was uploaded, but automatic field extraction was unavailable.": {
    "es": "Se ha subido el documento, pero la extracción automática de datos no estaba disponible.",
    "ko": "서류는 업로드되었지만 자동 정보 추출 기능을 사용할 수 없었습니다."
  },
  "The document could not be saved to file storage. Please try again or contact support.": {
    "es": "No se pudo guardar el documento en el almacenamiento. Vuelva a intentarlo o contacte con soporte.",
    "ko": "파일 저장소에 서류를 저장하지 못했습니다. 다시 시도하거나 지원팀에 문의해 주세요."
  },
  "Invalid or expired client session. Please sign in again.": {
    "es": "Sesión de cliente no válida o caducada. Vuelva a iniciar sesión.",
    "ko": "클라이언트 세션이 유효하지 않거나 만료되었습니다. 다시 로그인해 주세요."
  },
  "This participant account is not active.": {
    "es": "Esta cuenta de participante no está activa.",
    "ko": "이 참여자 계정은 활성화되지 않았습니다."
  },
  "Could not save the employee invitation.": {
    "es": "No se pudo guardar la invitación del empleado.",
    "ko": "직원 초대를 저장하지 못했습니다."
  },
  "The invitation was created, but the email could not be sent. Share the signup link with the employee manually.": {
    "es": "Se creó la invitación, pero no se pudo enviar el correo. Comparta el enlace de registro directamente con el empleado.",
    "ko": "초대는 생성되었지만 이메일을 보내지 못했습니다. 직원에게 가입 링크를 직접 전달해 주세요."
  },
  "Invitation sent successfully to": {
    "es": "Invitación enviada correctamente a",
    "ko": "초대 발송 완료, 수신자:"
  },
  "Invoice withdrawn. You can submit a corrected invoice.": {
    "es": "Factura retirada. Puede enviar una factura corregida.",
    "ko": "청구서가 철회되었습니다. 수정한 청구서를 제출할 수 있습니다."
  },
  "Invoice review saved.": {
    "es": "Se ha guardado la revisión de la factura.",
    "ko": "청구서 검토 결과가 저장되었습니다."
  },
  "Documents folder not found.": {
    "es": "No se ha encontrado la carpeta de documentos.",
    "ko": "서류 폴더를 찾을 수 없습니다."
  },
  "Failed to fetch employee enrollment documents.": {
    "es": "No se pudieron obtener los documentos de inscripción del empleado.",
    "ko": "직원 등록 서류를 불러오지 못했습니다."
  },
  "Employee not found with that name.": {
    "es": "No se ha encontrado ningún empleado con ese nombre.",
    "ko": "해당 이름의 직원을 찾을 수 없습니다."
  },
  "This employee is already connected to your account.": {
    "es": "Este empleado ya está vinculado a su cuenta.",
    "ko": "이 직원은 이미 회원님의 계정에 연결되어 있습니다."
  },
  "Employee hired successfully": {
    "es": "Empleado contratado correctamente",
    "ko": "직원이 채용되었습니다."
  },
  "data_fetched": {
    "es": "Datos obtenidos",
    "ko": "데이터를 불러왔습니다."
  },
  "Employee terminated successfully.": {
    "es": "Se ha finalizado la relación laboral del empleado.",
    "ko": "직원의 고용 관계가 종료되었습니다."
  },
  "The vendor directory is private. Add a vendor using their registered email address.": {
    "es": "El directorio de proveedores es privado. Añada un proveedor mediante su correo electrónico registrado.",
    "ko": "공급업체 명부는 비공개입니다. 가입한 이메일 주소로 공급업체를 추가하세요."
  },
  "Invalid login token.": {
    "es": "Token de acceso no válido.",
    "ko": "로그인 토큰이 유효하지 않습니다."
  },
  "Client account not found.": {
    "es": "No se ha encontrado la cuenta del cliente.",
    "ko": "클라이언트 계정을 찾을 수 없습니다."
  },
  "Please enter the vendor email address.": {
    "es": "Introduzca el correo electrónico del proveedor.",
    "ko": "공급업체의 이메일 주소를 입력해 주세요."
  },
  "No registered vendor was found. Please verify the email address or use Invite Vendor.": {
    "es": "No se ha encontrado ningún proveedor registrado. Compruebe el correo electrónico o utilice Invitar proveedor.",
    "ko": "가입된 공급업체를 찾을 수 없습니다. 이메일을 확인하거나 공급업체 초대를 이용하세요."
  },
  "This vendor is already connected to your account.": {
    "es": "Este proveedor ya está vinculado a su cuenta.",
    "ko": "이 공급업체는 이미 회원님의 계정에 연결되어 있습니다."
  },
  "Vendor connection reactivated successfully.": {
    "es": "Se ha reactivado la relación con el proveedor.",
    "ko": "공급업체 연결이 다시 활성화되었습니다."
  },
  "Vendor added successfully.": {
    "es": "Proveedor añadido correctamente",
    "ko": "공급업체가 추가되었습니다."
  },
  "Client not found.": {
    "es": "No se ha encontrado al cliente.",
    "ko": "클라이언트를 찾을 수 없습니다."
  },
  "Enrollment not found.": {
    "es": "No se ha encontrado la inscripción.",
    "ko": "등록 정보를 찾을 수 없습니다."
  },
  "Enrollment terminated successfully.": {
    "es": "Se ha finalizado la inscripción.",
    "ko": "등록 관계가 종료되었습니다."
  },
  "Invalid token": {
    "es": "Token no válido",
    "ko": "유효하지 않은 토큰"
  },
  "Invalid or expired token": {
    "es": "Token no válido o caducado",
    "ko": "유효하지 않거나 만료된 토큰"
  },
  "Forbidden": {
    "es": "Acceso denegado",
    "ko": "접근 권한이 없습니다."
  },
  "File not found": {
    "es": "Archivo no encontrado",
    "ko": "파일을 찾을 수 없습니다."
  },
  "Use the new-device email verification form.": {
    "es": "Utilice el formulario de verificación por correo para dispositivos nuevos.",
    "ko": "새 기기 이메일 인증 양식을 이용하세요."
  },
  "Please sign in again before changing your password.": {
    "es": "Vuelva a iniciar sesión antes de cambiar la contraseña.",
    "ko": "비밀번호를 변경하려면 다시 로그인해 주세요."
  },
  "payables created successfully": {
    "es": "Cuenta por pagar creada correctamente",
    "ko": "지급 예정 내역이 생성되었습니다."
  },
  "payroll created successfully": {
    "es": "Registro de nómina creado correctamente",
    "ko": "급여 기록이 생성되었습니다."
  },
  "Purchase request created successfully.": {
    "es": "Solicitud de compra creada correctamente.",
    "ko": "구매 요청이 생성되었습니다."
  },
  "Purchase request not found.": {
    "es": "No se ha encontrado la solicitud de compra.",
    "ko": "구매 요청을 찾을 수 없습니다."
  },
  "Approved purchase requests cannot be edited.": {
    "es": "Las solicitudes de compra aprobadas no se pueden editar.",
    "ko": "승인된 구매 요청은 수정할 수 없습니다."
  },
  "Purchase request updated and resubmitted for review.": {
    "es": "La solicitud de compra se ha actualizado y enviado de nuevo para revisión.",
    "ko": "구매 요청을 수정하여 다시 검토 요청했습니다."
  },
  "Approved purchase requests cannot be deleted.": {
    "es": "Las solicitudes de compra aprobadas no se pueden eliminar.",
    "ko": "승인된 구매 요청은 삭제할 수 없습니다."
  },
  "No active spending plan is available for this participant.": {
    "es": "No hay un plan de gastos activo para este participante.",
    "ko": "이 참여자에게 활성 지출 계획이 없습니다."
  },
  "The selected service code does not belong to the current spending plan.": {
    "es": "El código de servicio seleccionado no pertenece al plan de gastos actual.",
    "ko": "선택한 서비스 코드가 현재 지출 계획에 포함되어 있지 않습니다."
  },
  "Fetch successful": {
    "es": "Datos obtenidos correctamente",
    "ko": "데이터를 불러왔습니다."
  },
  "File uploaded successfully": {
    "es": "Archivo subido correctamente",
    "ko": "파일이 업로드되었습니다."
  },
  "Authenticated participant was not found.": {
    "es": "No se ha encontrado al participante autenticado.",
    "ko": "인증된 참여자를 찾을 수 없습니다."
  },
  "No active spending plan is available. Past years are visible to administrators only.": {
    "es": "No hay un plan de gastos activo. Solo los administradores pueden ver los años anteriores.",
    "ko": "활성 지출 계획이 없습니다. 이전 연차는 관리자만 볼 수 있습니다."
  },
  "Spending plan uploaded successfully": {
    "es": "Plan de gastos subido correctamente",
    "ko": "지출 계획이 업로드되었습니다."
  },
  "Timesheet not found.": {
    "es": "No se ha encontrado la hoja de horas.",
    "ko": "근무 시간표를 찾을 수 없습니다."
  },
  "You cannot edit an active shift. Please clock out first.": {
    "es": "No puede editar un turno activo. Registre primero la salida.",
    "ko": "진행 중인 근무는 수정할 수 없습니다. 먼저 퇴근을 기록해 주세요."
  },
  "Timesheet updated successfully.": {
    "es": "La hoja de horas se ha actualizado correctamente.",
    "ko": "근무 시간표가 수정되었습니다."
  },
  "You cannot delete an active shift. Please clock out first.": {
    "es": "No puede eliminar un turno activo. Registre primero la salida.",
    "ko": "진행 중인 근무는 삭제할 수 없습니다. 먼저 퇴근을 기록해 주세요."
  },
  "Timesheet deleted successfully.": {
    "es": "La hoja de horas se ha eliminado correctamente.",
    "ko": "근무 시간표가 삭제되었습니다."
  },
  "Change log not found.": {
    "es": "No se ha encontrado el registro de cambios.",
    "ko": "변경 기록을 찾을 수 없습니다."
  },
  "This record was removed by an administrator and cannot be restored here.": {
    "es": "Un administrador eliminó este registro; no se puede restaurar aquí.",
    "ko": "관리자가 삭제한 기록이므로 이 화면에서 복원할 수 없습니다."
  },
  "This change has already been reverted.": {
    "es": "Este cambio ya se ha revertido.",
    "ko": "이미 되돌린 변경 사항입니다."
  },
  "Original timesheet payload is missing.": {
    "es": "Faltan los datos originales de la hoja de horas.",
    "ko": "근무 시간표의 변경 전 데이터가 없습니다."
  },
  "Change reverted successfully.": {
    "es": "El cambio se ha revertido correctamente.",
    "ko": "변경 사항을 되돌렸습니다."
  },
  "Timesheet has no employee assigned.": {
    "es": "Esta hoja de horas no tiene ningún empleado asignado.",
    "ko": "이 근무 시간표에 지정된 직원이 없습니다."
  },
  "Paid timesheets cannot be edited.": {
    "es": "Las hojas de horas pagadas no se pueden editar.",
    "ko": "지급이 완료된 근무 시간표는 수정할 수 없습니다."
  },
  "A pending edit request already exists for this timesheet.": {
    "es": "Ya existe una solicitud de edición pendiente para esta hoja de horas.",
    "ko": "이 근무 시간표에 대한 수정 요청이 이미 대기 중입니다."
  },
  "Edit request submitted successfully.": {
    "es": "Solicitud de edición enviada correctamente.",
    "ko": "수정 요청이 제출되었습니다."
  },
  "Only pending requests can be approved.": {
    "es": "Solo se pueden aprobar las solicitudes pendientes.",
    "ko": "대기 중인 요청만 승인할 수 있습니다."
  },
  "Linked timesheet not found.": {
    "es": "No se ha encontrado la hoja de horas vinculada.",
    "ko": "연결된 근무 시간표를 찾을 수 없습니다."
  },
  "Timesheet edit request approved.": {
    "es": "Se ha aprobado la solicitud de edición de la hoja de horas.",
    "ko": "근무 시간표 수정 요청이 승인되었습니다."
  },
  "Only pending requests can be rejected.": {
    "es": "Solo se pueden rechazar las solicitudes pendientes.",
    "ko": "대기 중인 요청만 거절할 수 있습니다."
  },
  "Timesheet edit request rejected.": {
    "es": "Se ha rechazado la solicitud de edición de la hoja de horas.",
    "ko": "근무 시간표 수정 요청이 거절되었습니다."
  },
  "Bank account details updated successfully.": {
    "es": "Los datos de la cuenta bancaria se han actualizado correctamente.",
    "ko": "은행 계좌 정보가 수정되었습니다."
  },
  "Bank account details saved successfully.": {
    "es": "Los datos de la cuenta bancaria se han guardado correctamente.",
    "ko": "은행 계좌 정보가 저장되었습니다."
  },
  "No Account": {
    "es": "Sin cuenta",
    "ko": "계정 없음"
  },
  "Client enrolled successfully!": {
    "es": "¡Cliente inscrito correctamente!",
    "ko": "클라이언트가 등록되었습니다!"
  },
  "Vendor not found": {
    "es": "No se ha encontrado al proveedor.",
    "ko": "공급업체를 찾을 수 없습니다."
  },
  "Payroll & Rates saved successfully": {
    "es": "La nómina y las tarifas se han guardado correctamente.",
    "ko": "급여 및 요율 정보가 저장되었습니다."
  },
  "Signature not found": {
    "es": "No se ha encontrado la firma.",
    "ko": "서명을 찾을 수 없습니다."
  },
  "Unable to create vendor account. Please contact Blessed FMS.": {
    "es": "No se pudo crear la cuenta del proveedor. Contacte con Blessed FMS.",
    "ko": "공급업체 계정을 생성하지 못했습니다. Blessed FMS에 문의하세요."
  },
  "Account was created successfully. Your account is pending activation.": {
    "es": "La cuenta se ha creado correctamente y está pendiente de activación.",
    "ko": "계정이 생성되었으며 활성화를 기다리고 있습니다."
  },
  "You are not enrolled with this client.": {
    "es": "No está inscrito con este cliente.",
    "ko": "이 클라이언트와 등록 관계가 없습니다."
  },
  "invoice was created successfully": {
    "es": "Factura creada correctamente",
    "ko": "청구서가 생성되었습니다."
  },
  "Please sign in again to access your invoices.": {
    "es": "Vuelva a iniciar sesión para acceder a sus facturas.",
    "ko": "청구서를 확인하려면 다시 로그인해 주세요."
  },
  "no data found": {
    "es": "No se han encontrado datos.",
    "ko": "데이터가 없습니다."
  },
  "Invoice submitted successfully.": {
    "es": "Factura enviada correctamente.",
    "ko": "청구서가 제출되었습니다."
  },
  "Invoice client email not found.": {
    "es": "No se ha encontrado el correo del cliente de la factura.",
    "ko": "청구서에 해당하는 클라이언트의 이메일을 찾을 수 없습니다."
  },
  "Not authenticated. Please sign in again.": {
    "es": "No está autenticado. Vuelva a iniciar sesión.",
    "ko": "인증되지 않았습니다. 다시 로그인해 주세요."
  },
  "Invalid session. Please sign out and sign in again.": {
    "es": "Sesión no válida. Cierre la sesión y vuelva a iniciarla.",
    "ko": "세션이 유효하지 않습니다. 로그아웃한 후 다시 로그인해 주세요."
  },
  "Could not save vendor invitation. If this continues, ask support to run database migrations for the vendor_invitations table.": {
    "es": "No se pudo guardar la invitación del proveedor. Si el problema continúa, pida a soporte que ejecute las migraciones de la tabla vendor_invitations.",
    "ko": "공급업체 초대를 저장하지 못했습니다. 문제가 계속되면 지원팀에 vendor_invitations 테이블 마이그레이션 실행을 요청하세요."
  },
  "Invitation was created, but the email could not be sent. Copy the link below and send it to": {
    "es": "Se creó la invitación, pero no se pudo enviar el correo. Copie el enlace siguiente y envíelo a",
    "ko": "초대는 생성되었지만 이메일을 보내지 못했습니다. 아래 링크를 복사하여 직접 전달해 주세요. 수신자:"
  },
  "Vendor invitation sent successfully to": {
    "es": "Invitación de proveedor enviada correctamente a",
    "ko": "공급업체 초대 발송 완료, 수신자:"
  },
  "This vendor invitation link is invalid or has already been used.": {
    "es": "Este enlace de invitación de proveedor no es válido o ya se ha utilizado.",
    "ko": "이 공급업체 초대 링크는 유효하지 않거나 이미 사용되었습니다."
  },
  "Please sign in again before editing invoices.": {
    "es": "Vuelva a iniciar sesión antes de editar facturas.",
    "ko": "청구서를 수정하려면 다시 로그인해 주세요."
  },
  "This invoice already has an edit awaiting admin review.": {
    "es": "Esta factura ya tiene una edición pendiente de revisión del administrador.",
    "ko": "이 청구서에는 이미 관리자 검토를 기다리는 수정 사항이 있습니다."
  },
  "Please select one of your enrolled clients.": {
    "es": "Seleccione uno de sus clientes inscritos.",
    "ko": "등록 관계가 있는 클라이언트 중에서 선택해 주세요."
  },
  "Edit submitted for admin review. The current invoice remains unchanged until approval.": {
    "es": "Edición enviada al administrador para revisión. La factura actual se mantendrá hasta que se aprueben los cambios.",
    "ko": "관리자에게 수정 검토를 요청했습니다. 승인될 때까지 현재 청구서가 유지됩니다."
  },
  "Download error:": {
    "es": "Error de descarga",
    "ko": "다운로드 오류"
  },
  "Download failed:": {
    "es": "Error de descarga",
    "ko": "다운로드 실패"
  },
  "Preview failed:": {
    "es": "Error de vista previa",
    "ko": "미리보기 실패"
  },
  "Saved information is filled into your own copy when available. Review missing answers before signing. Preparing a copy does not submit it.": {
    "es": "Cuando hay datos guardados disponibles, se incluyen en su copia personal. Revise las respuestas pendientes antes de firmar. Preparar una copia no equivale a enviarla.",
    "ko": "저장된 정보가 있으면 본인용 사본에 자동으로 입력됩니다. 서명하기 전에 비어 있는 항목을 확인해 주세요. 사본을 만드는 것만으로 서류가 제출되지는 않습니다."
  },
  "Autofill available": {
    "es": "Autocompletado disponible",
    "ko": "자동입력 가능"
  },
  "View filled copy": {
    "es": "Ver copia con datos",
    "ko": "자동입력 사본 보기"
  },
  "Download filled copy": {
    "es": "Descargar copia con datos",
    "ko": "자동입력 사본 다운로드"
  },
  "Preparing your copy...": {
    "es": "Preparando su copia...",
    "ko": "사본을 준비하는 중..."
  },
  "Original copy": {
    "es": "Copia del original",
    "ko": "원본 양식"
  },
  "Prefilled draft — review before signing": {
    "es": "Borrador con datos: revíselo antes de firmar",
    "ko": "자동입력된 초안 — 서명 전 검토해 주세요"
  },
  "Review all pages and complete any missing answers. Your saved portal signature is not applied to this draft.": {
    "es": "Revise todas las páginas y complete las respuestas pendientes. La firma guardada en el portal no se aplica a este borrador.",
    "ko": "모든 페이지를 검토하고 비어 있는 항목을 작성해 주세요. 포털에 저장된 서명은 이 초안에 적용되지 않습니다."
  },
  "On a phone, use Download copy if the preview does not appear.": {
    "es": "Si no aparece la vista previa en su teléfono, use Descargar copia.",
    "ko": "휴대폰에서 미리보기가 표시되지 않으면 ‘사본 다운로드’를 이용해 주세요."
  },
  "A preview is not available for this file type. Use Download copy to open it on your device.": {
    "es": "Este tipo de archivo no tiene vista previa. Use Descargar copia para abrirlo en su dispositivo.",
    "ko": "이 파일 형식은 미리보기를 지원하지 않습니다. ‘사본 다운로드’를 눌러 기기에서 열어 주세요."
  },
  "Download copy": {
    "es": "Descargar copia",
    "ko": "사본 다운로드"
  },
  "Dismiss message": {
    "es": "Cerrar mensaje",
    "ko": "안내 닫기"
  },
  "This resource was changed or removed by Admin. Refresh the list and try again.": {
    "es": "El administrador ha modificado o eliminado este recurso. Actualice la lista e inténtelo de nuevo.",
    "ko": "관리자가 이 자료를 변경하거나 삭제했습니다. 목록을 새로고침한 뒤 다시 시도해 주세요."
  },
  "Your account changed. Please open the document again from the current account.": {
    "es": "La cuenta ha cambiado. Vuelva a abrir el documento desde la cuenta actual.",
    "ko": "사용 중인 계정이 변경되었습니다. 현재 계정에서 서류를 다시 열어 주세요."
  },
  "Please sign in again to access your documents.": {
    "es": "Vuelva a iniciar sesión para acceder a sus documentos.",
    "ko": "서류를 이용하려면 다시 로그인해 주세요."
  },
  "Could not load resources. Please retry.": {
    "es": "No se pudieron cargar los recursos. Vuelva a intentarlo.",
    "ko": "자료를 불러오지 못했습니다. 다시 시도해 주세요."
  },
  "Could not prepare this document. Please try again.": {
    "es": "No se pudo preparar este documento. Vuelva a intentarlo.",
    "ko": "서류를 준비하지 못했습니다. 다시 시도해 주세요."
  },
  "Could not confirm this document is current. Refresh and try again.": {
    "es": "No se pudo confirmar que el documento esté actualizado. Actualice la lista e inténtelo de nuevo.",
    "ko": "최신 서류인지 확인할 수 없습니다. 목록을 새로고침한 뒤 다시 시도해 주세요."
  },
  "Autofill is unavailable for this template. Use Blank original and contact Admin.": {
    "es": "Esta plantilla no permite el autocompletado. Use Original en blanco y comuníquese con el administrador.",
    "ko": "이 양식은 자동입력을 사용할 수 없습니다. ‘빈 원본’을 이용하고 관리자에게 문의해 주세요."
  },
  "This is an unsigned draft made from your saved information. Review missing fields, tax choices and authorizations before signing.": {
    "es": "Este borrador sin firmar se ha preparado con sus datos guardados. Revise los campos pendientes, las opciones fiscales y las autorizaciones antes de firmar.",
    "ko": "저장된 정보로 작성한 서명 전 초안입니다. 서명하기 전에 비어 있는 항목, 세금 관련 선택 사항과 위임 범위를 확인해 주세요."
  },
  "This resource is available as an original copy only.": {
    "es": "Este recurso solo está disponible como copia del original.",
    "ko": "이 자료는 원본 사본으로만 제공됩니다."
  },
  "This Admin template needs an autofill mapping review. You can still open the original.": {
    "es": "El administrador debe revisar la correspondencia de los campos de esta plantilla para el autocompletado. Mientras tanto, puede abrir el original.",
    "ko": "관리자가 이 양식의 자동입력 필드 연결을 검토해야 합니다. 원본은 계속 열 수 있습니다."
  },
  "The source document is temporarily unavailable. Please retry.": {
    "es": "El documento original no está disponible temporalmente. Vuelva a intentarlo.",
    "ko": "현재 원본 서류를 불러올 수 없습니다. 다시 시도해 주세요."
  },
  "This resource changed. Refresh the list and try again.": {
    "es": "Este recurso ha cambiado. Actualice la lista e inténtelo de nuevo.",
    "ko": "자료가 변경되었습니다. 목록을 새로고침한 뒤 다시 시도해 주세요."
  },
  "This resource was removed by Admin.": {
    "es": "El administrador ha eliminado este recurso.",
    "ko": "관리자가 이 자료를 삭제했습니다."
  },
  "The document could not be prepared. Please retry.": {
    "es": "No se pudo preparar el documento. Vuelva a intentarlo.",
    "ko": "서류를 준비하지 못했습니다. 다시 시도해 주세요."
  },
  "EIN Number (Optional)": {
    "es": "Número EIN (opcional)",
    "ko": "EIN 번호(선택 사항)"
  },
  "If the IRS has not issued an EIN yet, leave this blank. You can save enrollment and prepare SS-4 without it. Never use an SSN as an EIN.": {
    "es": "Si el IRS aún no ha emitido un EIN, deje este campo en blanco. Puede guardar la inscripción y preparar el formulario SS-4 sin este número. Nunca utilice un SSN como EIN.",
    "ko": "IRS에서 EIN을 아직 발급하지 않았다면 비워 두세요. EIN 없이도 등록 정보를 저장하고 SS-4를 준비할 수 있습니다. SSN을 EIN 대신 입력하지 마세요."
  },
  "Use the client's saved address and phone as the SS-4 mailing contact.": {
    "es": "Utilizar la dirección y el teléfono guardados del cliente como datos de contacto postal en el formulario SS-4.",
    "ko": "클라이언트의 저장된 주소와 전화번호를 SS-4 우편 연락처로 사용합니다."
  },
  "Select only if this is the correct mailing contact for the named EIN applicant. This does not assign a responsible party or change other tax forms.": {
    "es": "Seleccione esta opción solo si estos datos de contacto postal corresponden al solicitante del EIN indicado. Esto no designa a una persona responsable ni modifica otros formularios fiscales.",
    "ko": "기재된 EIN 신청자의 올바른 우편 연락처인 경우에만 선택하세요. 이 선택은 세무상 책임자를 지정하거나 다른 세금 양식을 변경하지 않습니다."
  },
  "SS-4 applicant name": {
    "es": "Nombre del solicitante en el formulario SS-4",
    "ko": "SS-4 신청자 이름"
  },
  "Signer full name": {
    "es": "Nombre completo del firmante",
    "ko": "서명자 전체 이름"
  },
  "Use the SS-4 applicant name from Personal Information. A matching saved signature is automatically included in SS-4 copies.": {
    "es": "Utilice el nombre del solicitante del SS-4 indicado en Información personal. La firma guardada que coincida con ese nombre se incluirá automáticamente en las copias del SS-4.",
    "ko": "개인정보에 등록된 SS-4 신청자 이름을 사용하세요. 이름이 일치하는 저장된 서명은 SS-4 사본에 자동으로 들어갑니다."
  },
  "Signature saved. A matching saved signature is included in SS-4 copies.": {
    "es": "Firma guardada. La firma que coincida con el solicitante se incluirá en las copias del SS-4.",
    "ko": "서명을 저장했습니다. 신청자 이름과 일치하는 서명은 SS-4 사본에 들어갑니다."
  },
  "Prefilled copy — saved signature included": {
    "es": "Copia precompletada: incluye la firma guardada",
    "ko": "자동입력 사본 — 저장된 서명 포함"
  },
  "Your saved applicant signature is included. Review every page, complete missing answers and confirm the signing date before using this copy.": {
    "es": "Se ha incluido la firma guardada del solicitante. Antes de utilizar esta copia, revise todas las páginas, complete los datos que falten y confirme la fecha de firma.",
    "ko": "신청자의 저장된 서명이 포함되어 있습니다. 사본을 사용하기 전에 모든 페이지를 검토하고, 비어 있는 항목과 서명 날짜를 확인하세요."
  },
  "Your matching saved portal signature will be included in the SS-4 copy. Review all answers and the signing date before using it.": {
    "es": "La firma guardada en el portal que coincida con el solicitante se incluirá en la copia del SS-4. Revise todas las respuestas y la fecha de firma antes de utilizarla.",
    "ko": "신청자 이름과 일치하는 포털 서명이 SS-4 사본에 들어갑니다. 사용하기 전에 작성 내용과 서명 날짜를 확인하세요."
  },
  "Complete the applicant name in Personal Information, then save that person's signature in Signature to include it in SS-4.": {
    "es": "Complete el nombre del solicitante en Información personal y guarde su firma en Firma para incluirla en el SS-4.",
    "ko": "개인정보에 신청자 이름을 입력하고, ‘서명’에서 해당 신청자의 서명을 저장하면 SS-4에 반영됩니다."
  },
  "The applicant or saved signature changed. Open the document again.": {
    "es": "El solicitante o la firma guardada ha cambiado. Vuelva a abrir el documento.",
    "ko": "신청자 정보 또는 저장된 서명이 변경되었습니다. 서류를 다시 열어 주세요."
  },
  "Use the SS-4 applicant name from Personal Information when saving the signature.": {
    "es": "Al guardar la firma, utilice el nombre del solicitante del SS-4 que figura en Información personal.",
    "ko": "서명을 저장할 때 개인정보에 등록된 SS-4 신청자 이름을 사용하세요."
  },
  "Please draw a visible signature and try again.": {
    "es": "Dibuje una firma visible e inténtelo de nuevo.",
    "ko": "서명이 보이도록 그린 뒤 다시 시도해 주세요."
  },
  "Saved signature image unavailable. Please save it again.": {
    "es": "La imagen de la firma guardada no está disponible. Vuelva a guardar la firma.",
    "ko": "저장된 서명 이미지를 불러올 수 없습니다. 서명을 다시 저장해 주세요."
  },
  "Use the employer or taxpayer name from Personal Information. A matching saved signature is included only in supported forms after their signer role is checked.": {
    "ko": "개인정보에 저장된 고용주 또는 납세자의 이름을 입력하세요. 저장된 서명은 서명자의 역할을 확인한 뒤 지원되는 양식에만 자동으로 들어갑니다.",
    "es": "Use el nombre del empleador o contribuyente guardado en Información personal. La firma guardada solo se incluye en los formularios compatibles después de comprobar la función del firmante."
  },
  "Signature saved. Matching signatures are included only in supported forms after the signer role is checked.": {
    "ko": "서명이 저장되었습니다. 서명자의 역할을 확인한 뒤 이름이 일치하는 서명이 지원되는 양식에만 들어갑니다.",
    "es": "Firma guardada. Las firmas coincidentes solo se incluyen en formularios compatibles después de comprobar la función del firmante."
  },
  "Your matching saved employer or taxpayer signature will be included only in this form's mapped signature box. Review all answers, authorizations and the signing date before using it.": {
    "ko": "이름이 일치하는 고용주 또는 납세자의 저장된 서명은 이 양식의 지정된 서명란에만 들어갑니다. 사용 전 모든 답변, 권한 부여 내용, 서명 날짜를 확인하세요.",
    "es": "La firma guardada del empleador o contribuyente cuyo nombre coincida solo se incluirá en la casilla de firma asignada de este formulario. Revise todas las respuestas, autorizaciones y la fecha de firma antes de usarlo."
  },
  "Confirm the employer or taxpayer and their role in Personal Information, then save that person's matching signature in Signature.": {
    "ko": "개인정보에서 고용주 또는 납세자와 그 역할을 확인한 다음, 서명 탭에서 해당 이름과 일치하는 서명을 저장하세요.",
    "es": "Confirme al empleador o contribuyente y su función en Información personal; después guarde su firma con el nombre correspondiente en Firma."
  },
  "Only the employer/payer signature is included. The agent must complete and sign Part 3 separately.": {
    "ko": "고용주/지급자의 서명만 들어갑니다. 대리인은 Part 3를 별도로 작성하고 서명해야 합니다.",
    "es": "Solo se incluye la firma del empleador o pagador. El agente debe completar y firmar la Parte 3 por separado."
  },
  "Form 8821 needs completed tax matters and periods before signing. Electronic signatures may be submitted to the IRS online only; mail or fax requires a handwritten signature. This copy stays unsigned until the filing method and completed authorization are confirmed.": {
    "ko": "Form 8821은 세금 관련 사항과 대상 기간을 작성한 후 서명해야 합니다. 전자서명은 IRS 온라인 제출에만 사용할 수 있으며, 우편·팩스 제출은 직접 손으로 서명해야 합니다. 제출 방식과 권한 부여 내용의 작성 완료가 확인되기 전에는 이 사본에 서명을 넣지 않습니다.",
    "es": "Antes de firmar el Formulario 8821, deben completarse los asuntos tributarios y los períodos. Las firmas electrónicas solo pueden presentarse al IRS en línea; por correo o fax se requiere una firma manuscrita. Esta copia permanecerá sin firmar hasta confirmar el método de presentación y que la autorización esté completa."
  },
  "Your matching saved signature is included in the employer or taxpayer signature box. Review every page, authorizations, missing answers and the signing date before using this copy.": {
    "ko": "이름이 일치하는 저장된 서명이 고용주 또는 납세자 서명란에 들어갔습니다. 사용 전 모든 페이지, 권한 부여 내용, 미입력 답변, 서명 날짜를 확인하세요.",
    "es": "Su firma guardada cuyo nombre coincide se ha incluido en la casilla del empleador o contribuyente. Revise todas las páginas, las autorizaciones, las respuestas pendientes y la fecha de firma antes de utilizar esta copia."
  },
  "Miles traveled": {
    "es": "Millas recorridas",
    "ko": "이동 거리(마일)"
  },
  "Per mile": {
    "es": "Por milla",
    "ko": "마일당"
  },
  "mile": {
    "es": "milla",
    "ko": "마일"
  },
  "Quantity": {
    "es": "Cantidad",
    "ko": "수량"
  },
  "Quantity / Rate": {
    "es": "Cantidad / Tarifa",
    "ko": "수량 / 단가"
  },
  "{0} miles": {
    "es": "{0} millas",
    "ko": "{0}마일"
  },
  "Agreed rate ($/mile)": {
    "es": "Tarifa acordada ($/milla)",
    "ko": "합의한 마일당 단가($/마일)"
  },
  "Code 338 reimburses transportation mileage: miles traveled × agreed rate per mile. Do not enter hours or days.": {
    "es": "El código 338 reembolsa el transporte según las millas recorridas: millas × tarifa acordada por milla. No ingrese horas ni días.",
    "ko": "코드 338은 교통 이동 거리를 기준으로 환급합니다. 이동한 마일 수 × 합의한 마일당 단가로 계산하며, 시간이나 일수는 입력하지 않습니다."
  },
  "Service code 338 must be submitted per mile. Enter miles traveled and the agreed rate per mile.": {
    "es": "El código de servicio 338 debe facturarse por milla. Ingrese las millas recorridas y la tarifa acordada por milla.",
    "ko": "서비스 코드 338은 마일 단위로 제출해야 합니다. 이동한 마일 수와 합의한 마일당 단가를 입력하세요."
  },
  "Per mile is available only for service code 338.": {
    "es": "La opción por milla solo está disponible para el código de servicio 338.",
    "ko": "마일 단위는 서비스 코드 338에만 사용할 수 있습니다."
  },
  "Confirm the described services, quantity and amount were provided as agreed. BFMS admin must still approve payment.": {
    "es": "Confirme que los servicios descritos, la cantidad y el importe corresponden a lo acordado. Admin de BFMS aún debe aprobar el pago.",
    "ko": "기재된 서비스, 수량 및 금액이 합의한 내용과 일치하는지 확인하세요. 지급을 위해서는 BFMS Admin의 승인도 필요합니다."
  }
};
